var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-developer-activity",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-developer-activity:not(.animated) .animable {opacity: 0;}svg#freepik_stories-developer-activity.animated #freepik--Floor--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn,1.5s Infinite  linear wind;animation-delay: 0s,1s;}svg#freepik_stories-developer-activity.animated #freepik--Shadows--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-developer-activity.animated #freepik--Plants--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-developer-activity.animated #freepik--Gears--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-developer-activity.animated #freepik--Device--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-developer-activity.animated #freepik--Windows--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-developer-activity.animated #freepik--Character--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-developer-activity.animated #freepik--speech-bubble--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite  linear wind;animation-delay: 0s,1s;}            @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 345.35px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-2",
    cx: 250,
    cy: 345.35,
    rx: 235.59,
    ry: 136.02,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "250px 345.35px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2",
    className: "animable",
    style: {
      transformOrigin: "257.585px 343.843px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-2",
    cx: 436.67,
    cy: 366.68,
    rx: 39.9,
    ry: 23.03,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "436.67px 366.68px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M200,462.3,39.1,369.42a.74.74,0,0,1,0-1.4l247-142.62a2.65,2.65,0,0,1,2.42,0l160.87,92.87a.74.74,0,0,1,0,1.4l-247,142.63A2.71,2.71,0,0,1,200,462.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "244.245px 343.843px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2",
    className: "animable",
    style: {
      transformOrigin: "44.0164px 323.973px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2",
    className: "animable",
    style: {
      transformOrigin: "44.0164px 323.973px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.94,335.88s.74-17.56-5.74-32.3-17-24.94-27.84-27.53S8,282.18,18.71,291s30.48,19.17,36,46.68Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "38.6015px 306.633px"
    },
    id: "elruf49bwntn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7unq2oh00zj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.94,335.88s.74-17.56-5.74-32.3-17-24.94-27.84-27.53S8,282.18,18.71,291s30.48,19.17,36,46.68Z",
    style: {
      opacity: 0.15,
      transformOrigin: "38.6015px 306.633px"
    },
    className: "animable",
    id: "elcrzy111lnu8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.41,330.89h.13a.6.6,0,0,0,.44-.72c-7.13-30.41-27.36-45.82-37.07-49.71a.58.58,0,0,0-.77.33.59.59,0,0,0,.33.77c9.5,3.82,29.33,18.94,36.35,48.88A.6.6,0,0,0,60.41,330.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "42.0464px 305.652px"
    },
    id: "el0yf9b7jio2x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6,362.83c1.64,5.32,5.66,8.22,11.12,9.28,3.47.67,9.05,0,12-2.17,4.08-3,5.46-5.2,6.31-8.15a49.53,49.53,0,0,0,1.76-12.06c.11-3-1.52-5.62-2.74-7.36A23.44,23.44,0,0,0,68.92,340c-.83-.88-1.77-1.65-2.65-2.48a9.5,9.5,0,0,1-2.79-4c-.68-2.2,0-4.58,0-6.89a10.59,10.59,0,0,0-8.08-10.06,48.88,48.88,0,0,0-6.92-1.22c-3.46-.32-7.2.69-10.58-.37s-6.31-2.78-9.77-3.44c-3.62-.7-7.64-.15-10.48,2.37a6.51,6.51,0,0,0-2.4,5.63c.37,2.31,2.35,4,4.24,5.4s3.92,2.91,4.54,5.18c1.25,4.56-4,9.14-2.54,13.64a7.35,7.35,0,0,0,4.1,4.09c1.49.71,3.09,1.12,4.65,1.68a20.77,20.77,0,0,0,2.31.42c2.26.26,4.66.78,6.37,2.43C41.58,355,41.49,359.26,42.6,362.83Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "44.5105px 341.809px"
    },
    id: "elbvmkr52ph6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.92,335.69a.51.51,0,0,0-.17-.21C43.49,322.56,28.25,317,23.16,316.17a.54.54,0,0,0-.61.44.52.52,0,0,0,.44.6c4.82.8,19,5.91,29,17.72a29.05,29.05,0,0,0-23,3.34.54.54,0,0,0-.11.74.53.53,0,0,0,.44.22.57.57,0,0,0,.3-.1,28.1,28.1,0,0,1,23.58-2.77c.4.13,1.05,1.4,1.3,1.75.48.68.94,1.36,1.38,2.06a44.7,44.7,0,0,1,2.4,4.34,45,45,0,0,1,1.95,4.77c.21.63,1,4.51,1.48,4.54a.63.63,0,0,0,.59-.5c.32-1.36-.77-3.53-1.22-4.8a43.3,43.3,0,0,0-2-4.77,47.2,47.2,0,0,0-2.37-4.23c-.43-.67-.87-1.32-1.32-2A12.33,12.33,0,0,1,53.92,335.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "42.4504px 334.992px"
    },
    id: "elzel4fjwn2m",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-2",
    className: "animable",
    style: {
      transformOrigin: "111.468px 81.5025px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-2",
    className: "animable",
    style: {
      transformOrigin: "111.468px 81.5025px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.62,42.11h0a.8.8,0,0,0-.87.08L169,43.38l-.4,1.08a2.08,2.08,0,0,0,.49,2,8.26,8.26,0,0,1,.82,1,1.22,1.22,0,0,0,1.68.37l4.2-2.76a.82.82,0,0,1,.85-.09Zm-6.46,15.4c-.59-3.39-2.75-5.09-5.56-4.86a8.23,8.23,0,0,1,.58,2c.93,5.39-2.49,13-7.62,17.06a10.4,10.4,0,0,1-5.38,2.41c1.68,3.61,5.94,4,10.37.47C162.68,70.54,166.09,62.9,165.16,57.51Zm.09-23h0a1.22,1.22,0,0,0-.33-.14l-3.16-.71a1.71,1.71,0,0,0-1.79.83l-3,5.67a2.55,2.55,0,0,1-.66.75h0a2.1,2.1,0,0,1-.5.34l.93,3.09a1.07,1.07,0,0,0,1.49.68,14.68,14.68,0,0,1,1.95-.63,3.28,3.28,0,0,0,1.12-.59A2.4,2.4,0,0,0,162,43l3-5.66a1.72,1.72,0,0,1,1.79-.83l3.17.71a1.05,1.05,0,0,1,.31.12Zm-8.9,54.84a.89.89,0,0,1-.3-.48L155,85.31a1.06,1.06,0,0,0-1.49-.68,14.22,14.22,0,0,1-2,.63,2.29,2.29,0,0,0-.61.26l.14.46a.89.89,0,0,0,.4.54h0Zm-6.06-52a.71.71,0,0,0-.35-.1.9.9,0,0,0-.58.23l-4.74,3.72a1.45,1.45,0,0,0-.18.17l-.13.14a3.6,3.6,0,0,0-.41.75c0,.06,0,.13-.06.18h0a2.44,2.44,0,0,0-.13.77l.29,4.5a3.57,3.57,0,0,1-.74,2.18c-.78.93-1.51,1.91-2.2,2.91a2.43,2.43,0,0,1-1,.81,1.66,1.66,0,0,1-.42.12.65.65,0,0,1-.2,0,1.22,1.22,0,0,1-.27,0l-3-.15H136a1,1,0,0,0-.24,0,1,1,0,0,0-.23,0h0a1.06,1.06,0,0,0-.25.09,2.2,2.2,0,0,0-.44.28,1.82,1.82,0,0,0-.49.62l-2.86,6.42a1.22,1.22,0,0,0,.48,1.54l3.38,1.95a1.53,1.53,0,0,1,.08.87,28.44,28.44,0,0,0-.53,3.06,3.86,3.86,0,0,1-1,2.08l0,0-4.15,3.82a.83.83,0,0,0-.2.22l0,0a1.56,1.56,0,0,0-.16.28,2.43,2.43,0,0,0-.32,1.53l.8,4.57a.94.94,0,0,0,.36.63l5,2.86a.89.89,0,0,1-.35-.61L134,79.45a2.21,2.21,0,0,1,0-.88,2.47,2.47,0,0,1,.66-1.2l4.14-3.81.05,0a3.91,3.91,0,0,0,1-2.08,26.16,26.16,0,0,1,.53-3.06,1.54,1.54,0,0,0-.85-1.7l-2.46-1a1.23,1.23,0,0,1-.64-1.63l2.86-6.41a1.86,1.86,0,0,1,.49-.63,1.9,1.9,0,0,1,1.26-.45l3,.15a2,2,0,0,0,.88-.18,2.34,2.34,0,0,0,1-.8c.69-1,1.43-2,2.2-2.91A3.5,3.5,0,0,0,149,50.6l-.28-4.5a2,2,0,0,1,.11-.78,2.53,2.53,0,0,1,.79-1.23l4.73-3.73a.82.82,0,0,1,.94-.13Zm-7.1,47.82a2.11,2.11,0,0,0-.5-2,7.36,7.36,0,0,1-.81-1,1.23,1.23,0,0,0-1.69-.38l-2.39,1.57-1.74,4.71a1.05,1.05,0,0,0,.42,1.29h0l5,2.88a1,1,0,0,1-.42-1.29Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "152.846px 62.9361px"
    },
    id: "eliobp6uuye4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elprgxnzilhv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.62,42.11h0a.8.8,0,0,0-.87.08L169,43.38l-.4,1.08a2.08,2.08,0,0,0,.49,2,8.26,8.26,0,0,1,.82,1,1.22,1.22,0,0,0,1.68.37l4.2-2.76a.82.82,0,0,1,.85-.09Zm-6.46,15.4c-.59-3.39-2.75-5.09-5.56-4.86a8.23,8.23,0,0,1,.58,2c.93,5.39-2.49,13-7.62,17.06a10.4,10.4,0,0,1-5.38,2.41c1.68,3.61,5.94,4,10.37.47C162.68,70.54,166.09,62.9,165.16,57.51Zm.09-23h0a1.22,1.22,0,0,0-.33-.14l-3.16-.71a1.71,1.71,0,0,0-1.79.83l-3,5.67a2.55,2.55,0,0,1-.66.75h0a2.1,2.1,0,0,1-.5.34l.93,3.09a1.07,1.07,0,0,0,1.49.68,14.68,14.68,0,0,1,1.95-.63,3.28,3.28,0,0,0,1.12-.59A2.4,2.4,0,0,0,162,43l3-5.66a1.72,1.72,0,0,1,1.79-.83l3.17.71a1.05,1.05,0,0,1,.31.12Zm-8.9,54.84a.89.89,0,0,1-.3-.48L155,85.31a1.06,1.06,0,0,0-1.49-.68,14.22,14.22,0,0,1-2,.63,2.29,2.29,0,0,0-.61.26l.14.46a.89.89,0,0,0,.4.54h0Zm-6.06-52a.71.71,0,0,0-.35-.1.9.9,0,0,0-.58.23l-4.74,3.72a1.45,1.45,0,0,0-.18.17l-.13.14a3.6,3.6,0,0,0-.41.75c0,.06,0,.13-.06.18h0a2.44,2.44,0,0,0-.13.77l.29,4.5a3.57,3.57,0,0,1-.74,2.18c-.78.93-1.51,1.91-2.2,2.91a2.43,2.43,0,0,1-1,.81,1.66,1.66,0,0,1-.42.12.65.65,0,0,1-.2,0,1.22,1.22,0,0,1-.27,0l-3-.15H136a1,1,0,0,0-.24,0,1,1,0,0,0-.23,0h0a1.06,1.06,0,0,0-.25.09,2.2,2.2,0,0,0-.44.28,1.82,1.82,0,0,0-.49.62l-2.86,6.42a1.22,1.22,0,0,0,.48,1.54l3.38,1.95a1.53,1.53,0,0,1,.08.87,28.44,28.44,0,0,0-.53,3.06,3.86,3.86,0,0,1-1,2.08l0,0-4.15,3.82a.83.83,0,0,0-.2.22l0,0a1.56,1.56,0,0,0-.16.28,2.43,2.43,0,0,0-.32,1.53l.8,4.57a.94.94,0,0,0,.36.63l5,2.86a.89.89,0,0,1-.35-.61L134,79.45a2.21,2.21,0,0,1,0-.88,2.47,2.47,0,0,1,.66-1.2l4.14-3.81.05,0a3.91,3.91,0,0,0,1-2.08,26.16,26.16,0,0,1,.53-3.06,1.54,1.54,0,0,0-.85-1.7l-2.46-1a1.23,1.23,0,0,1-.64-1.63l2.86-6.41a1.86,1.86,0,0,1,.49-.63,1.9,1.9,0,0,1,1.26-.45l3,.15a2,2,0,0,0,.88-.18,2.34,2.34,0,0,0,1-.8c.69-1,1.43-2,2.2-2.91A3.5,3.5,0,0,0,149,50.6l-.28-4.5a2,2,0,0,1,.11-.78,2.53,2.53,0,0,1,.79-1.23l4.73-3.73a.82.82,0,0,1,.94-.13Zm-7.1,47.82a2.11,2.11,0,0,0-.5-2,7.36,7.36,0,0,1-.81-1,1.23,1.23,0,0,0-1.69-.38l-2.39,1.57-1.74,4.71a1.05,1.05,0,0,0,.42,1.29h0l5,2.88a1,1,0,0,1-.42-1.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "152.846px 62.9361px"
    },
    className: "animable",
    id: "el5l9fjd1y1e9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "els1mazaz5oh8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.62,42.11h0a.8.8,0,0,0-.87.08L169,43.38l-.4,1.08a2.08,2.08,0,0,0,.49,2,8.26,8.26,0,0,1,.82,1,1.22,1.22,0,0,0,1.68.37l4.2-2.76a.82.82,0,0,1,.85-.09Zm-6.46,15.4c-.59-3.39-2.75-5.09-5.56-4.86a8.23,8.23,0,0,1,.58,2c.93,5.39-2.49,13-7.62,17.06a10.4,10.4,0,0,1-5.38,2.41c1.68,3.61,5.94,4,10.37.47C162.68,70.54,166.09,62.9,165.16,57.51Zm.09-23h0a1.22,1.22,0,0,0-.33-.14l-3.16-.71a1.71,1.71,0,0,0-1.79.83l-3,5.67a2.55,2.55,0,0,1-.66.75h0a2.1,2.1,0,0,1-.5.34l.93,3.09a1.07,1.07,0,0,0,1.49.68,14.68,14.68,0,0,1,1.95-.63,3.28,3.28,0,0,0,1.12-.59A2.4,2.4,0,0,0,162,43l3-5.66a1.72,1.72,0,0,1,1.79-.83l3.17.71a1.05,1.05,0,0,1,.31.12Zm-8.9,54.84a.89.89,0,0,1-.3-.48L155,85.31a1.06,1.06,0,0,0-1.49-.68,14.22,14.22,0,0,1-2,.63,2.29,2.29,0,0,0-.61.26l.14.46a.89.89,0,0,0,.4.54h0Zm-6.06-52a.71.71,0,0,0-.35-.1.9.9,0,0,0-.58.23l-4.74,3.72a1.45,1.45,0,0,0-.18.17l-.13.14a3.6,3.6,0,0,0-.41.75c0,.06,0,.13-.06.18h0a2.44,2.44,0,0,0-.13.77l.29,4.5a3.57,3.57,0,0,1-.74,2.18c-.78.93-1.51,1.91-2.2,2.91a2.43,2.43,0,0,1-1,.81,1.66,1.66,0,0,1-.42.12.65.65,0,0,1-.2,0,1.22,1.22,0,0,1-.27,0l-3-.15H136a1,1,0,0,0-.24,0,1,1,0,0,0-.23,0h0a1.06,1.06,0,0,0-.25.09,2.2,2.2,0,0,0-.44.28,1.82,1.82,0,0,0-.49.62l-2.86,6.42a1.22,1.22,0,0,0,.48,1.54l3.38,1.95a1.53,1.53,0,0,1,.08.87,28.44,28.44,0,0,0-.53,3.06,3.86,3.86,0,0,1-1,2.08l0,0-4.15,3.82a.83.83,0,0,0-.2.22l0,0a1.56,1.56,0,0,0-.16.28,2.43,2.43,0,0,0-.32,1.53l.8,4.57a.94.94,0,0,0,.36.63l5,2.86a.89.89,0,0,1-.35-.61L134,79.45a2.21,2.21,0,0,1,0-.88,2.47,2.47,0,0,1,.66-1.2l4.14-3.81.05,0a3.91,3.91,0,0,0,1-2.08,26.16,26.16,0,0,1,.53-3.06,1.54,1.54,0,0,0-.85-1.7l-2.46-1a1.23,1.23,0,0,1-.64-1.63l2.86-6.41a1.86,1.86,0,0,1,.49-.63,1.9,1.9,0,0,1,1.26-.45l3,.15a2,2,0,0,0,.88-.18,2.34,2.34,0,0,0,1-.8c.69-1,1.43-2,2.2-2.91A3.5,3.5,0,0,0,149,50.6l-.28-4.5a2,2,0,0,1,.11-.78,2.53,2.53,0,0,1,.79-1.23l4.73-3.73a.82.82,0,0,1,.94-.13Zm-7.1,47.82a2.11,2.11,0,0,0-.5-2,7.36,7.36,0,0,1-.81-1,1.23,1.23,0,0,0-1.69-.38l-2.39,1.57-1.74,4.71a1.05,1.05,0,0,0,.42,1.29h0l5,2.88a1,1,0,0,1-.42-1.29Z",
    style: {
      opacity: 0.05,
      transformOrigin: "152.846px 62.9361px"
    },
    className: "animable",
    id: "elv64kdbt2z0k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,73.56l-4.14,3.81a2.47,2.47,0,0,0-.66,1.2l-5-2.87a2.9,2.9,0,0,1,.25-.66,1.56,1.56,0,0,1,.16-.28l0,0a.83.83,0,0,1,.2-.22l4.15-3.82Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "133.91px 74.645px"
    },
    id: "elxmuknnwqu8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,56.49a2,2,0,0,1-.88.18l-3-.15a1.9,1.9,0,0,0-1.26.45l-5-2.87a2.2,2.2,0,0,1,.44-.28,1.06,1.06,0,0,1,.25-.09h0a1,1,0,0,1,.23,0,1,1,0,0,1,.24,0h.08l3,.15a1.22,1.22,0,0,0,.27,0l.2,0a2.67,2.67,0,0,0,.4-.13h0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "139.93px 55.3464px"
    },
    id: "el63juq6akabm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.59,45a.78.78,0,0,0-.85.1l-4.2,2.76a1.22,1.22,0,0,1-1.68-.39,8.91,8.91,0,0,0-.82-1,2.08,2.08,0,0,1-.49-2l.4-1.06,1.8-1.19a.8.8,0,0,1,.87-.08h0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "172.53px 45.0459px"
    },
    id: "elwyju1ue4w7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.22,37.36a1.05,1.05,0,0,0-.31-.12l-3.17-.71a1.72,1.72,0,0,0-1.79.83L162,43a2.4,2.4,0,0,1-.67.77l-5-2.89a2.55,2.55,0,0,0,.66-.75l3-5.67a1.71,1.71,0,0,1,1.79-.83l3.16.71a1.22,1.22,0,0,1,.33.14h0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "163.275px 38.6861px"
    },
    id: "elti1x8vzu3x9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.28,40.23a.82.82,0,0,0-.94.13l-4.73,3.73a2.53,2.53,0,0,0-.79,1.23l-5-2.87c0-.05,0-.12.06-.18a3.6,3.6,0,0,1,.41-.75l.13-.14a1.45,1.45,0,0,1,.18-.17l4.74-3.72a.9.9,0,0,1,.58-.23.71.71,0,0,1,.35.1Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "149.55px 41.29px"
    },
    id: "eljzgo79b6cmh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq0avst58sl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.81,73.56l-4.14,3.81a2.47,2.47,0,0,0-.66,1.2l-5-2.87a2.9,2.9,0,0,1,.25-.66,1.56,1.56,0,0,1,.16-.28l0,0a.83.83,0,0,1,.2-.22l4.15-3.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "133.91px 74.645px"
    },
    className: "animable",
    id: "elf0bkpslj704"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzop78ong6ys"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145,56.49a2,2,0,0,1-.88.18l-3-.15a1.9,1.9,0,0,0-1.26.45l-5-2.87a2.2,2.2,0,0,1,.44-.28,1.06,1.06,0,0,1,.25-.09h0a1,1,0,0,1,.23,0,1,1,0,0,1,.24,0h.08l3,.15a1.22,1.22,0,0,0,.27,0l.2,0a2.67,2.67,0,0,0,.4-.13h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "139.93px 55.3464px"
    },
    className: "animable",
    id: "elhmkmxjk4g0e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elh9j9rkg62jw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.59,45a.78.78,0,0,0-.85.1l-4.2,2.76a1.22,1.22,0,0,1-1.68-.39,8.91,8.91,0,0,0-.82-1,2.08,2.08,0,0,1-.49-2l.4-1.06,1.8-1.19a.8.8,0,0,1,.87-.08h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "172.53px 45.0459px"
    },
    className: "animable",
    id: "elfpwjhp9w1p"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz0oi2k53bmb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.22,37.36a1.05,1.05,0,0,0-.31-.12l-3.17-.71a1.72,1.72,0,0,0-1.79.83L162,43a2.4,2.4,0,0,1-.67.77l-5-2.89a2.55,2.55,0,0,0,.66-.75l3-5.67a1.71,1.71,0,0,1,1.79-.83l3.16.71a1.22,1.22,0,0,1,.33.14h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "163.275px 38.6861px"
    },
    className: "animable",
    id: "el8v66dlmmn6j"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2qp9dz18ozr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.28,40.23a.82.82,0,0,0-.94.13l-4.73,3.73a2.53,2.53,0,0,0-.79,1.23l-5-2.87c0-.05,0-.12.06-.18a3.6,3.6,0,0,1,.41-.75l.13-.14a1.45,1.45,0,0,1,.18-.17l4.74-3.72a.9.9,0,0,1,.58-.23.71.71,0,0,1,.35.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "149.55px 41.29px"
    },
    className: "animable",
    id: "el36se1m2iam7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.77,50.19,177,45.62a.75.75,0,0,0-1.25-.54l-4.19,2.76a1.22,1.22,0,0,1-1.68-.38,8.2,8.2,0,0,0-.82-1,2.07,2.07,0,0,1-.49-2l2.14-5.79a1,1,0,0,0-.78-1.43l-3.16-.71a1.7,1.7,0,0,0-1.79.83L162,43a3.12,3.12,0,0,1-1.79,1.35,15.83,15.83,0,0,0-1.95.64,1.07,1.07,0,0,1-1.49-.68l-1.07-3.54a.8.8,0,0,0-1.34-.43l-4.73,3.73a2.61,2.61,0,0,0-.9,2l.28,4.5a3.57,3.57,0,0,1-.74,2.18c-.77.93-1.51,1.9-2.2,2.91a2.43,2.43,0,0,1-1.92,1l-3-.15a2,2,0,0,0-1.74,1.07L136.47,64a1.22,1.22,0,0,0,.64,1.62l2.46,1.05a1.52,1.52,0,0,1,.84,1.7,28,28,0,0,0-.52,3.06,3.84,3.84,0,0,1-1,2.08l-4.2,3.86a2.53,2.53,0,0,0-.7,2.06l.79,4.58a.75.75,0,0,0,1.25.54l4.19-2.76a1.21,1.21,0,0,1,1.68.38,9.11,9.11,0,0,0,.82,1,2.09,2.09,0,0,1,.49,2L141,91a1.07,1.07,0,0,0,.79,1.44l3.16.71a1.71,1.71,0,0,0,1.79-.83l3-5.67a3.16,3.16,0,0,1,1.79-1.35,14.3,14.3,0,0,0,2-.64,1.07,1.07,0,0,1,1.49.68l1.07,3.55a.79.79,0,0,0,1.34.42l4.73-3.72a2.61,2.61,0,0,0,.9-2l-.28-4.5a3.62,3.62,0,0,1,.74-2.19,35.21,35.21,0,0,0,2.2-2.91,2.44,2.44,0,0,1,1.93-1l3,.15A2,2,0,0,0,172.4,72l2.86-6.41a1.23,1.23,0,0,0-.64-1.63l-2.46-1a1.51,1.51,0,0,1-.84-1.69c.23-1,.41-2.06.53-3.06a3.79,3.79,0,0,1,1-2.08l4.2-3.86A2.54,2.54,0,0,0,177.77,50.19ZM157.55,74.58c-5.14,4-10.05,2.94-11-2.45s2.48-13,7.62-17.07,10-2.94,11,2.45S162.68,70.54,157.55,74.58Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "155.88px 64.8394px"
    },
    id: "elb0rop33j1x7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elx7u6bufabpf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.77,50.19,177,45.62a.75.75,0,0,0-1.25-.54l-4.19,2.76a1.22,1.22,0,0,1-1.68-.38,8.2,8.2,0,0,0-.82-1,2.07,2.07,0,0,1-.49-2l2.14-5.79a1,1,0,0,0-.78-1.43l-3.16-.71a1.7,1.7,0,0,0-1.79.83L162,43a3.12,3.12,0,0,1-1.79,1.35,15.83,15.83,0,0,0-1.95.64,1.07,1.07,0,0,1-1.49-.68l-1.07-3.54a.8.8,0,0,0-1.34-.43l-4.73,3.73a2.61,2.61,0,0,0-.9,2l.28,4.5a3.57,3.57,0,0,1-.74,2.18c-.77.93-1.51,1.9-2.2,2.91a2.43,2.43,0,0,1-1.92,1l-3-.15a2,2,0,0,0-1.74,1.07L136.47,64a1.22,1.22,0,0,0,.64,1.62l2.46,1.05a1.52,1.52,0,0,1,.84,1.7,28,28,0,0,0-.52,3.06,3.84,3.84,0,0,1-1,2.08l-4.2,3.86a2.53,2.53,0,0,0-.7,2.06l.79,4.58a.75.75,0,0,0,1.25.54l4.19-2.76a1.21,1.21,0,0,1,1.68.38,9.11,9.11,0,0,0,.82,1,2.09,2.09,0,0,1,.49,2L141,91a1.07,1.07,0,0,0,.79,1.44l3.16.71a1.71,1.71,0,0,0,1.79-.83l3-5.67a3.16,3.16,0,0,1,1.79-1.35,14.3,14.3,0,0,0,2-.64,1.07,1.07,0,0,1,1.49.68l1.07,3.55a.79.79,0,0,0,1.34.42l4.73-3.72a2.61,2.61,0,0,0,.9-2l-.28-4.5a3.62,3.62,0,0,1,.74-2.19,35.21,35.21,0,0,0,2.2-2.91,2.44,2.44,0,0,1,1.93-1l3,.15A2,2,0,0,0,172.4,72l2.86-6.41a1.23,1.23,0,0,0-.64-1.63l-2.46-1a1.51,1.51,0,0,1-.84-1.69c.23-1,.41-2.06.53-3.06a3.79,3.79,0,0,1,1-2.08l4.2-3.86A2.54,2.54,0,0,0,177.77,50.19ZM157.55,74.58c-5.14,4-10.05,2.94-11-2.45s2.48-13,7.62-17.07,10-2.94,11,2.45S162.68,70.54,157.55,74.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.75,
      transformOrigin: "155.88px 64.8394px"
    },
    className: "animable",
    id: "elxl5ytst8ncm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.74,49.77h0a1.27,1.27,0,0,0-1.36.12l-2.81,1.85L107,53.43a3.25,3.25,0,0,0,.77,3.12A14.32,14.32,0,0,1,109,58.12a1.9,1.9,0,0,0,2.63.58l6.55-4.31a1.27,1.27,0,0,1,1.33-.14Zm-10.08,24c-.92-5.3-4.3-8-8.69-7.6a13.48,13.48,0,0,1,.91,3.11C95.33,77.75,90,89.68,82,96a16.25,16.25,0,0,1-8.4,3.75c2.63,5.65,9.28,6.18,16.19.74C97.79,94.18,103.11,82.24,101.66,73.82Zm.14-36h0a1.62,1.62,0,0,0-.52-.21l-4.93-1.11a2.68,2.68,0,0,0-2.8,1.3L88.91,46.7a3.93,3.93,0,0,1-1,1.18h0a4,4,0,0,1-.79.53l1.45,4.83a1.68,1.68,0,0,0,2.33,1.06,25,25,0,0,1,3-1,5,5,0,0,0,1.76-.92,3.89,3.89,0,0,0,1-1.19l4.63-8.85a2.71,2.71,0,0,1,2.8-1.3l5,1.12a1.78,1.78,0,0,1,.49.18ZM87.9,123.52a1.35,1.35,0,0,1-.47-.75l-1.67-5.54a1.67,1.67,0,0,0-2.33-1.06,24,24,0,0,1-3,1,3.7,3.7,0,0,0-1,.4l.22.71a1.45,1.45,0,0,0,.63.86h0ZM78.43,42.34a1.14,1.14,0,0,0-.54-.14,1.4,1.4,0,0,0-.91.35l-7.4,5.81a1.86,1.86,0,0,0-.29.27,1,1,0,0,0-.19.22A4.9,4.9,0,0,0,68.45,50c0,.09-.06.19-.09.28h0a3.25,3.25,0,0,0-.19,1.19l.44,7a5.65,5.65,0,0,1-1.15,3.41c-1.22,1.45-2.36,3-3.43,4.54a3.76,3.76,0,0,1-1.63,1.26,3.19,3.19,0,0,1-.65.19,1.18,1.18,0,0,1-.31,0A1.59,1.59,0,0,1,61,68l-4.75-.23h-.12a1.72,1.72,0,0,0-.39,0,2.41,2.41,0,0,0-.35.07s0,0,0,0a3.12,3.12,0,0,0-.39.15,3.48,3.48,0,0,0-.69.43,3,3,0,0,0-.76,1l-4.47,10a1.91,1.91,0,0,0,.75,2.41l5.28,3a2.39,2.39,0,0,1,.12,1.37,46,46,0,0,0-.83,4.78,6,6,0,0,1-1.59,3.25l-.08.07-6.48,5.95a2.15,2.15,0,0,0-.32.35l0,.06a1.59,1.59,0,0,0-.26.43,3.8,3.8,0,0,0-.49,2.4l1.24,7.14a1.38,1.38,0,0,0,.57,1l7.75,4.47a1.38,1.38,0,0,1-.54-.94l-1.23-7.15a3.22,3.22,0,0,1,.08-1.37,3.83,3.83,0,0,1,1-1.87l6.47-6,.08-.07a6,6,0,0,0,1.61-3.25A43.29,43.29,0,0,1,63,90.8a2.39,2.39,0,0,0-1.32-2.66l-3.84-1.63a1.91,1.91,0,0,1-1-2.54l4.47-10a2.71,2.71,0,0,1,.76-1,3,3,0,0,1,2-.71l4.76.23a3,3,0,0,0,1.38-.27A3.74,3.74,0,0,0,71.82,71c1.07-1.57,2.22-3.1,3.43-4.55A5.5,5.5,0,0,0,76.4,63L76,56a3.12,3.12,0,0,1,.18-1.22,4.06,4.06,0,0,1,1.23-1.93L84.76,47a1.28,1.28,0,0,1,1.47-.21ZM67.34,117a3.27,3.27,0,0,0-.78-3.12,13.18,13.18,0,0,1-1.27-1.57,1.9,1.9,0,0,0-2.63-.59l-3.74,2.46-2.72,7.35a1.65,1.65,0,0,0,.66,2h0l7.81,4.5a1.62,1.62,0,0,1-.66-2Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "82.3298px 82.2186px"
    },
    id: "elxvw3m4uoamj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhxmtf2takic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.74,49.77h0a1.27,1.27,0,0,0-1.36.12l-2.81,1.85L107,53.43a3.25,3.25,0,0,0,.77,3.12A14.32,14.32,0,0,1,109,58.12a1.9,1.9,0,0,0,2.63.58l6.55-4.31a1.27,1.27,0,0,1,1.33-.14Zm-10.08,24c-.92-5.3-4.3-8-8.69-7.6a13.48,13.48,0,0,1,.91,3.11C95.33,77.75,90,89.68,82,96a16.25,16.25,0,0,1-8.4,3.75c2.63,5.65,9.28,6.18,16.19.74C97.79,94.18,103.11,82.24,101.66,73.82Zm.14-36h0a1.62,1.62,0,0,0-.52-.21l-4.93-1.11a2.68,2.68,0,0,0-2.8,1.3L88.91,46.7a3.93,3.93,0,0,1-1,1.18h0a4,4,0,0,1-.79.53l1.45,4.83a1.68,1.68,0,0,0,2.33,1.06,25,25,0,0,1,3-1,5,5,0,0,0,1.76-.92,3.89,3.89,0,0,0,1-1.19l4.63-8.85a2.71,2.71,0,0,1,2.8-1.3l5,1.12a1.78,1.78,0,0,1,.49.18ZM87.9,123.52a1.35,1.35,0,0,1-.47-.75l-1.67-5.54a1.67,1.67,0,0,0-2.33-1.06,24,24,0,0,1-3,1,3.7,3.7,0,0,0-1,.4l.22.71a1.45,1.45,0,0,0,.63.86h0ZM78.43,42.34a1.14,1.14,0,0,0-.54-.14,1.4,1.4,0,0,0-.91.35l-7.4,5.81a1.86,1.86,0,0,0-.29.27,1,1,0,0,0-.19.22A4.9,4.9,0,0,0,68.45,50c0,.09-.06.19-.09.28h0a3.25,3.25,0,0,0-.19,1.19l.44,7a5.65,5.65,0,0,1-1.15,3.41c-1.22,1.45-2.36,3-3.43,4.54a3.76,3.76,0,0,1-1.63,1.26,3.19,3.19,0,0,1-.65.19,1.18,1.18,0,0,1-.31,0A1.59,1.59,0,0,1,61,68l-4.75-.23h-.12a1.72,1.72,0,0,0-.39,0,2.41,2.41,0,0,0-.35.07s0,0,0,0a3.12,3.12,0,0,0-.39.15,3.48,3.48,0,0,0-.69.43,3,3,0,0,0-.76,1l-4.47,10a1.91,1.91,0,0,0,.75,2.41l5.28,3a2.39,2.39,0,0,1,.12,1.37,46,46,0,0,0-.83,4.78,6,6,0,0,1-1.59,3.25l-.08.07-6.48,5.95a2.15,2.15,0,0,0-.32.35l0,.06a1.59,1.59,0,0,0-.26.43,3.8,3.8,0,0,0-.49,2.4l1.24,7.14a1.38,1.38,0,0,0,.57,1l7.75,4.47a1.38,1.38,0,0,1-.54-.94l-1.23-7.15a3.22,3.22,0,0,1,.08-1.37,3.83,3.83,0,0,1,1-1.87l6.47-6,.08-.07a6,6,0,0,0,1.61-3.25A43.29,43.29,0,0,1,63,90.8a2.39,2.39,0,0,0-1.32-2.66l-3.84-1.63a1.91,1.91,0,0,1-1-2.54l4.47-10a2.71,2.71,0,0,1,.76-1,3,3,0,0,1,2-.71l4.76.23a3,3,0,0,0,1.38-.27A3.74,3.74,0,0,0,71.82,71c1.07-1.57,2.22-3.1,3.43-4.55A5.5,5.5,0,0,0,76.4,63L76,56a3.12,3.12,0,0,1,.18-1.22,4.06,4.06,0,0,1,1.23-1.93L84.76,47a1.28,1.28,0,0,1,1.47-.21ZM67.34,117a3.27,3.27,0,0,0-.78-3.12,13.18,13.18,0,0,1-1.27-1.57,1.9,1.9,0,0,0-2.63-.59l-3.74,2.46-2.72,7.35a1.65,1.65,0,0,0,.66,2h0l7.81,4.5a1.62,1.62,0,0,1-.66-2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "82.3298px 82.2186px"
    },
    className: "animable",
    id: "elai2s41coq0m"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxzfyuaa5mx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.74,49.77h0a1.27,1.27,0,0,0-1.36.12l-2.81,1.85L107,53.43a3.25,3.25,0,0,0,.77,3.12A14.32,14.32,0,0,1,109,58.12a1.9,1.9,0,0,0,2.63.58l6.55-4.31a1.27,1.27,0,0,1,1.33-.14Zm-10.08,24c-.92-5.3-4.3-8-8.69-7.6a13.48,13.48,0,0,1,.91,3.11C95.33,77.75,90,89.68,82,96a16.25,16.25,0,0,1-8.4,3.75c2.63,5.65,9.28,6.18,16.19.74C97.79,94.18,103.11,82.24,101.66,73.82Zm.14-36h0a1.62,1.62,0,0,0-.52-.21l-4.93-1.11a2.68,2.68,0,0,0-2.8,1.3L88.91,46.7a3.93,3.93,0,0,1-1,1.18h0a4,4,0,0,1-.79.53l1.45,4.83a1.68,1.68,0,0,0,2.33,1.06,25,25,0,0,1,3-1,5,5,0,0,0,1.76-.92,3.89,3.89,0,0,0,1-1.19l4.63-8.85a2.71,2.71,0,0,1,2.8-1.3l5,1.12a1.78,1.78,0,0,1,.49.18ZM87.9,123.52a1.35,1.35,0,0,1-.47-.75l-1.67-5.54a1.67,1.67,0,0,0-2.33-1.06,24,24,0,0,1-3,1,3.7,3.7,0,0,0-1,.4l.22.71a1.45,1.45,0,0,0,.63.86h0ZM78.43,42.34a1.14,1.14,0,0,0-.54-.14,1.4,1.4,0,0,0-.91.35l-7.4,5.81a1.86,1.86,0,0,0-.29.27,1,1,0,0,0-.19.22A4.9,4.9,0,0,0,68.45,50c0,.09-.06.19-.09.28h0a3.25,3.25,0,0,0-.19,1.19l.44,7a5.65,5.65,0,0,1-1.15,3.41c-1.22,1.45-2.36,3-3.43,4.54a3.76,3.76,0,0,1-1.63,1.26,3.19,3.19,0,0,1-.65.19,1.18,1.18,0,0,1-.31,0A1.59,1.59,0,0,1,61,68l-4.75-.23h-.12a1.72,1.72,0,0,0-.39,0,2.41,2.41,0,0,0-.35.07s0,0,0,0a3.12,3.12,0,0,0-.39.15,3.48,3.48,0,0,0-.69.43,3,3,0,0,0-.76,1l-4.47,10a1.91,1.91,0,0,0,.75,2.41l5.28,3a2.39,2.39,0,0,1,.12,1.37,46,46,0,0,0-.83,4.78,6,6,0,0,1-1.59,3.25l-.08.07-6.48,5.95a2.15,2.15,0,0,0-.32.35l0,.06a1.59,1.59,0,0,0-.26.43,3.8,3.8,0,0,0-.49,2.4l1.24,7.14a1.38,1.38,0,0,0,.57,1l7.75,4.47a1.38,1.38,0,0,1-.54-.94l-1.23-7.15a3.22,3.22,0,0,1,.08-1.37,3.83,3.83,0,0,1,1-1.87l6.47-6,.08-.07a6,6,0,0,0,1.61-3.25A43.29,43.29,0,0,1,63,90.8a2.39,2.39,0,0,0-1.32-2.66l-3.84-1.63a1.91,1.91,0,0,1-1-2.54l4.47-10a2.71,2.71,0,0,1,.76-1,3,3,0,0,1,2-.71l4.76.23a3,3,0,0,0,1.38-.27A3.74,3.74,0,0,0,71.82,71c1.07-1.57,2.22-3.1,3.43-4.55A5.5,5.5,0,0,0,76.4,63L76,56a3.12,3.12,0,0,1,.18-1.22,4.06,4.06,0,0,1,1.23-1.93L84.76,47a1.28,1.28,0,0,1,1.47-.21ZM67.34,117a3.27,3.27,0,0,0-.78-3.12,13.18,13.18,0,0,1-1.27-1.57,1.9,1.9,0,0,0-2.63-.59l-3.74,2.46-2.72,7.35a1.65,1.65,0,0,0,.66,2h0l7.81,4.5a1.62,1.62,0,0,1-.66-2Z",
    style: {
      opacity: 0.05,
      transformOrigin: "82.3298px 82.2186px"
    },
    className: "animable",
    id: "elxjs8t4ehug"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.5,98.89l-6.47,6a3.83,3.83,0,0,0-1,1.87l-7.77-4.48a4.64,4.64,0,0,1,.39-1,1.59,1.59,0,0,1,.26-.43l0-.06a2.15,2.15,0,0,1,.32-.35l6.48-5.95Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "52.88px 100.625px"
    },
    id: "elhwen4wk17zb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.19,72.23a3,3,0,0,1-1.38.27l-4.76-.23a3,3,0,0,0-2,.71L54.3,68.49a3.48,3.48,0,0,1,.69-.43,3.12,3.12,0,0,1,.39-.15s0,0,0,0a2.41,2.41,0,0,1,.35-.07,1.72,1.72,0,0,1,.39,0h.12L61,68a1.59,1.59,0,0,0,.43,0,1.81,1.81,0,0,0,.31,0c.21-.05.41-.13.62-.2h0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "62.245px 70.39px"
    },
    id: "elytvrxi51cr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,54.24a1.24,1.24,0,0,0-1.33.16l-6.55,4.31a1.91,1.91,0,0,1-2.63-.6,13.14,13.14,0,0,0-1.28-1.56,3.25,3.25,0,0,1-.77-3.12l.62-1.67,2.81-1.86a1.27,1.27,0,0,1,1.36-.12v0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "113.169px 54.3192px"
    },
    id: "elil8fncujle",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,42.34a1.78,1.78,0,0,0-.49-.18l-5-1.12a2.71,2.71,0,0,0-2.8,1.3L96.7,51.19a3.89,3.89,0,0,1-1,1.19l-7.78-4.5a3.93,3.93,0,0,0,1-1.18l4.64-8.85a2.68,2.68,0,0,1,2.8-1.3l4.93,1.11a1.62,1.62,0,0,1,.52.21h0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "98.745px 44.4436px"
    },
    id: "els9yvqmtqzx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.23,46.83a1.28,1.28,0,0,0-1.47.21l-7.39,5.81a4.06,4.06,0,0,0-1.23,1.93L68.36,50.3c0-.09.07-.19.09-.28a4.9,4.9,0,0,1,.65-1.17,1,1,0,0,1,.19-.22,1.86,1.86,0,0,1,.29-.27L77,42.55a1.4,1.4,0,0,1,.91-.35,1.14,1.14,0,0,1,.54.14Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "77.295px 48.49px"
    },
    id: "elflhironpp2e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljxrwtpx2um"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5,98.89l-6.47,6a3.83,3.83,0,0,0-1,1.87l-7.77-4.48a4.64,4.64,0,0,1,.39-1,1.59,1.59,0,0,1,.26-.43l0-.06a2.15,2.15,0,0,1,.32-.35l6.48-5.95Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "52.88px 100.625px"
    },
    className: "animable",
    id: "elx18n09mhrqk"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxthknh6599m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.19,72.23a3,3,0,0,1-1.38.27l-4.76-.23a3,3,0,0,0-2,.71L54.3,68.49a3.48,3.48,0,0,1,.69-.43,3.12,3.12,0,0,1,.39-.15s0,0,0,0a2.41,2.41,0,0,1,.35-.07,1.72,1.72,0,0,1,.39,0h.12L61,68a1.59,1.59,0,0,0,.43,0,1.81,1.81,0,0,0,.31,0c.21-.05.41-.13.62-.2h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "62.245px 70.39px"
    },
    className: "animable",
    id: "elkwtvcg30tj8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el35c3jtud0e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.51,54.24a1.24,1.24,0,0,0-1.33.16l-6.55,4.31a1.91,1.91,0,0,1-2.63-.6,13.14,13.14,0,0,0-1.28-1.56,3.25,3.25,0,0,1-.77-3.12l.62-1.67,2.81-1.86a1.27,1.27,0,0,1,1.36-.12v0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "113.169px 54.3192px"
    },
    className: "animable",
    id: "ela0jqva086uj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6cu9v16rogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.57,42.34a1.78,1.78,0,0,0-.49-.18l-5-1.12a2.71,2.71,0,0,0-2.8,1.3L96.7,51.19a3.89,3.89,0,0,1-1,1.19l-7.78-4.5a3.93,3.93,0,0,0,1-1.18l4.64-8.85a2.68,2.68,0,0,1,2.8-1.3l4.93,1.11a1.62,1.62,0,0,1,.52.21h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "98.745px 44.4436px"
    },
    className: "animable",
    id: "eljaekauz46zl"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldkh9w9cj2e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.23,46.83a1.28,1.28,0,0,0-1.47.21l-7.39,5.81a4.06,4.06,0,0,0-1.23,1.93L68.36,50.3c0-.09.07-.19.09-.28a4.9,4.9,0,0,1,.65-1.17,1,1,0,0,1,.19-.22,1.86,1.86,0,0,1,.29-.27L77,42.55a1.4,1.4,0,0,1,.91-.35,1.14,1.14,0,0,1,.54.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "77.295px 48.49px"
    },
    className: "animable",
    id: "elm3slp7px6v"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.36,62.39l-1.23-7.15a1.18,1.18,0,0,0-1.95-.84l-6.55,4.31a1.9,1.9,0,0,1-2.63-.6,14,14,0,0,0-1.28-1.56,3.25,3.25,0,0,1-.77-3.12l3.34-9a1.65,1.65,0,0,0-1.22-2.25l-4.93-1.1a2.68,2.68,0,0,0-2.8,1.29L96.7,51.19a4.9,4.9,0,0,1-2.81,2.11,23.42,23.42,0,0,0-3,1,1.68,1.68,0,0,1-2.33-1.06L86.85,47.7A1.23,1.23,0,0,0,84.76,47l-7.39,5.81A4.14,4.14,0,0,0,76,56l.44,7a5.52,5.52,0,0,1-1.15,3.4c-1.21,1.45-2.36,3-3.43,4.55a3.86,3.86,0,0,1-3,1.53l-4.76-.24A3.06,3.06,0,0,0,61.32,74L56.85,84a1.91,1.91,0,0,0,1,2.54l3.84,1.63A2.39,2.39,0,0,1,63,90.79a43.53,43.53,0,0,0-.83,4.78,5.93,5.93,0,0,1-1.6,3.25l-6.55,6a4,4,0,0,0-1.1,3.23l1.23,7.14a1.18,1.18,0,0,0,2,.85l6.55-4.31a1.9,1.9,0,0,1,2.63.59,13.18,13.18,0,0,0,1.27,1.57,3.25,3.25,0,0,1,.77,3.12l-3.34,9a1.65,1.65,0,0,0,1.22,2.24l4.94,1.11a2.68,2.68,0,0,0,2.8-1.3l4.64-8.84a4.84,4.84,0,0,1,2.8-2.11,22.54,22.54,0,0,0,3-1,1.69,1.69,0,0,1,2.34,1.07l1.67,5.54a1.23,1.23,0,0,0,2.08.66l7.4-5.82a4.11,4.11,0,0,0,1.4-3.13l-.44-7A5.7,5.7,0,0,1,99,104c1.22-1.45,2.36-3,3.44-4.54a3.81,3.81,0,0,1,3-1.53l4.75.24A3.05,3.05,0,0,0,113,96.52l4.47-10a1.9,1.9,0,0,0-1-2.54l-3.84-1.64a2.37,2.37,0,0,1-1.32-2.65,43.46,43.46,0,0,0,.82-4.78,5.93,5.93,0,0,1,1.6-3.24l6.56-6A4,4,0,0,0,121.36,62.39ZM89.77,100.48c-8,6.3-15.69,4.59-17.14-3.83S76.5,76.29,84.52,70s15.69-4.59,17.14,3.83S97.79,94.18,89.77,100.48Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "87.1444px 85.2195px"
    },
    id: "eldw09b85n9ah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpr0zsynfsu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.36,62.39l-1.23-7.15a1.18,1.18,0,0,0-1.95-.84l-6.55,4.31a1.9,1.9,0,0,1-2.63-.6,14,14,0,0,0-1.28-1.56,3.25,3.25,0,0,1-.77-3.12l3.34-9a1.65,1.65,0,0,0-1.22-2.25l-4.93-1.1a2.68,2.68,0,0,0-2.8,1.29L96.7,51.19a4.9,4.9,0,0,1-2.81,2.11,23.42,23.42,0,0,0-3,1,1.68,1.68,0,0,1-2.33-1.06L86.85,47.7A1.23,1.23,0,0,0,84.76,47l-7.39,5.81A4.14,4.14,0,0,0,76,56l.44,7a5.52,5.52,0,0,1-1.15,3.4c-1.21,1.45-2.36,3-3.43,4.55a3.86,3.86,0,0,1-3,1.53l-4.76-.24A3.06,3.06,0,0,0,61.32,74L56.85,84a1.91,1.91,0,0,0,1,2.54l3.84,1.63A2.39,2.39,0,0,1,63,90.79a43.53,43.53,0,0,0-.83,4.78,5.93,5.93,0,0,1-1.6,3.25l-6.55,6a4,4,0,0,0-1.1,3.23l1.23,7.14a1.18,1.18,0,0,0,2,.85l6.55-4.31a1.9,1.9,0,0,1,2.63.59,13.18,13.18,0,0,0,1.27,1.57,3.25,3.25,0,0,1,.77,3.12l-3.34,9a1.65,1.65,0,0,0,1.22,2.24l4.94,1.11a2.68,2.68,0,0,0,2.8-1.3l4.64-8.84a4.84,4.84,0,0,1,2.8-2.11,22.54,22.54,0,0,0,3-1,1.69,1.69,0,0,1,2.34,1.07l1.67,5.54a1.23,1.23,0,0,0,2.08.66l7.4-5.82a4.11,4.11,0,0,0,1.4-3.13l-.44-7A5.7,5.7,0,0,1,99,104c1.22-1.45,2.36-3,3.44-4.54a3.81,3.81,0,0,1,3-1.53l4.75.24A3.05,3.05,0,0,0,113,96.52l4.47-10a1.9,1.9,0,0,0-1-2.54l-3.84-1.64a2.37,2.37,0,0,1-1.32-2.65,43.46,43.46,0,0,0,.82-4.78,5.93,5.93,0,0,1,1.6-3.24l6.56-6A4,4,0,0,0,121.36,62.39ZM89.77,100.48c-8,6.3-15.69,4.59-17.14-3.83S76.5,76.29,84.52,70s15.69-4.59,17.14,3.83S97.79,94.18,89.77,100.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.75,
      transformOrigin: "87.1444px 85.2195px"
    },
    className: "animable",
    id: "el0neuu3b619la"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2",
    className: "animable",
    style: {
      transformOrigin: "245.97px 239.151px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-2",
    className: "animable",
    style: {
      transformOrigin: "245.97px 239.151px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.77,363.91c0,3.5,2.62,7.85,5.85,9.71l127.26,73.49a12.88,12.88,0,0,0,11.69,0l224.1-129.38c3.23-1.87,5.85-6.21,5.85-9.71s-2.62-7.84-5.85-9.71L304.41,224.82a12.94,12.94,0,0,0-11.69,0L68.61,354.21C65.39,356.07,62.77,360.42,62.77,363.91Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "250.145px 335.969px"
    },
    id: "elgs4c6qhheai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqti7t1lg13a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.52,308c0,3.5-2.62,7.84-5.84,9.71L207.57,447.12a12.06,12.06,0,0,1-5.84,1.39V435.85a12,12,0,0,0,5.84-1.4L431.68,305.07c2.82-1.63,3.18-4.15,1.06-6C435.45,301.17,437.52,304.92,437.52,308Z",
    style: {
      opacity: 0.5,
      transformOrigin: "319.625px 373.791px"
    },
    className: "animable",
    id: "elublvhtc271l"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldf5vrrltonm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.61,361l127.27,73.49a12.94,12.94,0,0,0,11.69,0l224.1-129.39c3.23-1.86,3.23-4.88,0-6.75L304.41,224.82a12.94,12.94,0,0,0-11.69,0L68.61,354.21C65.39,356.07,65.39,359.09,68.61,361Z",
    style: {
      opacity: 0.3,
      transformOrigin: "250.144px 329.655px"
    },
    className: "animable",
    id: "el7ygi3wmwrsc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ela0inpkhly8e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.73,435.86v12.65a12,12,0,0,1-5.85-1.39L68.61,373.62c-3.22-1.86-5.84-6.21-5.84-9.7,0-3.29,2.31-7.31,5.25-9.33-2.62,1.87-2.42,4.63.59,6.37l127.27,73.49A11.86,11.86,0,0,0,201.73,435.86Z",
    style: {
      opacity: 0.6,
      transformOrigin: "132.25px 401.551px"
    },
    className: "animable",
    id: "elxa02ctghqv"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.29,354.42c-3-1.75-2.87-4.7-2.87-8.43V170.2a12.9,12.9,0,0,1,5.85-10.12L284.37,30.69c3.23-1.86,6.2-.51,9.23,1.24s5,3.25,5,7V214.7a12.89,12.89,0,0,1-5.84,10.12L68.61,354.21C65.39,356.07,60.31,356.16,57.29,354.42Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "176.51px 192.731px"
    },
    id: "el3btvkkbjbru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5c50y46a82d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.56,38.91c0-3.72-2.62-5.23-5.84-3.38L68.61,164.92a12,12,0,0,0-4.13,4.37l-8.34-4.85h0a12,12,0,0,1,4.14-4.37L284.36,30.69c3.23-1.87,6.21-.52,9.24,1.23S298.56,35.19,298.56,38.91Z",
    style: {
      opacity: 0.3,
      transformOrigin: "177.35px 99.5392px"
    },
    className: "animable",
    id: "elbjmfmsdjdqq"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzhkcews63m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.77,175.05V350.83c0,3.73,2.62,5.24,5.84,3.38L292.72,224.82a12.89,12.89,0,0,0,5.84-10.12V38.91c0-3.73-2.61-5.24-5.84-3.37L68.61,164.92A13,13,0,0,0,62.77,175.05Z",
    style: {
      opacity: 0.5,
      transformOrigin: "180.665px 194.872px"
    },
    className: "animable",
    id: "elp1m5br2wfn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkp22bvaq3k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.92,354.56c-3.22,1.51-7.81,1.49-10.63-.15-3-1.74-2.86-4.69-2.86-8.42V170.2a11.72,11.72,0,0,1,1.71-5.75l8.34,4.83h0A12,12,0,0,0,62.77,175V350.83C62.77,354.29,65,355.84,67.92,354.56Z",
    style: {
      opacity: 0.6,
      transformOrigin: "61.1745px 260.059px"
    },
    className: "animable",
    id: "elnbycu8be6d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.76,171.66,287.82,47c1.94-1.12,3.51-.21,3.51,2V202.43a7.72,7.72,0,0,1-3.51,6.07L71.76,333.21c-1.94,1.12-3.51.21-3.51-2V177.74A7.75,7.75,0,0,1,71.76,171.66Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "179.79px 190.105px"
    },
    id: "elyux2vb7hmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elow4u2lb796f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.79,354.55l208-120.09a6.4,6.4,0,0,1,5.84,0l6.05,3.18c1.62.93,1.62,2.44,0,3.37l-208,120.08a6.48,6.48,0,0,1-5.85,0l-6-3.16C83.18,357,83.18,355.48,84.79,354.55Z",
    style: {
      opacity: 0.3,
      transformOrigin: "194.741px 297.771px"
    },
    className: "animable",
    id: "elorql7l4c5hc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljcp2cc9rv8o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.11,364.25l208-120.09a5.94,5.94,0,0,1,5.34-.29l54.14,31.26c1.34.77,1.11,2.15-.5,3.08L160.33,398.14a6,6,0,0,1-5.35.3l-54.37-31.11C99.27,366.56,99.49,365.19,101.11,364.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      opacity: 0.3,
      transformOrigin: "234.598px 321.151px"
    },
    className: "animable",
    id: "el5v4z9vaclf5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.64,294.11l6.51-3.76c.27-.16.32-.4.09-.53l-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32A1,1,0,0,0,279.64,294.11Zm-9.09-12.77L264,285.1c-.27.16-.31.4-.09.53l5.75,3.31a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32A1,1,0,0,0,270.55,281.34Zm-21,12.15-11,6.36c-.27.16-.31.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.06l11-6.36c.28-.16.32-.4.09-.53l-5.74-3.31A1,1,0,0,0,249.51,293.49ZM261,286.84l-6.52,3.76c-.27.16-.31.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32A1,1,0,0,0,261,286.84Zm-25.55,14.75L229,305.35c-.28.16-.32.39-.1.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.31A1,1,0,0,0,235.48,301.59ZM226,307.08l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.1-.52L226.87,307A1,1,0,0,0,226,307.08Zm24.13,14.52,6.52-3.76c.27-.16.31-.4.09-.53L251,314a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32A1,1,0,0,0,250.09,321.6Zm-9.51,5.49,6.51-3.76c.27-.16.31-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91.05L234,323.3c-.28.16-.32.4-.09.53l5.74,3.31A1,1,0,0,0,240.58,327.09Zm-9.52,5.5,6.51-3.76c.28-.16.32-.4.09-.53L231.91,325a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32A1,1,0,0,0,231.06,332.59Zm-9.52,5.49,6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.92,0L215,334.29c-.28.16-.32.4-.09.53l5.75,3.32A1,1,0,0,0,221.54,338.08Zm48.58-38.48,6.51-3.76c.28-.16.32-.39.09-.52L271,292a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32A1,1,0,0,0,270.12,299.6Zm-10.51,16.5,14.53-8.39c.28-.16.32-.39.09-.52l-14.78-8.54a1,1,0,0,0-.91.06L251,303c-.28.16-.32.4-.1.53l8.22,4.74c.23.13.19.37-.09.53l-6,3.47c-.28.16-.32.4-.09.53l5.74,3.31A1,1,0,0,0,259.61,316.1Zm-43.17-3.52-6.51,3.76c-.28.16-.32.39-.09.53l5.74,3.31a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.31A1,1,0,0,0,216.44,312.58Zm-9.52,5.49-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.4.09-.53L207.83,318A1.05,1.05,0,0,0,206.92,318.07ZM154,376.61a1,1,0,0,0,.91-.06l6.52-3.76c.27-.16.31-.39.09-.52L155.76,369a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53ZM130.77,362l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.31a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.39.09-.52L131.68,362A1,1,0,0,0,130.77,362Zm11.68,10.8a1,1,0,0,0,.91-.06l6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91.05L136.8,369c-.28.16-.32.4-.09.53Zm26.5,6,6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.91.06l-6.52,3.76c-.27.16-.31.39-.09.52l5.75,3.32A1,1,0,0,0,169,378.88Zm-10.43,5.55a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.4-.09.53Zm-18.23-27.89-6.51,3.77c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91,0l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32A1,1,0,0,0,140.29,356.54Zm47.59-27.47-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.92-.05l6.51-3.76c.28-.16.32-.4.09-.53L188.79,329A1,1,0,0,0,187.88,329.07Zm-38.07,22-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.31a1,1,0,0,0,.91,0l6.51-3.76c.28-.16.32-.4.09-.53L150.72,351A1,1,0,0,0,149.81,351.05Zm47.59-27.48-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.31a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32A1,1,0,0,0,197.4,323.57Zm-19,11-6.51,3.76c-.28.16-.32.4-.09.53l5.75,3.31a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32A1,1,0,0,0,178.36,334.56Zm-9.51,5.5-6.52,3.76c-.27.16-.32.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53L169.76,340A1,1,0,0,0,168.85,340.06Zm-9.52,5.49-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32A1,1,0,0,0,159.33,345.55Zm43.17,3.53,6.51-3.77c.28-.15.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.32A1.05,1.05,0,0,0,202.5,349.08Zm89.09-79.89L285.08,273c-.28.16-.32.4-.09.53l5.74,3.32a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.1-.52l-5.75-3.32A1,1,0,0,0,291.59,269.19Zm-11.52,6.65-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53L281,275.79A1,1,0,0,0,280.07,275.84Zm21-12.14-6.51,3.76c-.28.16-.32.39-.1.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53L302,263.64A1,1,0,0,0,301.11,263.7Zm-53,48.63,6.52-3.76c.27-.16.31-.39.09-.53l-5.75-3.31a1,1,0,0,0-.91,0l-6.51,3.76c-.28.16-.32.39-.09.53l5.74,3.31A1,1,0,0,0,248.07,312.33Zm63.47-54.18a1,1,0,0,0-.91.05L304.11,262c-.27.16-.31.4-.09.53l5.75,3.31a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.53ZM212,343.58l6.51-3.76c.28-.16.32-.4.09-.53L212.88,336a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.31.39-.09.52l5.75,3.32A1,1,0,0,0,212,343.58Zm116.73-67.4,6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.32A1,1,0,0,0,328.75,276.18Zm-18.55.28,6.51-3.76c.28-.16.32-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32A1,1,0,0,0,310.2,276.46Zm10.37-13.1a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52L318.8,271a1,1,0,0,0,.91,0l6.52-3.76c.27-.16.32-.4.09-.53Zm2-1.15,14.78,8.53a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-14.78-8.53a1,1,0,0,0-.91.05l-6.51,3.76C322.39,261.84,322.35,262.08,322.58,262.21Zm-22,12.2-6.51,3.76c-.28.16-.32.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.31A1,1,0,0,0,300.62,274.41ZM229,315.77l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.31a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32A1,1,0,0,0,229,315.77Zm89.34-34a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.31a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.39-.1.53ZM238.5,310.28,232,314c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.32A1,1,0,0,0,238.5,310.28Zm-75,60.83a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52Zm-10.68-11.37-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91,0l6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.32A1,1,0,0,0,152.83,359.74Zm21.11,5.82,6.52-3.76c.27-.16.31-.39.09-.52L174.8,358a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.31A1,1,0,0,0,173.94,365.56Zm9.52-5.49,6.51-3.76c.28-.16.32-.4.1-.53l-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32A1,1,0,0,0,183.46,360.07Zm9.52-5.5,6.51-3.76c.28-.16.32-.39.09-.53L193.84,347a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.31A1,1,0,0,0,193,354.57Zm-30.63-.33L155.84,358c-.28.16-.32.4-.09.53l5.74,3.31a1,1,0,0,0,.91,0l6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32A1,1,0,0,0,162.35,354.24Zm9.52-5.5-6.51,3.77c-.28.16-.32.39-.1.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32A1,1,0,0,0,171.87,348.74Zm38.07-22-6.51,3.76c-.28.16-.32.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32A1,1,0,0,0,209.94,326.76Zm-9.51,5.5L193.91,336c-.27.16-.32.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.31A1,1,0,0,0,200.43,332.26Zm19-11L213,325c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.92-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.75-3.32A1,1,0,0,0,219.46,321.27Zm-38.07,22L174.87,347c-.27.16-.31.4-.09.53l5.75,3.31a1,1,0,0,0,.91-.05L188,347c.28-.16.32-.4.09-.53l-5.74-3.31A1,1,0,0,0,181.39,343.25Zm9.52-5.5-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.32a1.05,1.05,0,0,0,.91-.05l6.51-3.77c.28-.16.32-.39.09-.52l-5.74-3.32A1,1,0,0,0,190.91,337.75Zm-12.44,35.63,6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.31A1,1,0,0,0,178.47,373.38Zm-50.56-2.58-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91-.05l6.52-3.76C128.09,371.17,128.13,370.93,127.91,370.8ZM140.45,374l-5.75-3.31a1,1,0,0,0-.91.05l-10,5.78c-.27.16-.31.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.06l10-5.78C140.64,374.36,140.68,374.12,140.45,374Zm-21-9.81-5.75-3.31a1,1,0,0,0-.91.05l-8,4.63c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91-.05l8-4.63C119.64,364.55,119.68,364.31,119.45,364.18Zm6.15-3.55a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.52L127.36,353a1,1,0,0,0-.91,0l-6.51,3.76c-.28.16-.32.4-.09.53ZM152,377.76l-5.75-3.31a1,1,0,0,0-.91.05l-12.52,7.23c-.28.16-.32.4-.09.53l5.74,3.31a1,1,0,0,0,.91-.05l12.53-7.23C152.18,378.13,152.22,377.89,152,377.76Zm4.53,7.82-5.75-3.31a1,1,0,0,0-.91.05l-8,4.63c-.27.16-.31.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l8-4.63C156.7,386,156.74,385.71,156.52,385.58Zm39.85-65.81a1,1,0,0,0,.91,0l6.51-3.76c.28-.16.32-.39.09-.53l-5.74-3.31a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.4-.09.53Zm-19,11a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53Zm-42.22,24.38a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.32-.4.09-.53l-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52Zm51.74-29.87a1,1,0,0,0,.91,0l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.1.52Zm-19,11a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52Zm-6,50.07a1,1,0,0,0-.91.05l-10,5.78c-.28.16-.32.4-.09.53l5.74,3.32a1,1,0,0,0,.91-.06l10-5.78c.28-.16.32-.4.09-.53Zm-7.66-42.18a1,1,0,0,0,.91-.06l6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53Zm-9.52,5.49a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.4.09-.53L146.4,342a1,1,0,0,0-.91.05L139,345.8c-.28.16-.32.4-.09.53Zm193.53-65.13a1,1,0,0,0-.91.05l-16,9.26c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91-.05l16-9.26c.28-.16.32-.39.09-.52Zm-21,12.15a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.31a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.53ZM188,367.89l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.92.06l-6.51,3.76c-.27.16-.32.39-.09.52l5.75,3.32A1,1,0,0,0,188,367.89Zm110.09-60.24a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.1-.52ZM347.68,279a1,1,0,0,0-.91.06l-6.52,3.76c-.27.16-.31.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53Zm15.26-2.17-14.78-8.54a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l14.78,8.53a1,1,0,0,0,.91-.05l6.51-3.76C363.13,277.2,363.17,277,362.94,276.84ZM262.51,328.19a1,1,0,0,0-.91.05l-8,4.63c-.27.16-.32.39-.09.52l5.75,3.32a1,1,0,0,0,.91,0l8-4.63c.28-.16.32-.4.09-.53Zm24.05-13.89a1,1,0,0,0-.91.05l-10,5.79c-.28.16-.32.39-.09.53l5.74,3.31a1,1,0,0,0,.91-.05l10-5.78c.28-.16.32-.4.09-.53Zm-46.09,26.61a1,1,0,0,0-.92.06L186,371.92c-.28.15-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91-.05l53.61-30.95c.28-.16.32-.4.09-.53ZM183.85,373.6a1,1,0,0,0-.91,0l-8,4.63c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91-.05l8-4.63c.27-.16.32-.39.09-.52Zm67.64-39.05a1,1,0,0,0-.91.05l-8,4.63c-.28.16-.32.4-.09.53l5.75,3.31a1,1,0,0,0,.91-.05l8-4.63c.28-.16.32-.39.09-.52ZM172.83,380a1,1,0,0,0-.91.05l-8,4.63c-.27.16-.31.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.06l8-4.63c.27-.16.31-.39.09-.52Zm100.7-58.14a1,1,0,0,0-.91.06l-8,4.62c-.27.16-.31.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.06l8-4.62c.27-.16.31-.4.09-.53Zm34.07-19.67a1,1,0,0,0-.91.06L300.17,306c-.27.16-.31.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53Zm20.67-15.25,6.51-3.76c.28-.16.32-.4.09-.53l-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.15-.32.39-.09.52l5.75,3.32A1,1,0,0,0,328.27,286.9Zm-39.12,1.71,6.52-3.76c.27-.16.31-.39.09-.52L290,281a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.31A1,1,0,0,0,289.15,288.61Zm-25,35.31,19-11c.27-.16.31-.4.09-.53l-5.75-3.31a1,1,0,0,0-.91.05l-19,11c-.27.16-.31.39-.09.53l5.75,3.31A1,1,0,0,0,264.14,323.92Zm53.7-31.48a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.92,0l-6.51,3.76c-.27.16-.32.4-.09.53Zm-8.13-5.26,6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.32a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32A1,1,0,0,0,309.71,287.18Zm-55.09,42.24,6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.91.05l-6.52,3.77c-.27.15-.31.39-.09.52l5.75,3.32A1,1,0,0,0,254.62,329.42Zm42.17-24.83a1,1,0,0,0,.92,0l6.51-3.76c.28-.16.32-.4.09-.53l-5.75-3.31a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.39-.09.53ZM207,356.89l6.51-3.76c.27-.16.32-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91,0l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32A1,1,0,0,0,207,356.89Zm9.51-5.49,6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.31a1,1,0,0,0-.91.05L210,347.61c-.28.16-.32.39-.09.52l5.74,3.32A1,1,0,0,0,216.54,351.4Zm-19,11,6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.31a1,1,0,0,0-.92,0l-6.51,3.76c-.28.16-.32.39-.09.53l5.75,3.31A1,1,0,0,0,197.51,362.39Zm38.07-22,6.51-3.76c.28-.16.32-.4.1-.53l-5.75-3.32a1,1,0,0,0-.91.06L229,336.62c-.28.16-.32.39-.09.52l5.74,3.32A1,1,0,0,0,235.58,340.41Zm-9.52,5.49,6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32A1,1,0,0,0,226.06,345.9Zm19-11,6.51-3.76c.28-.16.32-.39.09-.52L246,327.31a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.31A1,1,0,0,0,245.1,334.91Zm52.6-76.07a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.09-.52l-1.52-.89a1,1,0,0,0-.92.06l-6.51,3.76c-.28.16-.32.39-.09.52Zm-47.49,29.85a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53L252,281a1,1,0,0,0-.91.05l-6.52,3.77c-.27.16-.31.39-.09.52Zm19-11a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.09-.52L271,270a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.32.4-.09.53Zm-30.66,17.7a1,1,0,0,0,.91,0l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.92.06l-6.51,3.76c-.28.16-.32.39-.09.52Zm21.14-12.21a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.31a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.31.39-.09.53Zm-40.18,23.2a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.91.06l-6.52,3.76c-.27.16-.31.39-.09.52Zm9.52-5.5a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.4-.09.53Zm49.59-31.06a1,1,0,0,0,.91-.06l6.52-3.76c.27-.16.31-.39.09-.52l-1.53-.88a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.39-.09.52Zm28.56-16.49a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-1.53-.88a1,1,0,0,0-.91,0l-6.51,3.76c-.28.16-.32.4-.09.53Zm12.07,7a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.31.4-.09.53Zm18.49,21.09,6.52-3.76c.27-.16.32-.4.09-.53l-5.75-3.31a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.31A1,1,0,0,0,337.78,281.4Zm-49.6-17.07a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.1-.53l-1.53-.88a1,1,0,0,0-.92.05l-6.51,3.76c-.27.16-.32.4-.09.53ZM210,311.89a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.91,0L204.37,308c-.27.16-.31.4-.09.53Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "233.82px 322.046px"
    },
    id: "elcb0i1wi0n34",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfw0ko2hark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.64,294.11l6.51-3.76c.27-.16.32-.4.09-.53l-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32A1,1,0,0,0,279.64,294.11Zm-9.09-12.77L264,285.1c-.27.16-.31.4-.09.53l5.75,3.31a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32A1,1,0,0,0,270.55,281.34Zm-21,12.15-11,6.36c-.27.16-.31.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.06l11-6.36c.28-.16.32-.4.09-.53l-5.74-3.31A1,1,0,0,0,249.51,293.49ZM261,286.84l-6.52,3.76c-.27.16-.31.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32A1,1,0,0,0,261,286.84Zm-25.55,14.75L229,305.35c-.28.16-.32.39-.1.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.31A1,1,0,0,0,235.48,301.59ZM226,307.08l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.1-.52L226.87,307A1,1,0,0,0,226,307.08Zm24.13,14.52,6.52-3.76c.27-.16.31-.4.09-.53L251,314a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32A1,1,0,0,0,250.09,321.6Zm-9.51,5.49,6.51-3.76c.27-.16.31-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91.05L234,323.3c-.28.16-.32.4-.09.53l5.74,3.31A1,1,0,0,0,240.58,327.09Zm-9.52,5.5,6.51-3.76c.28-.16.32-.4.09-.53L231.91,325a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32A1,1,0,0,0,231.06,332.59Zm-9.52,5.49,6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.92,0L215,334.29c-.28.16-.32.4-.09.53l5.75,3.32A1,1,0,0,0,221.54,338.08Zm48.58-38.48,6.51-3.76c.28-.16.32-.39.09-.52L271,292a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32A1,1,0,0,0,270.12,299.6Zm-10.51,16.5,14.53-8.39c.28-.16.32-.39.09-.52l-14.78-8.54a1,1,0,0,0-.91.06L251,303c-.28.16-.32.4-.1.53l8.22,4.74c.23.13.19.37-.09.53l-6,3.47c-.28.16-.32.4-.09.53l5.74,3.31A1,1,0,0,0,259.61,316.1Zm-43.17-3.52-6.51,3.76c-.28.16-.32.39-.09.53l5.74,3.31a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.31A1,1,0,0,0,216.44,312.58Zm-9.52,5.49-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.4.09-.53L207.83,318A1.05,1.05,0,0,0,206.92,318.07ZM154,376.61a1,1,0,0,0,.91-.06l6.52-3.76c.27-.16.31-.39.09-.52L155.76,369a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53ZM130.77,362l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.31a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.39.09-.52L131.68,362A1,1,0,0,0,130.77,362Zm11.68,10.8a1,1,0,0,0,.91-.06l6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91.05L136.8,369c-.28.16-.32.4-.09.53Zm26.5,6,6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.91.06l-6.52,3.76c-.27.16-.31.39-.09.52l5.75,3.32A1,1,0,0,0,169,378.88Zm-10.43,5.55a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.4-.09.53Zm-18.23-27.89-6.51,3.77c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91,0l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32A1,1,0,0,0,140.29,356.54Zm47.59-27.47-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.92-.05l6.51-3.76c.28-.16.32-.4.09-.53L188.79,329A1,1,0,0,0,187.88,329.07Zm-38.07,22-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.31a1,1,0,0,0,.91,0l6.51-3.76c.28-.16.32-.4.09-.53L150.72,351A1,1,0,0,0,149.81,351.05Zm47.59-27.48-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.31a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32A1,1,0,0,0,197.4,323.57Zm-19,11-6.51,3.76c-.28.16-.32.4-.09.53l5.75,3.31a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32A1,1,0,0,0,178.36,334.56Zm-9.51,5.5-6.52,3.76c-.27.16-.32.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53L169.76,340A1,1,0,0,0,168.85,340.06Zm-9.52,5.49-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32A1,1,0,0,0,159.33,345.55Zm43.17,3.53,6.51-3.77c.28-.15.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.32A1.05,1.05,0,0,0,202.5,349.08Zm89.09-79.89L285.08,273c-.28.16-.32.4-.09.53l5.74,3.32a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.1-.52l-5.75-3.32A1,1,0,0,0,291.59,269.19Zm-11.52,6.65-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53L281,275.79A1,1,0,0,0,280.07,275.84Zm21-12.14-6.51,3.76c-.28.16-.32.39-.1.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53L302,263.64A1,1,0,0,0,301.11,263.7Zm-53,48.63,6.52-3.76c.27-.16.31-.39.09-.53l-5.75-3.31a1,1,0,0,0-.91,0l-6.51,3.76c-.28.16-.32.39-.09.53l5.74,3.31A1,1,0,0,0,248.07,312.33Zm63.47-54.18a1,1,0,0,0-.91.05L304.11,262c-.27.16-.31.4-.09.53l5.75,3.31a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.53ZM212,343.58l6.51-3.76c.28-.16.32-.4.09-.53L212.88,336a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.31.39-.09.52l5.75,3.32A1,1,0,0,0,212,343.58Zm116.73-67.4,6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.32A1,1,0,0,0,328.75,276.18Zm-18.55.28,6.51-3.76c.28-.16.32-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32A1,1,0,0,0,310.2,276.46Zm10.37-13.1a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52L318.8,271a1,1,0,0,0,.91,0l6.52-3.76c.27-.16.32-.4.09-.53Zm2-1.15,14.78,8.53a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-14.78-8.53a1,1,0,0,0-.91.05l-6.51,3.76C322.39,261.84,322.35,262.08,322.58,262.21Zm-22,12.2-6.51,3.76c-.28.16-.32.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.31A1,1,0,0,0,300.62,274.41ZM229,315.77l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.31a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32A1,1,0,0,0,229,315.77Zm89.34-34a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.31a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.39-.1.53ZM238.5,310.28,232,314c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.32A1,1,0,0,0,238.5,310.28Zm-75,60.83a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52Zm-10.68-11.37-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91,0l6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.32A1,1,0,0,0,152.83,359.74Zm21.11,5.82,6.52-3.76c.27-.16.31-.39.09-.52L174.8,358a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.31A1,1,0,0,0,173.94,365.56Zm9.52-5.49,6.51-3.76c.28-.16.32-.4.1-.53l-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32A1,1,0,0,0,183.46,360.07Zm9.52-5.5,6.51-3.76c.28-.16.32-.39.09-.53L193.84,347a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.31A1,1,0,0,0,193,354.57Zm-30.63-.33L155.84,358c-.28.16-.32.4-.09.53l5.74,3.31a1,1,0,0,0,.91,0l6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32A1,1,0,0,0,162.35,354.24Zm9.52-5.5-6.51,3.77c-.28.16-.32.39-.1.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32A1,1,0,0,0,171.87,348.74Zm38.07-22-6.51,3.76c-.28.16-.32.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32A1,1,0,0,0,209.94,326.76Zm-9.51,5.5L193.91,336c-.27.16-.32.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.31A1,1,0,0,0,200.43,332.26Zm19-11L213,325c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.92-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.75-3.32A1,1,0,0,0,219.46,321.27Zm-38.07,22L174.87,347c-.27.16-.31.4-.09.53l5.75,3.31a1,1,0,0,0,.91-.05L188,347c.28-.16.32-.4.09-.53l-5.74-3.31A1,1,0,0,0,181.39,343.25Zm9.52-5.5-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.32a1.05,1.05,0,0,0,.91-.05l6.51-3.77c.28-.16.32-.39.09-.52l-5.74-3.32A1,1,0,0,0,190.91,337.75Zm-12.44,35.63,6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.31A1,1,0,0,0,178.47,373.38Zm-50.56-2.58-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91-.05l6.52-3.76C128.09,371.17,128.13,370.93,127.91,370.8ZM140.45,374l-5.75-3.31a1,1,0,0,0-.91.05l-10,5.78c-.27.16-.31.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.06l10-5.78C140.64,374.36,140.68,374.12,140.45,374Zm-21-9.81-5.75-3.31a1,1,0,0,0-.91.05l-8,4.63c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91-.05l8-4.63C119.64,364.55,119.68,364.31,119.45,364.18Zm6.15-3.55a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.52L127.36,353a1,1,0,0,0-.91,0l-6.51,3.76c-.28.16-.32.4-.09.53ZM152,377.76l-5.75-3.31a1,1,0,0,0-.91.05l-12.52,7.23c-.28.16-.32.4-.09.53l5.74,3.31a1,1,0,0,0,.91-.05l12.53-7.23C152.18,378.13,152.22,377.89,152,377.76Zm4.53,7.82-5.75-3.31a1,1,0,0,0-.91.05l-8,4.63c-.27.16-.31.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l8-4.63C156.7,386,156.74,385.71,156.52,385.58Zm39.85-65.81a1,1,0,0,0,.91,0l6.51-3.76c.28-.16.32-.39.09-.53l-5.74-3.31a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.4-.09.53Zm-19,11a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53Zm-42.22,24.38a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.32-.4.09-.53l-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52Zm51.74-29.87a1,1,0,0,0,.91,0l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.1.52Zm-19,11a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.16-.32.39-.09.52Zm-6,50.07a1,1,0,0,0-.91.05l-10,5.78c-.28.16-.32.4-.09.53l5.74,3.32a1,1,0,0,0,.91-.06l10-5.78c.28-.16.32-.4.09-.53Zm-7.66-42.18a1,1,0,0,0,.91-.06l6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53Zm-9.52,5.49a1,1,0,0,0,.91-.05l6.52-3.76c.27-.16.31-.4.09-.53L146.4,342a1,1,0,0,0-.91.05L139,345.8c-.28.16-.32.4-.09.53Zm193.53-65.13a1,1,0,0,0-.91.05l-16,9.26c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91-.05l16-9.26c.28-.16.32-.39.09-.52Zm-21,12.15a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.31a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.53ZM188,367.89l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.92.06l-6.51,3.76c-.27.16-.32.39-.09.52l5.75,3.32A1,1,0,0,0,188,367.89Zm110.09-60.24a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.1-.52ZM347.68,279a1,1,0,0,0-.91.06l-6.52,3.76c-.27.16-.31.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53Zm15.26-2.17-14.78-8.54a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l14.78,8.53a1,1,0,0,0,.91-.05l6.51-3.76C363.13,277.2,363.17,277,362.94,276.84ZM262.51,328.19a1,1,0,0,0-.91.05l-8,4.63c-.27.16-.32.39-.09.52l5.75,3.32a1,1,0,0,0,.91,0l8-4.63c.28-.16.32-.4.09-.53Zm24.05-13.89a1,1,0,0,0-.91.05l-10,5.79c-.28.16-.32.39-.09.53l5.74,3.31a1,1,0,0,0,.91-.05l10-5.78c.28-.16.32-.4.09-.53Zm-46.09,26.61a1,1,0,0,0-.92.06L186,371.92c-.28.15-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91-.05l53.61-30.95c.28-.16.32-.4.09-.53ZM183.85,373.6a1,1,0,0,0-.91,0l-8,4.63c-.28.16-.32.39-.09.52l5.74,3.32a1,1,0,0,0,.91-.05l8-4.63c.27-.16.32-.39.09-.52Zm67.64-39.05a1,1,0,0,0-.91.05l-8,4.63c-.28.16-.32.4-.09.53l5.75,3.31a1,1,0,0,0,.91-.05l8-4.63c.28-.16.32-.39.09-.52ZM172.83,380a1,1,0,0,0-.91.05l-8,4.63c-.27.16-.31.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.06l8-4.63c.27-.16.31-.39.09-.52Zm100.7-58.14a1,1,0,0,0-.91.06l-8,4.62c-.27.16-.31.4-.09.53l5.75,3.32a1,1,0,0,0,.91-.06l8-4.62c.27-.16.31-.4.09-.53Zm34.07-19.67a1,1,0,0,0-.91.06L300.17,306c-.27.16-.31.39-.09.52l5.75,3.32a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53Zm20.67-15.25,6.51-3.76c.28-.16.32-.4.09-.53l-5.75-3.32a1,1,0,0,0-.91.06l-6.51,3.76c-.28.15-.32.39-.09.52l5.75,3.32A1,1,0,0,0,328.27,286.9Zm-39.12,1.71,6.52-3.76c.27-.16.31-.39.09-.52L290,281a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.31A1,1,0,0,0,289.15,288.61Zm-25,35.31,19-11c.27-.16.31-.4.09-.53l-5.75-3.31a1,1,0,0,0-.91.05l-19,11c-.27.16-.31.39-.09.53l5.75,3.31A1,1,0,0,0,264.14,323.92Zm53.7-31.48a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.92,0l-6.51,3.76c-.27.16-.32.4-.09.53Zm-8.13-5.26,6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.32a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32A1,1,0,0,0,309.71,287.18Zm-55.09,42.24,6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.91.05l-6.52,3.77c-.27.15-.31.39-.09.52l5.75,3.32A1,1,0,0,0,254.62,329.42Zm42.17-24.83a1,1,0,0,0,.92,0l6.51-3.76c.28-.16.32-.4.09-.53l-5.75-3.31a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.39-.09.53ZM207,356.89l6.51-3.76c.27-.16.32-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91,0l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32A1,1,0,0,0,207,356.89Zm9.51-5.49,6.52-3.76c.27-.16.31-.4.09-.53l-5.75-3.31a1,1,0,0,0-.91.05L210,347.61c-.28.16-.32.39-.09.52l5.74,3.32A1,1,0,0,0,216.54,351.4Zm-19,11,6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.31a1,1,0,0,0-.92,0l-6.51,3.76c-.28.16-.32.39-.09.53l5.75,3.31A1,1,0,0,0,197.51,362.39Zm38.07-22,6.51-3.76c.28-.16.32-.4.1-.53l-5.75-3.32a1,1,0,0,0-.91.06L229,336.62c-.28.16-.32.39-.09.52l5.74,3.32A1,1,0,0,0,235.58,340.41Zm-9.52,5.49,6.52-3.76c.27-.16.31-.39.09-.52l-5.75-3.32a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.32A1,1,0,0,0,226.06,345.9Zm19-11,6.51-3.76c.28-.16.32-.39.09-.52L246,327.31a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.4-.09.53l5.75,3.31A1,1,0,0,0,245.1,334.91Zm52.6-76.07a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.09-.52l-1.52-.89a1,1,0,0,0-.92.06l-6.51,3.76c-.28.16-.32.39-.09.52Zm-47.49,29.85a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53L252,281a1,1,0,0,0-.91.05l-6.52,3.77c-.27.16-.31.39-.09.52Zm19-11a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.09-.52L271,270a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.32.4-.09.53Zm-30.66,17.7a1,1,0,0,0,.91,0l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.92.06l-6.51,3.76c-.28.16-.32.39-.09.52Zm21.14-12.21a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.31a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.31.39-.09.53Zm-40.18,23.2a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.91.06l-6.52,3.76c-.27.16-.31.39-.09.52Zm9.52-5.5a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.4-.09.53Zm49.59-31.06a1,1,0,0,0,.91-.06l6.52-3.76c.27-.16.31-.39.09-.52l-1.53-.88a1,1,0,0,0-.91.05l-6.52,3.76c-.27.16-.31.39-.09.52Zm28.56-16.49a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-1.53-.88a1,1,0,0,0-.91,0l-6.51,3.76c-.28.16-.32.4-.09.53Zm12.07,7a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.09-.53l-5.74-3.32a1,1,0,0,0-.91,0l-6.52,3.76c-.27.16-.31.4-.09.53Zm18.49,21.09,6.52-3.76c.27-.16.32-.4.09-.53l-5.75-3.31a1,1,0,0,0-.91.05l-6.51,3.76c-.28.16-.32.4-.09.53l5.74,3.31A1,1,0,0,0,337.78,281.4Zm-49.6-17.07a1,1,0,0,0,.91-.05l6.51-3.76c.28-.16.32-.4.1-.53l-1.53-.88a1,1,0,0,0-.92.05l-6.51,3.76c-.27.16-.32.4-.09.53ZM210,311.89a1,1,0,0,0,.91-.06l6.51-3.76c.28-.16.32-.39.09-.52l-5.74-3.32a1,1,0,0,0-.91,0L204.37,308c-.27.16-.31.4-.09.53Z",
    style: {
      opacity: 0.1,
      transformOrigin: "233.82px 322.046px"
    },
    className: "animable",
    id: "el9g0ms8cw12c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnai6ywaj2fh"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "239.17 361.04 240.51 361.81 275.98 382.29 339.06 345.87 340.37 345.12 303.57 323.87 239.17 361.04",
    style: {
      opacity: 0.4,
      transformOrigin: "289.77px 353.08px"
    },
    className: "animable",
    id: "elcvza91t6um4"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "240.51 361.81 275.98 382.29 339.06 345.87 303.57 325.39 240.51 361.81",
    style: {
      fill: "#3CB499",
      transformOrigin: "289.785px 353.84px"
    },
    id: "el2lmtf7x520u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elypchuuo85jm"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "240.51 361.81 275.98 382.29 339.06 345.87 303.57 325.39 240.51 361.81",
    style: {
      opacity: 0.45,
      transformOrigin: "289.785px 353.84px"
    },
    className: "animable",
    id: "elb6rnlszs2ma"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.28,354.41a9.47,9.47,0,0,0,1.8.77,8.32,8.32,0,0,1-1.8-.76c-.18-.11-.37-.23-.55-.36Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "57.905px 354.62px"
    },
    id: "elly8ymg6j0z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.52,355s0,0,.09-.08l-.07.07Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "67.565px 354.96px"
    },
    id: "elyfz88h8m3lm",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-2",
    className: "animable",
    style: {
      transformOrigin: "239.815px 219.099px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2",
    className: "animable",
    style: {
      transformOrigin: "208.81px 199.449px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2",
    className: "animable",
    style: {
      transformOrigin: "208.81px 199.449px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.48,49.47a1.76,1.76,0,0,0-.07-.41.1.1,0,0,0,0-.09,1.56,1.56,0,0,0-.1-.4A2,2,0,0,0,330,48a.58.58,0,0,0-.14-.24.73.73,0,0,0-.14-.16,1.18,1.18,0,0,0-.29-.3l0,0a2.88,2.88,0,0,0-.38-.22,3.27,3.27,0,0,0-3,.39L97.37,179.09a10,10,0,0,0-4.5,7.79V352.14a3.09,3.09,0,0,0,1.62,2.72l.19.11.24.13a1.55,1.55,0,0,0,.38.13,2.25,2.25,0,0,0,.58.08,3,3,0,0,0,1.49-.43l.11-.07h0l4.29-2.48L326,223.15a9.93,9.93,0,0,0,4.5-7.78V50A5.12,5.12,0,0,0,330.48,49.47Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "211.685px 201.095px"
    },
    id: "eltf4xikcp4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,47.05a3.27,3.27,0,0,0-3,.39L97.37,179.09a10,10,0,0,0-4.5,7.79v14.69l-5.74-3.37V183.62a9.91,9.91,0,0,1,4.48-7.78L320.27,44.19a3.11,3.11,0,0,1,3.26-.26C324.35,44.41,328.08,46.55,329,47.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "208.065px 122.579px"
    },
    id: "elnh4cn10nqvq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.5,50c0-2.84-2-4-4.49-2.56L97.36,179.09a9.93,9.93,0,0,0-4.49,7.78v14.7L330.5,64.75Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "211.685px 124.195px"
    },
    id: "eluihun0p5t0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkn2oyibhc6"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "208.755px 113.01px"
    },
    className: "animable",
    id: "elqzyqa6d3n59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326,47.44,97.37,179.09a9.28,9.28,0,0,0-3.17,3.34l-5.71-3.31a8.92,8.92,0,0,1,3.13-3.28L320.27,44.19a3.18,3.18,0,0,1,3.27-.27c.8.5,4.53,2.62,5.48,3.12A3.27,3.27,0,0,0,326,47.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "208.755px 113.01px"
    },
    id: "eluiwe0a6vsja",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el9rzxqj6scz6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.12,198.22V183.61a9.31,9.31,0,0,1,1.36-4.49l5.73,3.29a9,9,0,0,0-1.35,4.47v14.69Z",
    style: {
      opacity: 0.15,
      transformOrigin: "90.665px 190.345px"
    },
    className: "animable",
    id: "elye9h0amtbv9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.93,66.66c-1.41.81-2.54,3.21-2.54,5.37s1.13,3.26,2.54,2.45,2.54-3.22,2.54-5.38S305.33,65.85,303.93,66.66Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "303.93px 70.5694px"
    },
    id: "elfssdpvth3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.07,61.37c-1.4.81-2.54,3.22-2.54,5.38s1.14,3.25,2.54,2.44,2.54-3.22,2.54-5.38S314.47,60.56,313.07,61.37Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "313.07px 65.28px"
    },
    id: "el6rd1uepf93j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.21,56.08c-1.4.81-2.54,3.22-2.54,5.38s1.14,3.25,2.54,2.44,2.54-3.21,2.54-5.37S323.61,55.27,322.21,56.08Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "322.21px 59.9906px"
    },
    id: "elitqz8n0m6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5,354.86l-.25-.14L89.51,352a4.76,4.76,0,0,1-2.34-3.49,4.87,4.87,0,0,1,0-.65V198.2l5.75,3.37V352.13a3.06,3.06,0,0,0,1.43,2.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "90.8296px 276.53px"
    },
    id: "elsnpzzv6z9ka",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--binary-code--inject-2",
    className: "animable",
    style: {
      transformOrigin: "213.821px 210.686px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.05,208.3v2.1a11.41,11.41,0,0,1-.14,1.35,5.31,5.31,0,0,1-.35,1.23,5,5,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31A1.79,1.79,0,0,1,100,214a6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,1-.3.84.84,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A7.93,7.93,0,0,1,104.05,208.3Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S100.94,211.84,101,212.13Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "101.96px 210.58px"
    },
    id: "elyddc8tsma8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.1,205.38c0,.14,0,.31,0,.49V207c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.35,1.23,5,5,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.84,1.84,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.84,1.84,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.4,4.4,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,.95-.3.84.84,0,0,1,.63.31,1.9,1.9,0,0,1,.35.81A6.89,6.89,0,0,1,109.1,205.38Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.22.41.23.77,0a1.75,1.75,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.65,0,1S106,208.92,106,209.21Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "107.015px 207.63px"
    },
    id: "elms7184ym4ne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.16,202.45c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,4.8,4.8,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.21,3.21,0,0,1-1,.79,1.72,1.72,0,0,1-1,.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.35-.81A6.89,6.89,0,0,1,110,207c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.13,6.13,0,0,1,.35-1.24,4.8,4.8,0,0,1,.63-1.05,3.55,3.55,0,0,1,1-.81,1.83,1.83,0,0,1,1-.3.81.81,0,0,1,.63.31,1.69,1.69,0,0,1,.36.81A6.88,6.88,0,0,1,114.16,202.45Zm-3.09,3.84a2.37,2.37,0,0,0,.26,1.17c.15.22.41.23.76,0a1.7,1.7,0,0,0,.77-.9,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S111.06,206,111.07,206.29Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "112.08px 204.735px"
    },
    id: "elbaz8hwbmlrt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.84,201.65a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21a.53.53,0,0,1,.15-.15l.6-.34a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.57.57,0,0,1-.06.25.39.39,0,0,1-.14.18l-.63.36a.1.1,0,0,1-.14,0,.26.26,0,0,1-.07-.19v-5.84L115.49,202a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "116.24px 201.797px"
    },
    id: "elx9yvbu3rco8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.78,197.48v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,2,2,0,0,1-.36-.82,7.73,7.73,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a11.83,11.83,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.81,1.81,0,0,1,1-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,122.78,197.48Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S119.67,201,119.68,201.32Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "120.685px 199.715px"
    },
    id: "el6da7nwsmbu3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.45,196.68a.33.33,0,0,1,0-.21.57.57,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.1.1,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.64a.48.48,0,0,1-.07.26.39.39,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "124.857px 196.824px"
    },
    id: "elw5z6vlmmzk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.39,192.51c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,131.39,192.51Zm-3.1,3.84a2.31,2.31,0,0,0,.27,1.16c.15.23.4.24.76,0a1.77,1.77,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.16-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.59,4.59,0,0,0-.27,1.47c0,.3,0,.64,0,1S128.28,196.05,128.29,196.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "129.295px 194.745px"
    },
    id: "elzi37nsu1u3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.45,189.59v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.91,1.91,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12.23,12.23,0,0,1,.13-1.37,5.86,5.86,0,0,1,.36-1.23,4.19,4.19,0,0,1,.63-1.06,3.09,3.09,0,0,1,.95-.8,1.81,1.81,0,0,1,1-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.83,6.83,0,0,1,136.45,189.59Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.16.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.35,2.35,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.81,1.81,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S133.34,193.13,133.35,193.43Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "134.355px 191.82px"
    },
    id: "elrhcmj7lqzar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.12,188.78a.33.33,0,0,1,0-.21.87.87,0,0,1,.08-.26l1.67-3a1.07,1.07,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "138.527px 188.92px"
    },
    id: "el2orioe9xhal",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.68,186.73a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.21a.62.62,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36c-.06,0-.11,0-.14,0a.24.24,0,0,1-.07-.19v-5.85l-1.09,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "142.08px 186.867px"
    },
    id: "elgbiriwdpcl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.23,184.68a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.39.39,0,0,1,.15-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.54.54,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0A.23.23,0,0,1,146,189v-5.85l-1.1,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "145.63px 184.83px"
    },
    id: "elpdrx21lhq2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.17,180.51v2.11A9.63,9.63,0,0,1,152,184a5.37,5.37,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,2,2,0,0,1-.36-.82A6.66,6.66,0,0,1,148,185c0-.29,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.22,4.22,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.7,1.7,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.82,6.82,0,0,1,152.17,180.51Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.88,4.88,0,0,0,.27-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S149.06,184.06,149.07,184.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "150.08px 182.78px"
    },
    id: "elh7kqeamd05",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.84,179.71a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "154.247px 179.855px"
    },
    id: "elbz19dl3grcu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,175.54c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,160.78,175.54Zm-3.1,3.84a2.52,2.52,0,0,0,.26,1.17c.16.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.38,4.38,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.28,2.28,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,5,5,0,0,0-.26,1.47c0,.31,0,.64,0,1S157.67,179.08,157.68,179.38Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "158.685px 177.775px"
    },
    id: "elhdnazqnzoqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.46,174.74a.34.34,0,0,1-.05-.22.87.87,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "162.824px 174.871px"
    },
    id: "eletimba53p7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.39,170.57c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.83,1.83,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.21,3.21,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.81A6.89,6.89,0,0,1,169.39,170.57Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.79,1.79,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S166.28,174.11,166.29,174.41Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "167.295px 172.825px"
    },
    id: "el94u9jfnfpvg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.07,169.76a.28.28,0,0,1,0-.21.52.52,0,0,1,.08-.26l1.66-3,.13-.21A.41.41,0,0,1,172,166l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V168.2l-1.09,2a.27.27,0,0,1-.15.15.12.12,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "171.43px 169.97px"
    },
    id: "el2lzd80vagen",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.62,167.71a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.64.64,0,0,1,.15-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85l-1.1,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "175.02px 167.86px"
    },
    id: "elevfcw7s83ap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.17,165.66a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3A2.39,2.39,0,0,1,179,162a.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.55.55,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18V164.1L177.83,166a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "178.552px 165.83px"
    },
    id: "el3wohif550ng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.11,161.49c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5A9.63,9.63,0,0,1,185,165a5.23,5.23,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.77,1.77,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.89,1.89,0,0,1-.35-.81A6.83,6.83,0,0,1,181,166c0-.29,0-.63,0-1s0-.72,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4,4,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.78,1.78,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.82,6.82,0,0,1,185.11,161.49Zm-3.1,3.84a2.35,2.35,0,0,0,.27,1.17c.15.22.4.23.76,0a1.75,1.75,0,0,0,.77-.9,5,5,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.44,2.44,0,0,0-.26-1.16c-.16-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S182,165,182,165.33Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "183.056px 163.78px"
    },
    id: "el216o2o68kq4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.79,160.69a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "187.19px 160.835px"
    },
    id: "elt10cw4mrgxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.72,156.52c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.83,1.83,0,0,1-1,.31.85.85,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.54,3.54,0,0,1,1-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.77,6.77,0,0,1,193.72,156.52Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.72,1.72,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S190.61,160.07,190.62,160.36Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "191.625px 158.755px"
    },
    id: "el94vbmasm82a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4,155.72a.29.29,0,0,1,0-.22.52.52,0,0,1,.08-.26l1.67-3,.12-.21a.51.51,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.14,0,.22.22,0,0,1-.07-.19v-5.85l-1.09,1.95a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "195.799px 155.851px"
    },
    id: "eloc26l9agym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.33,151.55c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,3.84,3.84,0,0,1-.64,1,3.47,3.47,0,0,1-.94.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.32,5.32,0,0,1,.36-1.23,4.47,4.47,0,0,1,.62-1.06,3.42,3.42,0,0,1,1-.8,1.81,1.81,0,0,1,.94-.31.84.84,0,0,1,.64.31,1.89,1.89,0,0,1,.35.81A6.89,6.89,0,0,1,202.33,151.55Zm-3.09,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1A2.47,2.47,0,0,0,201,151c-.15-.22-.41-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.56,4.56,0,0,0-.26,1.47c0,.3,0,.64,0,1S199.23,155.09,199.24,155.39Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "200.245px 153.785px"
    },
    id: "el2ntd97p9d16",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.39,148.63c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.37,3.37,0,0,1-1,.79,1.81,1.81,0,0,1-.95.31.86.86,0,0,1-.63-.32,1.9,1.9,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,6.13,6.13,0,0,1,.35-1.24,4.65,4.65,0,0,1,.63-1.05,3.35,3.35,0,0,1,.95-.8,1.86,1.86,0,0,1,1-.31.84.84,0,0,1,.63.31,1.9,1.9,0,0,1,.36.81A6.89,6.89,0,0,1,207.39,148.63Zm-3.09,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.41-.23-.77,0a1.75,1.75,0,0,0-.76.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S204.28,152.17,204.3,152.47Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "205.3px 150.86px"
    },
    id: "elxl8r1qrookc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.45,145.71c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.51a9.66,9.66,0,0,1-.13,1.34,5.85,5.85,0,0,1-.35,1.23,4.62,4.62,0,0,1-.64,1,3.62,3.62,0,0,1-.94.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.69,1.69,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.07,5.07,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.85,1.85,0,0,1,.94-.3.84.84,0,0,1,.64.31,1.9,1.9,0,0,1,.35.81A6.89,6.89,0,0,1,212.45,145.71Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.41.23.77,0a1.75,1.75,0,0,0,.76-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.65,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S209.34,149.25,209.35,149.54Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "210.365px 147.94px"
    },
    id: "elt7qplnslgtr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.13,144.9a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.49.49,0,0,1,.15-.14l.59-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85l-1.1,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "214.53px 145.049px"
    },
    id: "elrnqih4j3h1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.07,140.74v2.1a11.41,11.41,0,0,1-.14,1.35,5.23,5.23,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.31,3.31,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,2,2,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.4,4.4,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A7.93,7.93,0,0,1,221.07,140.74Zm-3.1,3.83a2.37,2.37,0,0,0,.26,1.17c.15.22.41.23.77,0a1.65,1.65,0,0,0,.76-.9,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S218,144.28,218,144.57Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "218.98px 142.97px"
    },
    id: "el4lmfxi3ljt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.74,139.93a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.54.54,0,0,1-.07.26.41.41,0,0,1-.14.17l-.63.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "223.147px 140.077px"
    },
    id: "elirf9yo55woc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.68,135.76c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,229.68,135.76Zm-3.1,3.84a2.52,2.52,0,0,0,.26,1.17c.16.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.38,2.38,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.77,1.77,0,0,0-.77.91,5,5,0,0,0-.26,1.47c0,.31,0,.64,0,1S226.57,139.31,226.58,139.6Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "227.585px 137.995px"
    },
    id: "elx9it3ydw0le",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.36,135a.33.33,0,0,1-.05-.21.72.72,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "231.725px 135.143px"
    },
    id: "elrrwh4bhd4la",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.29,130.79c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a11.65,11.65,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.82A7.73,7.73,0,0,1,238.29,130.79Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S235.18,134.33,235.19,134.63Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "236.22px 133.025px"
    },
    id: "elo0zzwbq5kej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,130a.3.3,0,0,1,0-.22.52.52,0,0,1,.08-.26l1.66-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "240.4px 130.13px"
    },
    id: "elo39iuwha8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,224.62a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.1.1,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.64a.48.48,0,0,1-.07.26.39.39,0,0,1-.14.18l-.63.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.84L100.32,225a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "101.067px 224.765px"
    },
    id: "elcjfexne9xv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6,220.45v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31A.84.84,0,0,1,104,227a2,2,0,0,1-.36-.82,7.87,7.87,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a11.83,11.83,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,107.6,220.45Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S104.49,224,104.5,224.29Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "105.569px 222.725px"
    },
    id: "elg7t49r42ysl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.66,217.53v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31A.85.85,0,0,1,109,224a1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,112.66,217.53Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.16.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S109.55,221.07,109.56,221.37Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "110.589px 219.77px"
    },
    id: "el1bu5cp5xbi7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.72,214.61v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.91,1.91,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.86,5.86,0,0,1,.36-1.23,4.47,4.47,0,0,1,.62-1.06,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.83,6.83,0,0,1,117.72,214.61Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.7,1.7,0,0,0-.77.9,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S114.61,218.15,114.62,218.45Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "115.63px 216.845px"
    },
    id: "elywju8kji1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.78,211.69v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.91,1.91,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12.23,12.23,0,0,1,.13-1.37,6.14,6.14,0,0,1,.36-1.24,4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.88,1.88,0,0,1,1-.3.81.81,0,0,1,.63.31,1.84,1.84,0,0,1,.35.81A6.83,6.83,0,0,1,122.78,211.69Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S119.67,215.23,119.68,215.53Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "120.685px 213.92px"
    },
    id: "elazg0drgkg06",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.45,210.88a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.54.54,0,0,1-.07.26.39.39,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.15.15,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "124.857px 211.031px"
    },
    id: "elqtx9q4k243b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.39,206.72c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,4,4,0,0,1-.63,1,3.37,3.37,0,0,1-1,.8,1.83,1.83,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.81,1.81,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,131.39,206.72Zm-3.1,3.83a2.32,2.32,0,0,0,.27,1.17c.15.22.4.23.76,0a1.77,1.77,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.16-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S128.28,210.26,128.29,210.55Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "129.295px 208.96px"
    },
    id: "elqo5ryctbv1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.06,205.91a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.31.31,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.35a.11.11,0,0,1-.15,0,.24.24,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "133.467px 206.057px"
    },
    id: "elzgmmhemsxlq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,201.74c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.83,1.83,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.54,3.54,0,0,1,1-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.88,6.88,0,0,1,140,201.74Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.69,1.69,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S136.89,205.29,136.9,205.58Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "137.905px 203.975px"
    },
    id: "elmvoyld4rzv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.68,200.94a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.21a.51.51,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36c-.06,0-.11,0-.14,0a.22.22,0,0,1-.07-.19v-5.85l-1.09,1.95a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "142.08px 201.07px"
    },
    id: "el8yx0oyh9r5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.23,198.89a.28.28,0,0,1,0-.21.57.57,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.6-.34a.1.1,0,0,1,.14,0,.24.24,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.1,2a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "145.631px 199.033px"
    },
    id: "elzn45uanxz9s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.78,196.84a.35.35,0,0,1,0-.22.87.87,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "149.186px 196.97px"
    },
    id: "el0s02vxx1zrp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.72,192.67c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a11.87,11.87,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.09,3.09,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.81.81,0,0,1,.63.31,2,2,0,0,1,.36.81A8,8,0,0,1,155.72,192.67Zm-3.1,3.84a2.31,2.31,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,4.66,4.66,0,0,0-.27,1.48c0,.3,0,.64,0,1S152.61,196.21,152.62,196.51Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "153.625px 194.925px"
    },
    id: "elpqlihvgfehl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.4,191.86a.33.33,0,0,1-.05-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19V190.3l-1.09,1.94a.33.33,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "157.765px 192.01px"
    },
    id: "el5pg6fjd6y8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.33,187.7c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.23,4,4,0,0,1-.63,1,3.37,3.37,0,0,1-1,.8,1.81,1.81,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1,3.4,3.4,0,0,1,.95-.81,1.81,1.81,0,0,1,1-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.89,6.89,0,0,1,164.33,187.7Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.65,0,1S161.22,191.24,161.23,191.53Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "162.24px 189.965px"
    },
    id: "ele26bhkuzqsu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,186.89a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.43.43,0,0,1,.15-.15l.59-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.35a.11.11,0,0,1-.15,0,.24.24,0,0,1-.06-.19v-5.84l-1.09,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "166.4px 187.037px"
    },
    id: "el863fry8pqij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,184.84a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.14,0,.26.26,0,0,1,.07.19v7.64a.59.59,0,0,1-.07.26.39.39,0,0,1-.14.18l-.63.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.84l-1.1,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "169.967px 184.987px"
    },
    id: "el5hvc4r7bce2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5,180.67v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.63-.31,2,2,0,0,1-.36-.82,7.73,7.73,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a11.83,11.83,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,176.5,180.67Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S173.39,184.22,173.4,184.51Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "174.405px 182.905px"
    },
    id: "eloasjnckku7h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.56,177.75v2.11a9.79,9.79,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.36-.82,7.87,7.87,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a11.83,11.83,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,181.56,177.75Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S178.45,181.29,178.46,181.59Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "179.465px 179.985px"
    },
    id: "ely240c4t8uud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.23,177a.35.35,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.24.24,0,0,1,.07.19v7.65a.51.51,0,0,1-.07.26.34.34,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "183.637px 177.131px"
    },
    id: "elttz868pk2rk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.17,172.78c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a11.87,11.87,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.09,3.09,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.81A8,8,0,0,1,190.17,172.78Zm-3.1,3.84a2.31,2.31,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,4.66,4.66,0,0,0-.27,1.48c0,.3,0,.64,0,1S187.06,176.32,187.07,176.62Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "188.075px 175.01px"
    },
    id: "elp39yv0hnjse",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.85,172a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.2a.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "192.257px 172.15px"
    },
    id: "elavu1e0f0c16",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.78,167.81c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.72,1.72,0,0,1-1,.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.4,3.4,0,0,1,1-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.89,6.89,0,0,1,198.78,167.81Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.65,0,1S195.67,171.35,195.68,171.64Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "196.69px 170.04px"
    },
    id: "el6uppshy02d8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.46,167a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "200.86px 167.15px"
    },
    id: "eln687s8ya79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,165a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.14,0,.26.26,0,0,1,.07.19v7.65a.59.59,0,0,1-.07.25.39.39,0,0,1-.14.18l-.63.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.32.32,0,0,1-.16.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "204.407px 165.147px"
    },
    id: "eldvyplrk0ei6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,160.78v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,2,2,0,0,1-.36-.82,7.73,7.73,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a11.83,11.83,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.81,1.81,0,0,1,1-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,211,160.78Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S207.84,164.33,207.85,164.62Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "208.905px 163.015px"
    },
    id: "elpe0wqv0xjkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,157.86V160a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.36-.82,7.87,7.87,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1A11.83,11.83,0,0,1,212,159a6,6,0,0,1,.36-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,216,157.86Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S212.9,161.4,212.91,161.7Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "213.93px 160.13px"
    },
    id: "elsiw2nor59mr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.68,157.06a.35.35,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.24.24,0,0,1,.07.19v7.65a.48.48,0,0,1-.07.26.34.34,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "218.087px 157.192px"
    },
    id: "elwyzuiozjnge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.62,152.89c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.31,5.31,0,0,1,.35-1.23,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.83,6.83,0,0,1,224.62,152.89Zm-3.1,3.84a2.31,2.31,0,0,0,.27,1.16c.15.23.4.24.76,0a1.77,1.77,0,0,0,.77-.91,5,5,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.49,2.49,0,0,0-.26-1.17c-.16-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.54,4.54,0,0,0-.27,1.47c0,.3,0,.64,0,1S221.51,156.43,221.52,156.73Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "222.525px 155.125px"
    },
    id: "elmh79ffpnwz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.3,152.08a.33.33,0,0,1-.05-.21.79.79,0,0,1,.08-.26l1.67-3a1.93,1.93,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85L226,152.47a.35.35,0,0,1-.15.15.11.11,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "226.665px 152.22px"
    },
    id: "elm73pniqp90e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.23,147.92c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.86,5.86,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.72,1.72,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.4,3.4,0,0,1,.95-.81,1.9,1.9,0,0,1,1-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.89,6.89,0,0,1,233.23,147.92Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S230.12,151.46,230.13,151.75Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "231.135px 150.175px"
    },
    id: "eln7txw0r3ar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,147.11a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "235.31px 147.26px"
    },
    id: "ell49xnj42v2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,142.94c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,4.8,4.8,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.21,3.21,0,0,1-.95.79,1.72,1.72,0,0,1-1,.31.85.85,0,0,1-.63-.31,2,2,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.13,6.13,0,0,1,.35-1.24,4.25,4.25,0,0,1,.63-1,3.55,3.55,0,0,1,1-.81,1.83,1.83,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.69,1.69,0,0,1,.36.81A6.88,6.88,0,0,1,241.84,142.94Zm-3.1,3.84A2.47,2.47,0,0,0,239,148c.15.22.41.23.76,0a1.7,1.7,0,0,0,.77-.9,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S238.73,146.49,238.74,146.78Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "239.75px 145.205px"
    },
    id: "el9bgwnjrblz5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.05,236.71v2.11a11.46,11.46,0,0,1-.14,1.34,5.31,5.31,0,0,1-.35,1.23,5,5,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.79,1.79,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.13-1.37,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,1-.3.84.84,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A7.93,7.93,0,0,1,104.05,236.71Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S100.94,240.25,101,240.55Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "101.935px 238.935px"
    },
    id: "eli6fl9puw41",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.22,233.72c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,109.22,233.72Zm-3.1,3.84a2.44,2.44,0,0,0,.26,1.16c.16.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.38,4.38,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.28,2.28,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,5,5,0,0,0-.26,1.47c0,.31,0,.64,0,1S106.11,237.26,106.12,237.56Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "107.125px 235.955px"
    },
    id: "elkkm8ug4zuo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,232.85a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21A.43.43,0,0,1,112,229l.6-.34a.1.1,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.84l-1.1,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "111.39px 232.975px"
    },
    id: "elh0qur1a5i8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.06,228.62c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.23,4,4,0,0,1-.63,1,3.37,3.37,0,0,1-1,.8,1.81,1.81,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1.05,3.4,3.4,0,0,1,.95-.81,1.81,1.81,0,0,1,1-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,118.06,228.62Zm-3.1,3.83a2.32,2.32,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S115,232.16,115,232.45Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "115.965px 230.86px"
    },
    id: "ela46mo8j3onh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.85,227.74a.33.33,0,0,1,0-.21.65.65,0,0,1,.08-.26l1.67-3a2,2,0,0,1,.12-.21.53.53,0,0,1,.15-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.32.32,0,0,1-.16.15.12.12,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "120.252px 227.88px"
    },
    id: "elsnf01jc19n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.9,223.51c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.8,9.8,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.83,1.83,0,0,1-1,.31.87.87,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.54,3.54,0,0,1,1-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.82A6.66,6.66,0,0,1,126.9,223.51Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S123.79,227.05,123.8,227.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "124.785px 225.745px"
    },
    id: "elr77fzt0zege",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.69,222.64a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34c.06,0,.1,0,.14,0a.22.22,0,0,1,.07.19v7.64a.48.48,0,0,1-.07.26.34.34,0,0,1-.14.18l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84L128.35,223a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "129.097px 222.8px"
    },
    id: "elfybzey6vkar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.74,218.41c0,.14,0,.31,0,.49V220c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.46,5.46,0,0,1-.35,1.23,4.34,4.34,0,0,1-.64,1,3.24,3.24,0,0,1-1,.8,1.78,1.78,0,0,1-.95.3.84.84,0,0,1-.63-.31,2,2,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.13,6.13,0,0,1,.35-1.24,4.8,4.8,0,0,1,.63-1.05,3.55,3.55,0,0,1,.95-.81,1.83,1.83,0,0,1,1-.3.84.84,0,0,1,.64.31,1.79,1.79,0,0,1,.35.81A6.89,6.89,0,0,1,135.74,218.41Zm-3.09,3.83a2.34,2.34,0,0,0,.26,1.17c.15.22.41.23.76,0a1.68,1.68,0,0,0,.77-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S132.64,222,132.65,222.24Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "133.65px 220.64px"
    },
    id: "elu12pimzwoy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.92,215.42v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.09,3.09,0,0,1,.95-.8,1.81,1.81,0,0,1,1-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.83,6.83,0,0,1,140.92,215.42Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.16.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.38,4.38,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.25,2.25,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.77,1.77,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S137.81,219,137.82,219.26Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "138.825px 217.675px"
    },
    id: "elbxdlf5rjmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.09,212.43c0,.15,0,.31,0,.49V214c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.83,1.83,0,0,1-1,.31.89.89,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.39,5.39,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.54,3.54,0,0,1,1-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.66,6.66,0,0,1,146.09,212.43Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S143,216,143,216.27Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "144px 214.625px"
    },
    id: "el8dwcu8sgdgn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.88,211.56a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.54.54,0,0,1-.07.26.41.41,0,0,1-.14.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19V210l-1.09,1.94a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "148.287px 211.707px"
    },
    id: "el7rhwf1qvw3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.93,207.33c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.85,5.85,0,0,1-.35,1.23,4.62,4.62,0,0,1-.64,1,3.47,3.47,0,0,1-.94.79,1.77,1.77,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.84,1.84,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1,3.31,3.31,0,0,1,1-.81,1.87,1.87,0,0,1,.94-.3.84.84,0,0,1,.64.31,1.9,1.9,0,0,1,.35.81A6.89,6.89,0,0,1,154.93,207.33Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.41.23.77,0a1.75,1.75,0,0,0,.76-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S151.82,210.87,151.83,211.16Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "152.845px 209.585px"
    },
    id: "elgii2amuqdm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.73,206.46a.36.36,0,0,1,0-.22.87.87,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "157.137px 206.59px"
    },
    id: "eloykt9m7eogc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.77,202.22c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,2,2,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.77,6.77,0,0,1,163.77,202.22Zm-3.09,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S160.67,205.77,160.68,206.06Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "161.685px 204.455px"
    },
    id: "eltmzu2pna65q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.57,201.35a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.31.31,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19V205a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.35a.11.11,0,0,1-.15,0,.24.24,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "165.977px 201.487px"
    },
    id: "el2yk3nh5nqxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.62,197.12v2.11a9.65,9.65,0,0,1-.14,1.34,5.31,5.31,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.09,10.09,0,0,1,.14-1.37A5.54,5.54,0,0,1,169,197a4.61,4.61,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,172.62,197.12Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.16.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.65,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.77,1.77,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S169.51,200.66,169.52,201Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "170.531px 199.365px"
    },
    id: "el3wqupcma9n1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.79,194.13c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.82A6.66,6.66,0,0,1,177.79,194.13Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.88,4.88,0,0,0-.27,1.47c0,.3,0,.64,0,1S174.68,197.67,174.69,198Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "175.72px 196.365px"
    },
    id: "elr18lkm3jjeq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,191.14v2.11a11.41,11.41,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.91.91,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A7.79,7.79,0,0,1,183,191.14Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.72,1.72,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S179.85,194.69,179.87,195Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "180.91px 193.375px"
    },
    id: "elfq4fginvsk7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.76,190.27a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19V194a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "185.167px 190.45px"
    },
    id: "elv06kugu4sb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.81,186v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.85.85,0,0,1-.63-.32,1.91,1.91,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12.23,12.23,0,0,1,.13-1.37,6.14,6.14,0,0,1,.36-1.24,4.31,4.31,0,0,1,.63-1,3.27,3.27,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.84,1.84,0,0,1,.35.81A6.83,6.83,0,0,1,191.81,186Zm-3.1,3.84A2.33,2.33,0,0,0,189,191c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S188.7,189.58,188.71,189.88Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "189.715px 188.255px"
    },
    id: "elyux0lncum7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.6,185.17a.28.28,0,0,1,0-.21.47.47,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.51.51,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.23.23,0,0,1,.06.18v7.65a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36c-.06,0-.1,0-.14,0a.22.22,0,0,1-.07-.19V183.6l-1.09,2a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "194px 185.3px"
    },
    id: "eltc0lt0ezb2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.27,183.05a.33.33,0,0,1-.05-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "197.635px 183.195px"
    },
    id: "el730psb3rki3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.93,180.93a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.37.37,0,0,1,.14-.14l.6-.35a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.63.63,0,0,1-.21.44l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "201.337px 181.081px"
    },
    id: "elnyebujk27o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.6,178.81a.28.28,0,0,1,0-.21.65.65,0,0,1,.08-.26l1.67-3a2,2,0,0,1,.12-.21.53.53,0,0,1,.15-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.1,1.95a.27.27,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "205px 178.95px"
    },
    id: "elgzwp7wfkyol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.65,174.58c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.8,9.8,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.83,1.83,0,0,1-1,.31.87.87,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.54,3.54,0,0,1,1-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.82A6.66,6.66,0,0,1,211.65,174.58Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S208.54,178.12,208.55,178.42Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "209.56px 176.815px"
    },
    id: "elgi02lmiqsb6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.44,173.71a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.64a.48.48,0,0,1-.07.26.39.39,0,0,1-.14.18l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "213.847px 173.857px"
    },
    id: "el1jjv09hjm8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.49,169.48c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.47,5.47,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.37,3.37,0,0,1-1,.79,1.81,1.81,0,0,1-.95.3.84.84,0,0,1-.63-.31,2,2,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.13,6.13,0,0,1,.35-1.24,4.8,4.8,0,0,1,.63-1,3.4,3.4,0,0,1,.95-.81,1.83,1.83,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.89,6.89,0,0,1,220.49,169.48Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.22.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.65,0,1S217.38,173,217.39,173.31Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "218.4px 171.735px"
    },
    id: "el4iaqplassqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.28,168.6a.33.33,0,0,1,0-.21.87.87,0,0,1,.08-.26l1.67-3c0-.08.09-.14.13-.21a.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V167l-1.09,2a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "222.687px 168.74px"
    },
    id: "elt55orhkr12",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.33,164.37c0,.15,0,.31,0,.49V166c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.3,3.3,0,0,1-.94.79,1.86,1.86,0,0,1-1,.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.87,4.87,0,0,1,.63-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.94-.31.88.88,0,0,1,.64.31,1.88,1.88,0,0,1,.35.82A6.66,6.66,0,0,1,229.33,164.37Zm-3.09,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S226.23,167.91,226.24,168.21Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "227.245px 166.625px"
    },
    id: "el51l2se893f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.13,163.5a.28.28,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.36.36,0,0,1-.15.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "231.535px 163.647px"
    },
    id: "elf1i08banu1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.18,159.27v2.1a9.63,9.63,0,0,1-.14,1.35,5.31,5.31,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,2,2,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,238.18,159.27Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S235.07,162.81,235.08,163.1Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "236.09px 161.5px"
    },
    id: "eldqrqg9ciil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,158.4a.3.3,0,0,1,0-.22.52.52,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "240.4px 158.53px"
    },
    id: "elpi89cmehmp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.05,250.91V253a11.41,11.41,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1A10,10,0,0,1,100,252a5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.91.91,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A7.79,7.79,0,0,1,104.05,250.91Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S100.94,254.46,101,254.75Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "101.935px 253.13px"
    },
    id: "elsofjk4pxmx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.79,250.07a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.21a.51.51,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.1.1,0,0,1-.14,0,.22.22,0,0,1-.07-.19v-5.84l-1.09,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "106.19px 250.216px"
    },
    id: "elexyxkzaqc55",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.41,248a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.36.36,0,0,1-.15.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "109.81px 248.147px"
    },
    id: "elzw038ax9cki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,245.89a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "113.407px 246.04px"
    },
    id: "elhyay3rgtvqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,241.69v2.1a9.63,9.63,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,4,4,0,0,1-.63,1,3.52,3.52,0,0,1-1,.8,1.83,1.83,0,0,1-.95.3.81.81,0,0,1-.63-.31,2,2,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12,12,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.13,4.13,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.78,1.78,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,120,241.69Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S116.92,245.23,116.93,245.52Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "117.905px 243.93px"
    },
    id: "el0uir49ioouf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.77,240.84a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21a.64.64,0,0,1,.15-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.54.54,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85l-1.1,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "122.17px 240.99px"
    },
    id: "eldprwl0veso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.77,236.64c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.32,5.32,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.72,1.72,0,0,1-1,.3.81.81,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.4,3.4,0,0,1,1-.81,1.9,1.9,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.89,6.89,0,0,1,128.77,236.64Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S125.66,240.18,125.67,240.47Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "126.655px 238.895px"
    },
    id: "elkty7m3t29w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.9,233.68c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.74,1.74,0,0,1-1,.3.81.81,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.09,10.09,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,133.9,233.68Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.16.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.32,2.32,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.77,1.77,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S130.79,237.22,130.8,237.52Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "131.805px 235.905px"
    },
    id: "elisirdlga7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,230.72c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.83,1.83,0,0,1-.95.31.86.86,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.54,5.54,0,0,1,.35-1.24,4.65,4.65,0,0,1,.63-1.05,3.21,3.21,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,1.9,1.9,0,0,1,.36.81A6.89,6.89,0,0,1,139,230.72Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S135.91,234.26,135.92,234.56Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "136.91px 232.95px"
    },
    id: "elcwdoge7300v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.77,229.88a.34.34,0,0,1-.05-.22.87.87,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "141.134px 230.01px"
    },
    id: "elduwilwg7sw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.77,225.67v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.91,1.91,0,0,1-.36-.81,8,8,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a11.83,11.83,0,0,1,.13-1.36,5.78,5.78,0,0,1,.36-1.24,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.81,1.81,0,0,1,1-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,147.77,225.67Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.61,4.61,0,0,0-.26,1.47c0,.3,0,.64,0,1S144.66,229.21,144.67,229.51Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "145.675px 227.905px"
    },
    id: "el826z6nk8i64",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.51,224.83a.29.29,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.59-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.1,2a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "149.909px 224.961px"
    },
    id: "elddyfw66e8v7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,220.62c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A6.77,6.77,0,0,1,156.51,220.62Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S153.4,224.16,153.41,224.46Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "154.44px 222.855px"
    },
    id: "elevxee5ibrgw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25,219.78a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "158.657px 219.923px"
    },
    id: "eltlpqyq96i2q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.26,215.57v2.11a11.41,11.41,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,2,2,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A7.79,7.79,0,0,1,165.26,215.57Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S162.15,219.12,162.16,219.41Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "163.17px 217.805px"
    },
    id: "eldn4wh7uwt09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.38,212.61c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.75,1.75,0,0,1-.95.31.85.85,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.54,3.54,0,0,1,.95-.8,1.72,1.72,0,0,1,.95-.3.83.83,0,0,1,.63.3,1.89,1.89,0,0,1,.36.82A6.88,6.88,0,0,1,170.38,212.61Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.69,1.69,0,0,0,.77-.91,4.61,4.61,0,0,0,.26-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S167.27,216.16,167.28,216.45Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "168.31px 214.85px"
    },
    id: "elsi4aeh7b1td",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51,209.65v2.11a9.63,9.63,0,0,1-.14,1.35,5.23,5.23,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.72,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.22,4.22,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.82,6.82,0,0,1,175.51,209.65Zm-3.1,3.84a2.37,2.37,0,0,0,.26,1.17c.16.22.41.23.77,0a1.69,1.69,0,0,0,.76-.9,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.77,1.77,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S172.4,213.2,172.41,213.49Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "173.42px 211.89px"
    },
    id: "el482dtkndzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25,208.81a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21a.46.46,0,0,1,.14-.14l.61-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.54.54,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.2.2,0,0,1-.07-.18v-5.85l-1.09,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "177.65px 208.96px"
    },
    id: "elk2c0q5chcwp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.25,204.61c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.23,4,4,0,0,1-.63,1,3.37,3.37,0,0,1-.95.8,1.81,1.81,0,0,1-1,.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1,3.4,3.4,0,0,1,1-.81,1.81,1.81,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.89,6.89,0,0,1,184.25,204.61Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.65,0,1S181.14,208.15,181.15,208.44Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "182.155px 206.875px"
    },
    id: "elh8sa7b33jdu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,203.76a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21A.47.47,0,0,1,187,200l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.46.46,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19V202.2l-1.09,1.94a.33.33,0,0,1-.15.16.15.15,0,0,1-.15-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "186.397px 203.97px"
    },
    id: "el7uw126x8wni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,199.56v2.1a9.63,9.63,0,0,1-.14,1.35,5.31,5.31,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.91,1.91,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,193,199.56Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.65,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S189.89,203.1,189.9,203.39Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "190.91px 201.79px"
    },
    id: "eldkw92h9ki6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.74,198.71a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.21a.36.36,0,0,1,.15-.15l.59-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.26.26,0,0,1-.15.16.12.12,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "195.14px 198.85px"
    },
    id: "elzo6egan6bah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.74,194.51c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a11.87,11.87,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.09,3.09,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.81A8,8,0,0,1,201.74,194.51Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S198.63,198.05,198.64,198.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "199.645px 196.765px"
    },
    id: "elyob2yylu8w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.48,193.67a.35.35,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.11.11,0,0,1,.14,0,.24.24,0,0,1,.07.19v7.65a.51.51,0,0,1-.07.26.39.39,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V192.1l-1.09,2a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "203.887px 193.801px"
    },
    id: "eltdvfw892pyg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.48,189.46c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10,10,0,0,1,.13-1.36,5.26,5.26,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.42,3.42,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.66,6.66,0,0,1,210.48,189.46Zm-3.09,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.61,4.61,0,0,0-.26,1.47c0,.3,0,.64,0,1S207.38,193,207.39,193.3Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "208.37px 191.695px"
    },
    id: "el55skkycxkb3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.61,186.5c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a11.65,11.65,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31A.87.87,0,0,1,212,193a1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.82A7.73,7.73,0,0,1,215.61,186.5Zm-3.1,3.84a2.38,2.38,0,0,0,.27,1.17c.15.22.4.23.76,0a1.77,1.77,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.4,2.4,0,0,0-.26-1.17c-.16-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S212.5,190,212.51,190.34Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "213.563px 188.75px"
    },
    id: "eltmi6rrpytn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.35,185.66a.33.33,0,0,1,0-.21.57.57,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.1.1,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.64a.48.48,0,0,1-.07.26.34.34,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85L217,186a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "217.757px 185.804px"
    },
    id: "el8o9m74dt7lg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.35,181.45c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.91.91,0,0,1,.63.31,2,2,0,0,1,.35.82A6.77,6.77,0,0,1,224.35,181.45Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S221.24,185,221.25,185.29Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "222.24px 183.685px"
    },
    id: "el9fmazi2r69k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.48,178.49c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A8,8,0,0,1,229.48,178.49Zm-3.1,3.84a2.38,2.38,0,0,0,.27,1.17c.15.22.4.23.76,0a1.69,1.69,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S226.37,182,226.38,182.33Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "227.385px 180.725px"
    },
    id: "el2m1qyhjct91",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.22,177.65a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.14,0,.26.26,0,0,1,.07.19v7.65a.68.68,0,0,1-.07.26.41.41,0,0,1-.14.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84L230.88,178a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "231.627px 177.797px"
    },
    id: "eldo07f0415mh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.22,173.44c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.23,5.23,0,0,1-.35,1.22,3.93,3.93,0,0,1-.64,1,3.3,3.3,0,0,1-.94.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.9,1.9,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.22,4.22,0,0,1,.62-1,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,.94-.3.83.83,0,0,1,.64.31,1.79,1.79,0,0,1,.35.81A6.88,6.88,0,0,1,238.22,173.44Zm-3.09,3.84a2.37,2.37,0,0,0,.26,1.17c.15.22.41.23.77,0a1.73,1.73,0,0,0,.76-.9,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S235.12,177,235.13,177.28Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "236.135px 175.705px"
    },
    id: "elb22qq66x27",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,172.6a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18V171L239.62,173a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "240.4px 172.75px"
    },
    id: "elan2em8t1mtm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.05,265.12v2.11a11.86,11.86,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.87.87,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A7.93,7.93,0,0,1,104.05,265.12ZM101,269a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91A4.68,4.68,0,0,0,101,267c0,.3,0,.64,0,1S100.94,268.66,101,269Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "101.935px 267.375px"
    },
    id: "ellkp01dy0fe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,262.16c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a11.87,11.87,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.31,5.31,0,0,1,.35-1.23,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.82A7.73,7.73,0,0,1,109.17,262.16Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.82,4.82,0,0,0-.27,1.47c0,.3,0,.64,0,1S106.06,265.7,106.07,266Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "107.075px 264.395px"
    },
    id: "elq1w3tryir6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,259.2v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.91,1.91,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10,10,0,0,1,.13-1.36,5.78,5.78,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.42,3.42,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,114.3,259.2ZM111.2,263a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.3,0,.64,0,1S111.19,262.74,111.2,263Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "112.185px 261.435px"
    },
    id: "el9qd00fabp7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,258.36a.28.28,0,0,1,0-.21.47.47,0,0,1,.08-.26l1.67-3,.12-.21a.51.51,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19V262a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.14,0,.22.22,0,0,1-.07-.19v-5.85l-1.09,1.95a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "116.4px 258.493px"
    },
    id: "elv9v04odiyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,254.15c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.83,1.83,0,0,1,1-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A7.87,7.87,0,0,1,123,254.15Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S119.93,257.69,119.94,258Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "120.88px 256.385px"
    },
    id: "elidka8vc1gq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.78,253.31a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.1.1,0,0,1,.14,0,.26.26,0,0,1,.07.19V257a.59.59,0,0,1-.07.26.39.39,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "125.187px 253.469px"
    },
    id: "ellx32s8bgh2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.78,249.1c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.37,4.37,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.89.89,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.77,6.77,0,0,1,131.78,249.1Zm-3.09,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S128.68,252.65,128.69,252.94Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "129.695px 251.335px"
    },
    id: "elrjy04gzah7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.91,246.14c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4,4,0,0,1,.63-1.05,3.27,3.27,0,0,1,1-.81,1.72,1.72,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.88,6.88,0,0,1,136.91,246.14Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.69,1.69,0,0,0,.77-.91,4.61,4.61,0,0,0,.26-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S133.8,249.69,133.81,250Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "134.815px 248.38px"
    },
    id: "elk3ex7bivlz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,243.19c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.23,5.23,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.31,3.31,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,2,2,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24A4.4,4.4,0,0,1,139,242a3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.89,6.89,0,0,1,142,243.19ZM138.94,247a2.37,2.37,0,0,0,.26,1.17c.15.22.41.23.77,0a1.69,1.69,0,0,0,.76-.9,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S138.93,246.73,138.94,247Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "139.916px 245.425px"
    },
    id: "elf2ej2r9jege",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.78,242.34a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.46.46,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19V246a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.14,0,.2.2,0,0,1-.07-.18v-5.85l-1.09,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "144.18px 242.484px"
    },
    id: "elthku6igci6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.78,238.14c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.74,1.74,0,0,1-1,.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1,3.27,3.27,0,0,1,1-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,150.78,238.14Zm-3.1,3.83a2.32,2.32,0,0,0,.27,1.17c.15.22.4.23.76,0a1.77,1.77,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.16-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.65,0,1S147.67,241.68,147.68,242Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "148.685px 240.395px"
    },
    id: "elk98g6ckot6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,235.18v2.1a9.63,9.63,0,0,1-.14,1.35,5.31,5.31,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.91,1.91,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,155.91,235.18Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S152.8,238.72,152.81,239Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "153.82px 237.41px"
    },
    id: "eldqrz96c9qa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,232.22c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a11.87,11.87,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24A4.31,4.31,0,0,1,158,231a3.27,3.27,0,0,1,1-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,2,2,0,0,1,.36.81A8,8,0,0,1,161,232.22Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S157.92,235.76,157.93,236.06Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "158.906px 234.445px"
    },
    id: "elgrfsrodm0zw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.77,231.37a.33.33,0,0,1,0-.21.87.87,0,0,1,.08-.26l1.67-3a1.07,1.07,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "163.177px 231.51px"
    },
    id: "el1qxc79ly3pgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.77,227.17c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.91,1.91,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.86,5.86,0,0,1,.36-1.23,4.47,4.47,0,0,1,.62-1.06,3.42,3.42,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.89,6.89,0,0,1,169.77,227.17ZM166.68,231a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.7,1.7,0,0,0-.77.9,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S166.67,230.71,166.68,231Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "167.685px 229.405px"
    },
    id: "elv55hy7zsg0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.9,224.21c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,1-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.82A6.66,6.66,0,0,1,174.9,224.21Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.88,4.88,0,0,0-.27,1.47c0,.3,0,.64,0,1S171.79,227.75,171.8,228.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "172.805px 226.445px"
    },
    id: "elvxe0qfoi8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.64,223.37a.35.35,0,0,1,0-.22.73.73,0,0,1,.08-.25l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.24.24,0,0,1,.07.19v7.65a.48.48,0,0,1-.07.26.39.39,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V221.8l-1.09,1.95a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "177.047px 223.512px"
    },
    id: "elmoz9q5w9cc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.64,219.16c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,3.84,3.84,0,0,1-.64,1,3.3,3.3,0,0,1-.94.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,2,2,0,0,1-.36-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36A6,6,0,0,1,180,219a4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.94-.31.88.88,0,0,1,.64.31,1.88,1.88,0,0,1,.35.82A6.77,6.77,0,0,1,183.64,219.16ZM180.55,223a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S180.54,222.7,180.55,223Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "181.555px 221.385px"
    },
    id: "elxq4s2g8exs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.39,218.32a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19V222a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85L185,218.7c0,.08-.09.13-.15.15a.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "185.79px 218.473px"
    },
    id: "el0viy50yu0stb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.39,214.11c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,192.39,214.11Zm-3.1,3.84a2.38,2.38,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.16-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S189.28,217.66,189.29,218Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "190.295px 216.345px"
    },
    id: "el4nnd7pw2tnd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.13,213.27a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34c.06,0,.1,0,.14,0a.22.22,0,0,1,.07.19V217a.48.48,0,0,1-.07.26.34.34,0,0,1-.14.18l-.63.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "194.537px 213.464px"
    },
    id: "el02bw8jdo1d63",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.13,209.06c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.23,5.23,0,0,1-.35,1.22,4.5,4.5,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.22,4.22,0,0,1,.62-1,3.45,3.45,0,0,1,1-.81,1.7,1.7,0,0,1,1-.3.84.84,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.88,6.88,0,0,1,201.13,209.06ZM198,212.9a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.72,1.72,0,0,0,.76-.91,4.88,4.88,0,0,0,.27-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S198,212.61,198,212.9Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "199.02px 211.325px"
    },
    id: "el9838wg8e88i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.88,208.22a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "203.287px 208.37px"
    },
    id: "elasziei2mk3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.49,206.13a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "206.897px 206.28px"
    },
    id: "elkh4o07kglgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5,201.93V204a9.63,9.63,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.74,1.74,0,0,1-1,.3.81.81,0,0,1-.63-.31,2,2,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12,12,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,213.5,201.93Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.16.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.24-.76,0a1.77,1.77,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.65,0,1S210.39,205.47,210.4,205.76Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "211.405px 204.13px"
    },
    id: "el6n4wxwx06xc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,201.08a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21a.64.64,0,0,1,.15-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85l-1.1,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "215.64px 201.23px"
    },
    id: "el9pgy87mcqr7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.24,196.88c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.51a10,10,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.72,1.72,0,0,1-.95.3.82.82,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.13-1.37,5.54,5.54,0,0,1,.35-1.24,4.65,4.65,0,0,1,.63-1.05,3.4,3.4,0,0,1,.95-.81,1.9,1.9,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.89,6.89,0,0,1,222.24,196.88Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S219.13,200.42,219.14,200.72Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "220.15px 199.105px"
    },
    id: "elyd7q71d9l3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,196a.33.33,0,0,1,0-.21.87.87,0,0,1,.08-.26l1.67-3a1.07,1.07,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "224.407px 196.14px"
    },
    id: "el9psdvx84vhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,191.83v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.91,1.91,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.86,5.86,0,0,1,.36-1.23,4.47,4.47,0,0,1,.62-1.06,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.83,6.83,0,0,1,231,191.83Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.7,1.7,0,0,0-.77.9,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S227.88,195.37,227.89,195.67Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "228.885px 194.06px"
    },
    id: "el9n0pua0flmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.73,191a.29.29,0,0,1,0-.22.52.52,0,0,1,.08-.26l1.67-3,.12-.21a.51.51,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.14,0,.22.22,0,0,1-.07-.19v-5.85l-1.09,2a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "233.13px 191.131px"
    },
    id: "elexdh6gn3oro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.35,188.9a.29.29,0,0,1,0-.22.52.52,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85L236,189.28a.31.31,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "236.75px 189.031px"
    },
    id: "elsepzpxpbp1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,186.81a.28.28,0,0,1,0-.21.47.47,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "240.4px 186.96px"
    },
    id: "el3s4dio54p4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,281.44a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.54.54,0,0,1-.07.26.41.41,0,0,1-.14.17l-.63.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "101.067px 281.587px"
    },
    id: "eleo35gqhbohi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.58,277.28c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.83,1.83,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.54,3.54,0,0,1,1-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A6.77,6.77,0,0,1,107.58,277.28Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S104.47,280.83,104.48,281.12Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "105.485px 279.515px"
    },
    id: "elounlw8dygd8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.24,276.49a.35.35,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.24.24,0,0,1,.07.19v7.65a.48.48,0,0,1-.07.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "109.647px 276.621px"
    },
    id: "elb08xbonfju4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.16,272.33c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.83,1.83,0,0,1-1,.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.21,3.21,0,0,1,1-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.81A6.89,6.89,0,0,1,116.16,272.33Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S113.05,275.87,113.06,276.17Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "114.04px 274.56px"
    },
    id: "elwrhyq2tbjan",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.82,271.53a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a1.37,1.37,0,0,1,.13-.2.41.41,0,0,1,.14-.15l.6-.35a.11.11,0,0,1,.14,0,.26.26,0,0,1,.07.19v7.65a.63.63,0,0,1-.07.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19V270l-1.1,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "118.227px 271.68px"
    },
    id: "elxrghqjndn9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.74,267.38c0,.14,0,.31,0,.49V269c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.23,4,4,0,0,1-.63,1,3.37,3.37,0,0,1-1,.8,1.83,1.83,0,0,1-1,.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1.05,3.27,3.27,0,0,1,1-.81,1.81,1.81,0,0,1,1-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.89,6.89,0,0,1,124.74,267.38Zm-3.1,3.83a2.47,2.47,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S121.63,270.92,121.64,271.21Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "122.62px 269.64px"
    },
    id: "elbm4mg548vpf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.78,264.46c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.21,4.21,0,0,1-.64,1,3.3,3.3,0,0,1-.94.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.22,4.22,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.69,1.69,0,0,1,.94-.3.87.87,0,0,1,.64.3,2,2,0,0,1,.35.82A6.88,6.88,0,0,1,129.78,264.46Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.72,1.72,0,0,0,.76-.91,4.88,4.88,0,0,0,.27-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S126.68,268,126.68,268.3Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "127.695px 266.7px"
    },
    id: "elzy2jgad376f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.44,263.67a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V262.1l-1.09,1.95a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "131.847px 263.813px"
    },
    id: "elfrjfd0ig7i5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.36,259.51c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10,10,0,0,1,.13-1.36,5.26,5.26,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.42,3.42,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.35.82A6.66,6.66,0,0,1,138.36,259.51Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.3,0,.64,0,1S135.26,263.05,135.26,263.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "136.275px 261.745px"
    },
    id: "eltnxki0bvz4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,258.71a.33.33,0,0,1,0-.21.87.87,0,0,1,.08-.26l1.67-3a1.07,1.07,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.11.11,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "140.407px 258.85px"
    },
    id: "elib1bk3i0y3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.94,254.56c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.35,1.23,5,5,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.84,1.84,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,1-.3.84.84,0,0,1,.63.31,1.9,1.9,0,0,1,.35.81A6.89,6.89,0,0,1,146.94,254.56Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.41.23.77,0a1.75,1.75,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S143.83,258.1,143.84,258.39Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "144.83px 256.79px"
    },
    id: "el77j9g42p072",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.6,253.76a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.31.31,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.35a.11.11,0,0,1-.15,0,.24.24,0,0,1-.06-.19V252.2l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "149.007px 253.907px"
    },
    id: "el6vmqvdorwje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.52,249.6c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.21,3.21,0,0,1-1,.79,1.81,1.81,0,0,1-.95.31.85.85,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.71,3.71,0,0,1,.95-.8,1.86,1.86,0,0,1,1-.31.87.87,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.77,6.77,0,0,1,155.52,249.6Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.76,0a1.69,1.69,0,0,0,.77-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S152.41,253.15,152.42,253.44Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "153.43px 251.835px"
    },
    id: "eluwtl0fylwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.18,248.81a.33.33,0,0,1,0-.21.72.72,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "157.587px 248.953px"
    },
    id: "elr4aybqfkf3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72,246.77a.29.29,0,0,1,0-.22.52.52,0,0,1,.08-.26l1.67-3,.12-.21a.53.53,0,0,1,.15-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19V245.2l-1.1,2a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "161.12px 246.9px"
    },
    id: "elo9e6lw7rzxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.64,242.61c0,.15,0,.31,0,.49v1.11c0,.18,0,.35,0,.51a11.87,11.87,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.74,1.74,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.09,10.09,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.9,1.9,0,0,1,1-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,167.64,242.61Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S164.53,246.15,164.54,246.45Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "165.545px 244.86px"
    },
    id: "el94286744hal",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3,241.81a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21a.64.64,0,0,1,.15-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.54.54,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.23.23,0,0,1-.06-.18v-5.85l-1.1,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "169.7px 241.96px"
    },
    id: "elfqx8e25ewdi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.22,237.65c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,5.77,5.77,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4,4,0,0,1,.63-1.05,3.27,3.27,0,0,1,1-.81,1.72,1.72,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,176.22,237.65Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.69,1.69,0,0,0,.77-.91,4.61,4.61,0,0,0,.26-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S173.11,241.2,173.12,241.49Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "174.125px 239.89px"
    },
    id: "eli75u7e762gn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.88,236.86a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.53.53,0,0,1,.15-.15l.6-.34a.1.1,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.1,2a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "178.28px 237.003px"
    },
    id: "elgj62w9q8yv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.42,234.82a.29.29,0,0,1,0-.22.52.52,0,0,1,.08-.26l1.66-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "181.82px 234.951px"
    },
    id: "elgzkdnide11u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.34,230.66v2.11a11.86,11.86,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.91,1.91,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12.23,12.23,0,0,1,.13-1.37,6.14,6.14,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A7.93,7.93,0,0,1,188.34,230.66Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S185.23,234.2,185.24,234.5Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "186.25px 232.89px"
    },
    id: "elsuojf5dzcrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,229.86a.33.33,0,0,1-.05-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.39.39,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19V228.3l-1.09,1.94a.33.33,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "190.365px 230.01px"
    },
    id: "elqngzw6wjkcd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.53,227.82a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.31.31,0,0,1,.14-.14l.6-.35c.06,0,.1,0,.14,0a.22.22,0,0,1,.07.19v7.65a.54.54,0,0,1-.07.26.44.44,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "193.937px 227.983px"
    },
    id: "elzjiumilcbfn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.45,223.66c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.21,3.21,0,0,1-1,.79,1.83,1.83,0,0,1-.95.31.87.87,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.39,5.39,0,0,1,.35-1.24,4.87,4.87,0,0,1,.63-1.06,3.54,3.54,0,0,1,.95-.8,1.86,1.86,0,0,1,1-.31.91.91,0,0,1,.64.31,2,2,0,0,1,.35.82A6.77,6.77,0,0,1,200.45,223.66Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.76,0a1.69,1.69,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S197.34,227.21,197.35,227.5Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "198.36px 225.895px"
    },
    id: "elj5zmc1lfvfq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.11,222.87a.33.33,0,0,1,0-.21.57.57,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.1.1,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.64a.48.48,0,0,1-.07.26.34.34,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V221.3l-1.09,1.95a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "202.517px 223.014px"
    },
    id: "el4oiu02nujt7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.65,220.83a.3.3,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.1,2a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "206.05px 220.96px"
    },
    id: "elk831ox924bj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.57,216.67c0,.15,0,.31,0,.49v1.11c0,.18,0,.35,0,.51a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.74,1.74,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.09,10.09,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,212.57,216.67Zm-3.1,3.84a2.31,2.31,0,0,0,.27,1.16c.15.23.4.23.76,0a1.77,1.77,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.16-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,4.66,4.66,0,0,0-.27,1.48c0,.3,0,.64,0,1S209.46,220.21,209.47,220.51Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "210.5px 218.92px"
    },
    id: "elj5vkycs1ku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.61,213.76c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.47,5.47,0,0,1-.36,1.23,4,4,0,0,1-.63,1,3.24,3.24,0,0,1-1,.8,1.81,1.81,0,0,1-.95.3.84.84,0,0,1-.63-.31,2,2,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.13,6.13,0,0,1,.35-1.24,4.8,4.8,0,0,1,.63-1,3.4,3.4,0,0,1,.95-.81,1.83,1.83,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.89,6.89,0,0,1,217.61,213.76Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.22.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S214.5,217.3,214.51,217.59Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "215.52px 216.025px"
    },
    id: "elelav4uvzira",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.27,213a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.54.54,0,0,1-.07.26.41.41,0,0,1-.14.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19V211.4l-1.09,1.94a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "219.677px 213.147px"
    },
    id: "el4gxi83abo69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.81,210.92a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.6-.34a.1.1,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.1.1,0,0,1-.14,0,.26.26,0,0,1-.07-.19v-5.84l-1.09,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "223.21px 211.065px"
    },
    id: "els4xe5uraxsh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.73,206.76c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.79,9.79,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.87.87,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.81,1.81,0,0,1,1-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,229.73,206.76Zm-3.1,3.84a2.52,2.52,0,0,0,.26,1.17c.16.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.38,2.38,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,5,5,0,0,0-.26,1.47c0,.31,0,.64,0,1S226.62,210.3,226.63,210.6Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "227.635px 208.995px"
    },
    id: "ely1yyv7cynlg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.77,203.85c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.83,1.83,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.21,3.21,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.81A6.89,6.89,0,0,1,234.77,203.85Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.75,1.75,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S231.66,207.39,231.67,207.69Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "232.68px 206.08px"
    },
    id: "el954hscgrhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.43,203.05a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.51.51,0,0,1-.07.26.39.39,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.14.14,0,0,1-.15-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "236.837px 203.201px"
    },
    id: "ell1qc0zym1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,201a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.39.39,0,0,1,.15-.14l.59-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.14,0,.23.23,0,0,1-.06-.18v-5.85l-1.1,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "240.4px 201.149px"
    },
    id: "el16zom3ql751",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.05,293.53v2.11a11.86,11.86,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.32,5.32,0,0,1,.36-1.23,4.47,4.47,0,0,1,.62-1.06,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.87.87,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A7.93,7.93,0,0,1,104.05,293.53Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.76,1.76,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S100.94,297.07,101,297.37Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "101.935px 295.76px"
    },
    id: "ela6pbsd78vet",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,290.57c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5A11.87,11.87,0,0,1,109,294a6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.82A7.73,7.73,0,0,1,109.17,290.57Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.88,4.88,0,0,0-.27,1.47c0,.3,0,.64,0,1S106.06,294.11,106.07,294.41Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "107.055px 292.775px"
    },
    id: "elb81ft4lfls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,289.73a.35.35,0,0,1,0-.22.87.87,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.14.14,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "111.316px 289.862px"
    },
    id: "elsl3jf7bkumq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.91,285.52c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.77,6.77,0,0,1,117.91,285.52Zm-3.09,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S114.8,289.06,114.82,289.36Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "115.8px 287.755px"
    },
    id: "elx58626gevt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.66,284.68a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "120.06px 284.823px"
    },
    id: "elmho82k833aq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.66,280.47c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31A.84.84,0,0,1,123,287a1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,126.66,280.47Zm-3.1,3.84a2.52,2.52,0,0,0,.26,1.17c.16.22.41.23.77,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.16-.22-.41-.23-.77,0a1.77,1.77,0,0,0-.77.91,5,5,0,0,0-.26,1.47c0,.31,0,.64,0,1S123.55,284,123.56,284.31Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "124.588px 282.735px"
    },
    id: "elftycisax8u8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.78,277.51c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.37,4.37,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.89.89,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.88,6.88,0,0,1,131.78,277.51Zm-3.09,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.88,4.88,0,0,0,.27-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S128.68,281.06,128.69,281.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "129.695px 279.745px"
    },
    id: "elm92i18p19em",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.91,274.55c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.77,5.77,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4,4,0,0,1,.63-1,3.27,3.27,0,0,1,1-.81,1.72,1.72,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.88,6.88,0,0,1,136.91,274.55Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.7,1.7,0,0,0,.77-.9,4.73,4.73,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S133.8,278.1,133.81,278.39Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "134.815px 276.815px"
    },
    id: "eliia0ei6mqsj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.65,273.71a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.37.37,0,0,1,.14-.14l.6-.35a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.63.63,0,0,1-.21.44l-.63.36a.11.11,0,0,1-.14,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "139.057px 273.86px"
    },
    id: "elau5tdfqynwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.27,271.62a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.63.63,0,0,1-.21.44l-.63.36a.12.12,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85L141.93,272c-.05.08-.1.14-.15.15a.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "142.677px 271.769px"
    },
    id: "elgsryrj4htfu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.27,267.42c0,.14,0,.31,0,.49V269c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.85,5.85,0,0,1-.35,1.23,4.62,4.62,0,0,1-.64,1,3.47,3.47,0,0,1-.94.79,1.77,1.77,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.74,1.74,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.07,5.07,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.31,3.31,0,0,1,1-.81,1.87,1.87,0,0,1,.94-.3.84.84,0,0,1,.64.31,1.9,1.9,0,0,1,.35.81A6.89,6.89,0,0,1,149.27,267.42Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.41.23.77,0a1.75,1.75,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S146.16,271,146.17,271.25Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "147.185px 269.63px"
    },
    id: "elhvs0hdwaguj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.4,264.46c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,5.86,5.86,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.74,1.74,0,0,1-1,.3.81.81,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,1-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,154.4,264.46Zm-3.1,3.83a2.32,2.32,0,0,0,.27,1.17c.15.23.4.23.76,0a1.77,1.77,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.16-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,4.66,4.66,0,0,0-.27,1.48c0,.3,0,.64,0,1S151.29,268,151.3,268.29Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "152.305px 266.69px"
    },
    id: "elsa3wy6ivo5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.14,263.61a.28.28,0,0,1,0-.21.65.65,0,0,1,.08-.26l1.67-3A1.07,1.07,0,0,1,157,260a.41.41,0,0,1,.14-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85L155.8,264a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "156.53px 263.82px"
    },
    id: "el4ey39pds9fw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.14,259.41c0,.15,0,.31,0,.49V261c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.37,3.37,0,0,1-1,.79,1.83,1.83,0,0,1-.95.31.88.88,0,0,1-.63-.32,1.9,1.9,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,6.13,6.13,0,0,1,.35-1.24,5,5,0,0,1,.63-1.05,3.21,3.21,0,0,1,.95-.8,1.86,1.86,0,0,1,1-.31.84.84,0,0,1,.63.31,1.9,1.9,0,0,1,.36.81A6.89,6.89,0,0,1,163.14,259.41Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.75,1.75,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S160,263,160,263.25Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "161.05px 261.62px"
    },
    id: "elg8ai7dkoixk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.89,258.57a.36.36,0,0,1,0-.22.87.87,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V257L164.54,259a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "165.297px 258.7px"
    },
    id: "eleji78cimcpu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,256.48a.34.34,0,0,1,0-.22.87.87,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "168.916px 256.611px"
    },
    id: "el5483xawdae5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51,252.27v2.11a9.79,9.79,0,0,1-.14,1.35A5.37,5.37,0,0,1,175,257a4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.47,4.47,0,0,1,.62-1.06,3.42,3.42,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,175.51,252.27Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.16.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S172.4,255.81,172.41,256.11Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "173.41px 254.555px"
    },
    id: "elca0rj41xieq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.63,249.31c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.83,1.83,0,0,1-.95.31.85.85,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,5.93,5.93,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a8.59,8.59,0,0,1,.13-1.36,5.39,5.39,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.54,3.54,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.77,6.77,0,0,1,180.63,249.31Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S177.52,252.85,177.53,253.15Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "178.565px 251.545px"
    },
    id: "el00eja335scl2h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,248.47a.28.28,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V246.9L182,248.85a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "182.785px 248.613px"
    },
    id: "elof49103y6ti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.38,244.26v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,2,2,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,189.38,244.26Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S186.27,247.81,186.28,248.1Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "187.29px 246.495px"
    },
    id: "eltl5vh8y8qzr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.12,243.42a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.59-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.84l-1.1,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "191.52px 243.566px"
    },
    id: "el0dz2q2qe3zn8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.12,239.21c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.77,5.77,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4,4,0,0,1,.63-1.05,3.27,3.27,0,0,1,1-.81,1.72,1.72,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.88,6.88,0,0,1,198.12,239.21Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.69,1.69,0,0,0,.77-.91,4.61,4.61,0,0,0,.26-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S195,242.76,195,243.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "196.025px 241.45px"
    },
    id: "elyu5r2ko768",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.86,238.37a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.55.55,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "200.267px 238.52px"
    },
    id: "eli54hs5mn18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.86,234.17c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.46,5.46,0,0,1-.35,1.23,4,4,0,0,1-.63,1,3.52,3.52,0,0,1-.95.8,1.84,1.84,0,0,1-1,.3.8.8,0,0,1-.62-.31,2,2,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.4,4.4,0,0,1,.62-1,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.89,6.89,0,0,1,206.86,234.17ZM203.77,238a2.34,2.34,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S203.76,237.71,203.77,238Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "204.775px 236.435px"
    },
    id: "elpbqhnua7fmd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.61,233.32a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19V237a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "209.01px 233.475px"
    },
    id: "el5esijqk3hh7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.23,231.23a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,0,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.39.39,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "212.637px 231.38px"
    },
    id: "elsfpe8xtdgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.23,227c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.51a11.87,11.87,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.74,1.74,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.09,10.09,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.9,1.9,0,0,1,1-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,219.23,227Zm-3.1,3.84a2.31,2.31,0,0,0,.27,1.16c.15.23.4.23.76,0a1.77,1.77,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.65,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.16-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,4.66,4.66,0,0,0-.27,1.48c0,.3,0,.64,0,1S216.12,230.57,216.13,230.87Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "217.135px 229.225px"
    },
    id: "el7bkffl9qy2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.35,224.07c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.35.81A6.89,6.89,0,0,1,224.35,224.07Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S221.24,227.61,221.25,227.91Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "222.24px 226.325px"
    },
    id: "elet1ywdr91cv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.48,221.11c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a11.87,11.87,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.31,5.31,0,0,1,.35-1.23,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.81A8,8,0,0,1,229.48,221.11Zm-3.1,3.84a2.31,2.31,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.69,1.69,0,0,0-.76.9,4.66,4.66,0,0,0-.27,1.48c0,.3,0,.64,0,1S226.37,224.65,226.38,225Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "227.385px 223.345px"
    },
    id: "el5t8jxt8ianb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.22,220.27a.35.35,0,0,1,0-.22.87.87,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.27.27,0,0,1,.07.19V224a.63.63,0,0,1-.07.26.39.39,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V218.7l-1.09,2a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "231.626px 220.442px"
    },
    id: "elhdoltqbakj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.84,218.18a.35.35,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3,.12-.21a.53.53,0,0,1,.15-.15l.6-.35a.12.12,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.1,1.95a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "235.241px 218.311px"
    },
    id: "el2t3jmnt1f1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,214c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.8,9.8,0,0,1-.13,1.35,4.92,4.92,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.37,3.37,0,0,1-.95.79,1.81,1.81,0,0,1-1,.31.89.89,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.71,3.71,0,0,1,1-.8,1.86,1.86,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.78,1.78,0,0,1,.36.82A6.66,6.66,0,0,1,241.84,214Zm-3.1,3.84A2.5,2.5,0,0,0,239,219c.15.22.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.41-.23-.77,0a1.72,1.72,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S238.73,217.51,238.74,217.81Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "239.75px 216.235px"
    },
    id: "elrreoebk6ilh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.05,307.74v2.1a11.41,11.41,0,0,1-.14,1.35,5.23,5.23,0,0,1-.35,1.22,4.5,4.5,0,0,1-.63,1,3.31,3.31,0,0,1-1,.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.9,1.9,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.4,4.4,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,1-.3.84.84,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A7.93,7.93,0,0,1,104.05,307.74Zm-3.1,3.83a2.37,2.37,0,0,0,.26,1.17c.15.22.41.23.77,0a1.69,1.69,0,0,0,.76-.9,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S100.94,311.28,101,311.57Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "101.935px 309.97px"
    },
    id: "elybriku4v2vd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,304.78c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.23,4,4,0,0,1-.63,1,3.37,3.37,0,0,1-1,.8,1.83,1.83,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.81,1.81,0,0,1,1-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,109.17,304.78Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S106.06,308.32,106.07,308.61Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "107.075px 307.02px"
    },
    id: "el3m30s1vf9yz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,303.93a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.55.55,0,0,1-.15.18l-.62.36a.13.13,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.39.39,0,0,1-.15.16.15.15,0,0,1-.15-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "111.317px 304.079px"
    },
    id: "elwc8ytlwh6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.91,299.73c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.31,5.31,0,0,1-.35,1.23,5,5,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.79,1.79,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,1-.3.84.84,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.89,6.89,0,0,1,117.91,299.73Zm-3.09,3.83a2.34,2.34,0,0,0,.26,1.17c.15.23.41.23.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.65,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S114.8,303.27,114.82,303.56Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "115.8px 301.96px"
    },
    id: "elsibuuvkrc6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.66,298.88a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a1.93,1.93,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.12.12,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "120.06px 299.02px"
    },
    id: "eld90dy5ouvz7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28,296.79a.33.33,0,0,1,0-.21.87.87,0,0,1,.08-.26l1.67-3a1.93,1.93,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.12.12,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "123.687px 296.93px"
    },
    id: "elqfwbg42jix",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.28,292.59c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.09,3.09,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.83,6.83,0,0,1,130.28,292.59Zm-3.1,3.84a2.44,2.44,0,0,0,.26,1.16c.16.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.35,2.35,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.77,1.77,0,0,0-.77.91,5,5,0,0,0-.26,1.48c0,.3,0,.64,0,1S127.17,296.13,127.18,296.43Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "128.185px 294.82px"
    },
    id: "el44b4schuf1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,291.75a.35.35,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.1,1.95a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "132.401px 291.881px"
    },
    id: "elhktre54x5jh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,287.54c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.8,9.8,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.83,1.83,0,0,1-.95.31.89.89,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10,10,0,0,1,.13-1.36,5.26,5.26,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.37,3.37,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.66,6.66,0,0,1,139,287.54Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S135.91,291.08,135.92,291.38Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "136.91px 289.775px"
    },
    id: "eltx9l7mk9ma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.15,284.58c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5A9.79,9.79,0,0,1,144,288a5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.87.87,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,144.15,284.58Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.16.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.38,2.38,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S141,288.12,141.05,288.42Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "142.05px 286.775px"
    },
    id: "elroz7sohdogr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.89,283.74a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.53.53,0,0,1,.15-.15l.6-.34a.1.1,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.32.32,0,0,1-.16.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "146.29px 283.883px"
    },
    id: "elqgqodsgfo1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.89,279.53c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.21,3.21,0,0,1-1,.79,1.83,1.83,0,0,1-.95.31.85.85,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.39,5.39,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.54,3.54,0,0,1,.95-.8,1.86,1.86,0,0,1,1-.31.87.87,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.77,6.77,0,0,1,152.89,279.53Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.75,1.75,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S149.78,283.08,149.79,283.37Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "150.8px 281.765px"
    },
    id: "el8eahiqhr37y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,276.57v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.77,1.77,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.7,1.7,0,0,1,1-.3.83.83,0,0,1,.63.3,1.88,1.88,0,0,1,.35.82A6.82,6.82,0,0,1,158,276.57Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.88,4.88,0,0,0,.27-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S154.91,280.12,154.92,280.41Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "155.905px 278.81px"
    },
    id: "elrn5932psdj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.14,273.61c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.24,5.24,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.21,3.21,0,0,1-1,.79,1.75,1.75,0,0,1-.95.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.72,0-1a10.11,10.11,0,0,1,.13-1.36,6.13,6.13,0,0,1,.35-1.24,4.57,4.57,0,0,1,.63-1,3.4,3.4,0,0,1,.95-.81,1.83,1.83,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.88,6.88,0,0,1,163.14,273.61Zm-3.1,3.84a2.47,2.47,0,0,0,.27,1.17c.15.22.41.23.76,0a1.7,1.7,0,0,0,.77-.9,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S160,277.16,160,277.45Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "161.05px 275.875px"
    },
    id: "elppr726tk2ys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.89,272.77a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "165.297px 272.92px"
    },
    id: "elyqzy4h1uf1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.89,268.57c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,4,4,0,0,1-.63,1,3.52,3.52,0,0,1-1,.8,1.83,1.83,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.78,1.78,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,171.89,268.57Zm-3.1,3.83a2.45,2.45,0,0,0,.26,1.17c.16.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.66,4.66,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.31,2.31,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.77,1.77,0,0,0-.77.91,5,5,0,0,0-.26,1.47c0,.31,0,.64,0,1S168.78,272.11,168.79,272.4Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "169.795px 270.81px"
    },
    id: "el1qx517c1nmc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,267.72a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.64.64,0,0,1,.15-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.54.54,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85l-1.1,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "174.03px 267.87px"
    },
    id: "eldjf2703d9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.63,263.52c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.51a9.66,9.66,0,0,1-.13,1.34,5.32,5.32,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.72,1.72,0,0,1-.95.3A.82.82,0,0,1,177,270a1.79,1.79,0,0,1-.35-.81,6,6,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a8.72,8.72,0,0,1,.13-1.37,5.54,5.54,0,0,1,.35-1.24,4.65,4.65,0,0,1,.63-1.05,3.4,3.4,0,0,1,.95-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.89,6.89,0,0,1,180.63,263.52Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.65,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S177.52,267.06,177.53,267.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "178.575px 265.755px"
    },
    id: "elb1u2r5vl0nv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,262.67a.28.28,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a1.93,1.93,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85L182,263.05a.33.33,0,0,1-.15.16.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "182.785px 262.81px"
    },
    id: "el5b39j4yusor",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.38,258.47v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.91,1.91,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,6.14,6.14,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.84,1.84,0,0,1,.35.81A6.83,6.83,0,0,1,189.38,258.47Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S186.27,262,186.28,262.31Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "187.29px 260.7px"
    },
    id: "eldo0wtclg7dh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5,255.51c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.83,1.83,0,0,1-1,.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.31,5.31,0,0,1,.35-1.23,4.19,4.19,0,0,1,.63-1.06,3.21,3.21,0,0,1,1-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.81A6.89,6.89,0,0,1,194.5,255.51Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.73,1.73,0,0,0-.76.9,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S191.39,259.05,191.4,259.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "192.41px 257.745px"
    },
    id: "el55c7l9fu2jq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.24,254.67a.35.35,0,0,1,0-.22.87.87,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0A.25.25,0,0,1,197,259V253.1l-1.09,2a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "196.646px 254.801px"
    },
    id: "elw0dc6kf4bg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.25,250.46v2.11a9.79,9.79,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.36-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,203.25,250.46Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S200.14,254,200.15,254.3Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "201.155px 252.695px"
    },
    id: "el8ckykeijcos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,249.62a.28.28,0,0,1,0-.21.47.47,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.43.43,0,0,1,.15-.15l.59-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.1,1.95a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "205.4px 249.763px"
    },
    id: "elqcl6nmv4w89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.61,247.53a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V246l-1.09,1.95a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "209.01px 247.673px"
    },
    id: "elel8gwtkwiua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.61,243.32c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A7.87,7.87,0,0,1,215.61,243.32Zm-3.1,3.84a2.38,2.38,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.16-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S212.5,246.87,212.51,247.16Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "213.515px 245.555px"
    },
    id: "elhoyb0qjdpm9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.74,240.36v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,2,2,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.82,6.82,0,0,1,220.74,240.36Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.88,4.88,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S217.63,243.91,217.64,244.2Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "218.625px 242.595px"
    },
    id: "el95tnl0vg1xh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.48,239.52a.33.33,0,0,1,0-.21.62.62,0,0,1,.09-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.51.51,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.36.36,0,0,1-.15.17l-.62.36a.1.1,0,0,1-.14,0,.22.22,0,0,1-.07-.19V238l-1.09,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "222.887px 239.666px"
    },
    id: "el609lc8zc2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.48,235.32c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35A5.77,5.77,0,0,1,229,240a3.9,3.9,0,0,1-.63,1,3.18,3.18,0,0,1-1,.79,1.77,1.77,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.89,1.89,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.81,1.81,0,0,1,1-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,229.48,235.32Zm-3.1,3.83a2.35,2.35,0,0,0,.27,1.17c.15.22.4.23.76,0a1.67,1.67,0,0,0,.77-.9,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S226.37,238.86,226.38,239.15Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "227.39px 237.585px"
    },
    id: "el22o6tur2gaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.22,234.47a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.37.37,0,0,1,.14-.14l.6-.35a.11.11,0,0,1,.14,0,.26.26,0,0,1,.07.19v7.65a.68.68,0,0,1-.07.26.54.54,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "231.627px 234.621px"
    },
    id: "el2a9cok9r3zz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.22,230.27c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.46,5.46,0,0,1-.35,1.23,4.28,4.28,0,0,1-.64,1,3.47,3.47,0,0,1-.94.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.84,1.84,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.87,1.87,0,0,1,.94-.3.83.83,0,0,1,.64.31,1.79,1.79,0,0,1,.35.81A6.89,6.89,0,0,1,238.22,230.27Zm-3.09,3.83a2.34,2.34,0,0,0,.26,1.17c.15.22.41.23.77,0a1.75,1.75,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.65,0,1S235.12,233.81,235.13,234.1Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "236.135px 232.5px"
    },
    id: "el3ru75uyebm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,229.42a.28.28,0,0,1,0-.21A.5.5,0,0,1,239,229l1.66-3a2.39,2.39,0,0,0,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.39.39,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "240.36px 229.62px"
    },
    id: "el7ceycox9j4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,324.06a.33.33,0,0,1,0-.21.65.65,0,0,1,.08-.27l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.24.24,0,0,1,.07.19v7.65a.51.51,0,0,1-.07.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "101.067px 324.191px"
    },
    id: "elxunxximkpsf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.28,322a.28.28,0,0,1,0-.21.57.57,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.6-.35a.12.12,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19V320.4l-1.09,2a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "104.68px 322.141px"
    },
    id: "el7n8di6meowj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,317.76c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.21,3.21,0,0,1-1,.79,1.83,1.83,0,0,1-.95.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.87,4.87,0,0,1,.63-1.06,3.54,3.54,0,0,1,.95-.8,1.86,1.86,0,0,1,1-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.77,6.77,0,0,1,111.28,317.76Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.72,1.72,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S108.17,321.3,108.18,321.6Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "109.19px 319.995px"
    },
    id: "el0k6ygyhhore5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,316.92a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "113.407px 317.065px"
    },
    id: "elx1wgabkclz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,312.71v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.77,1.77,0,0,1-.95.31.84.84,0,0,1-.63-.31,2,2,0,0,1-.36-.82,7.73,7.73,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a11.83,11.83,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.81,1.81,0,0,1,1-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,120,312.71Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S116.92,316.26,116.93,316.55Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "117.905px 314.945px"
    },
    id: "eltrr2gflgi5l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.15,309.75c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.34,3.34,0,0,1-1,.79,1.81,1.81,0,0,1-1,.31.85.85,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.25,4.25,0,0,1,.63-1.05,3.55,3.55,0,0,1,1-.81,1.72,1.72,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.88,6.88,0,0,1,125.15,309.75Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.76,0a1.69,1.69,0,0,0,.77-.91,4.61,4.61,0,0,0,.26-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S122,313.3,122.05,313.59Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "123.035px 311.99px"
    },
    id: "eliw2tn09iuzi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.9,308.91a.33.33,0,0,1-.05-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.36.36,0,0,1-.15.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "127.265px 309.057px"
    },
    id: "ellq4if0eybv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.9,304.71c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.23,5.23,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.52,3.52,0,0,1-.95.8,1.83,1.83,0,0,1-1,.3.84.84,0,0,1-.63-.31,1.89,1.89,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1.05,3.27,3.27,0,0,1,1-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,133.9,304.71Zm-3.1,3.83a2.37,2.37,0,0,0,.26,1.17c.16.22.41.23.77,0a1.65,1.65,0,0,0,.76-.9,4.66,4.66,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.31,2.31,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.77,1.77,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S130.79,308.25,130.8,308.54Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "131.805px 306.94px"
    },
    id: "elsnbco630ez",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.64,303.86a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21a.62.62,0,0,1,.14-.14l.61-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.54.54,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.24.24,0,0,1-.07-.19V302.3l-1.09,1.94c0,.08-.09.14-.15.15a.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "136.04px 304.01px"
    },
    id: "elaoank1iaqcf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.26,301.77a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21a.62.62,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.14,0,.24.24,0,0,1-.07-.19v-5.85l-1.09,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "139.66px 301.919px"
    },
    id: "elykz9bakn21",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.26,297.57c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.86,5.86,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.74,1.74,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.89,6.89,0,0,1,146.26,297.57Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.65,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S143.15,301.11,143.16,301.4Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "144.19px 299.8px"
    },
    id: "el20bcn5f42o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,296.72a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a1.37,1.37,0,0,1,.13-.2.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.15.15,0,0,1-.15-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "148.407px 296.87px"
    },
    id: "eldbgzl4bqdrq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,292.52c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,3.84,3.84,0,0,1-.64,1,3.47,3.47,0,0,1-.94.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,.94-.31.84.84,0,0,1,.64.31,1.89,1.89,0,0,1,.35.81A6.89,6.89,0,0,1,155,292.52Zm-3.09,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S151.9,296.06,151.91,296.36Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "152.915px 294.75px"
    },
    id: "elzu46qhhbsx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.13,289.56c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5A10,10,0,0,1,160,293a6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.31,5.31,0,0,1,.35-1.23,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.82A6.66,6.66,0,0,1,160.13,289.56ZM157,293.4a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.82,4.82,0,0,0-.27,1.47c0,.3,0,.64,0,1S157,293.1,157,293.4Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "158.06px 291.775px"
    },
    id: "el89k1gud91js",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.87,288.72a.35.35,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.24.24,0,0,1,.07.19v7.65a.51.51,0,0,1-.07.26.39.39,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "162.277px 288.852px"
    },
    id: "el04xf5ogr29p4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,286.63a.35.35,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.24.24,0,0,1,.07.19v7.65a.48.48,0,0,1-.07.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85L165.15,287a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "165.897px 286.761px"
    },
    id: "elm7q7psj77",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.49,282.42c0,.15,0,.31,0,.49V284c0,.18,0,.35,0,.5a9.8,9.8,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.87.87,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.35.82A6.66,6.66,0,0,1,172.49,282.42Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S169.38,286,169.39,286.26Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "170.405px 284.625px"
    },
    id: "el5fwjpdynnxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.62,279.46c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31A.84.84,0,0,1,174,286a1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,177.62,279.46Zm-3.1,3.84a2.38,2.38,0,0,0,.27,1.17c.15.22.4.23.76,0a1.77,1.77,0,0,0,.77-.91,5,5,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.52,2.52,0,0,0-.26-1.17c-.16-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S174.51,283,174.52,283.3Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "175.566px 281.73px"
    },
    id: "elcdx8lgwyjwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.74,276.5c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.91.91,0,0,1,.63.31,2,2,0,0,1,.35.82A6.77,6.77,0,0,1,182.74,276.5Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.72,1.72,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S179.63,280.05,179.64,280.34Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "180.655px 278.735px"
    },
    id: "eltquuu5fszhe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.49,275.66a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.57.57,0,0,1-.06.25.35.35,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19V274.1L184.14,276a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "184.89px 275.807px"
    },
    id: "elk3us30e33w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.11,273.57a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.36.36,0,0,1-.15.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19V272L187.76,274a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "188.51px 273.717px"
    },
    id: "elo8s1cqq0umj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.73,271.48a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.31.31,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.35a.11.11,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "192.137px 271.627px"
    },
    id: "el2mnqejanbxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.73,267.28v2.1a9.63,9.63,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,4,4,0,0,1-.63,1,3.52,3.52,0,0,1-1,.8,1.84,1.84,0,0,1-1,.3.8.8,0,0,1-.62-.31,2,2,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12,12,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.4,4.4,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,198.73,267.28Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.16.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.77,1.77,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S195.62,270.82,195.63,271.11Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "196.615px 269.52px"
    },
    id: "elosyegx7cd5b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.85,264.32c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.32,5.32,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.72,1.72,0,0,1-.95.3.82.82,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.54,5.54,0,0,1,.35-1.24,4.65,4.65,0,0,1,.63-1.05,3.4,3.4,0,0,1,.95-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.89,6.89,0,0,1,203.85,264.32Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.77,0a1.75,1.75,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S200.74,267.86,200.75,268.15Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "201.785px 266.55px"
    },
    id: "elbunn1r9wkxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.6,263.47a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16A.13.13,0,0,1,205,264Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "206.007px 263.62px"
    },
    id: "elvwa8oodfybb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6,259.27v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.09,10.09,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.84,1.84,0,0,1,.35.81A6.83,6.83,0,0,1,212.6,259.27Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S209.49,262.81,209.5,263.11Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "210.53px 261.5px"
    },
    id: "elbv5qro1amc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.72,256.31c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.83,1.83,0,0,1-1,.31.86.86,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.54,5.54,0,0,1,.35-1.24,4.65,4.65,0,0,1,.63-1,3.21,3.21,0,0,1,1-.8,1.83,1.83,0,0,1,.95-.31.81.81,0,0,1,.63.31,1.84,1.84,0,0,1,.36.81A6.89,6.89,0,0,1,217.72,256.31Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.75,1.75,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S214.61,259.85,214.62,260.15Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "215.63px 258.565px"
    },
    id: "elu2ahak86fg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.85,253.35v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.31,5.31,0,0,1,.35-1.23,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,222.85,253.35Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.16.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.38,2.38,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.61,4.61,0,0,0-.26,1.47c0,.3,0,.64,0,1S219.74,256.89,219.75,257.19Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "220.78px 255.585px"
    },
    id: "eln4ejz85me4a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,250.39c0,.15,0,.31,0,.49V252c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.47,3.47,0,0,1-.94.79,1.89,1.89,0,0,1-1,.31.88.88,0,0,1-.63-.32,1.9,1.9,0,0,1-.35-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10,10,0,0,1,.13-1.36,5.78,5.78,0,0,1,.35-1.24,4.87,4.87,0,0,1,.63-1.06,3.28,3.28,0,0,1,1-.8,1.81,1.81,0,0,1,.94-.31.88.88,0,0,1,.64.31,2,2,0,0,1,.35.82A6.66,6.66,0,0,1,228,250.39Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.77,0a1.75,1.75,0,0,0,.76-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S224.86,253.93,224.87,254.23Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "225.915px 252.625px"
    },
    id: "eleqfv6hevit9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.72,249.55a.33.33,0,0,1-.05-.21.72.72,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.24.24,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V248l-1.09,2a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "230.085px 249.693px"
    },
    id: "elkcphw4iv11e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.72,245.34v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,236.72,245.34Zm-3.1,3.84a2.52,2.52,0,0,0,.26,1.17c.16.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,5,5,0,0,0-.26,1.47c0,.31,0,.64,0,1S233.61,248.88,233.62,249.18Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "234.625px 247.575px"
    },
    id: "eljqbll795jb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,242.38c0,.15,0,.31,0,.5V244c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,4.92,4.92,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.21,3.21,0,0,1-.95.79,1.81,1.81,0,0,1-1,.31.85.85,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.71,3.71,0,0,1,1-.8,1.86,1.86,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.78,1.78,0,0,1,.36.82A6.77,6.77,0,0,1,241.84,242.38Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.41-.23-.77,0a1.75,1.75,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S238.73,245.93,238.74,246.22Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "239.75px 244.625px"
    },
    id: "ela4gt0tcuy2p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.05,336.15v2.1a11.41,11.41,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,5,5,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.84,1.84,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.4,4.4,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,1-.3.84.84,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A7.93,7.93,0,0,1,104.05,336.15ZM101,340a2.34,2.34,0,0,0,.26,1.17c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91A4.66,4.66,0,0,0,101,338c0,.31,0,.65,0,1S100.94,339.69,101,340Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "101.935px 338.38px"
    },
    id: "elmue6ss4tnq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.7,335.35a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19V339a.65.65,0,0,1-.06.26.36.36,0,0,1-.15.17l-.62.36a.11.11,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "106.107px 335.487px"
    },
    id: "eluie6lntabwm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.24,333.31a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.1.1,0,0,1,.14,0,.22.22,0,0,1,.07.19V337a.48.48,0,0,1-.07.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "109.647px 333.468px"
    },
    id: "eldermwklpobs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.78,331.27a.28.28,0,0,1,0-.21.53.53,0,0,1,.08-.27l1.66-3a2.39,2.39,0,0,0,.13-.21.43.43,0,0,1,.15-.15l.59-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19V335a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36c-.06,0-.1,0-.14,0a.22.22,0,0,1-.07-.19V329.7l-1.09,1.95a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "113.18px 331.428px"
    },
    id: "eldk8tv2kvvx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.32,329.22a.33.33,0,0,1,0-.21.87.87,0,0,1,.08-.26l1.67-3c0-.08.09-.14.13-.21a.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85L116,329.61a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "116.727px 329.36px"
    },
    id: "el4nmg8s04pys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.23,325.07c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.31,5.31,0,0,1-.35,1.23,4,4,0,0,1-.64,1,3.47,3.47,0,0,1-.94.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.79,1.79,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.87,1.87,0,0,1,.94-.3.81.81,0,0,1,.64.31,1.79,1.79,0,0,1,.35.81A6.89,6.89,0,0,1,123.23,325.07Zm-3.09,3.83a2.34,2.34,0,0,0,.26,1.17c.15.23.41.23.77,0a1.75,1.75,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S120.13,328.61,120.14,328.9Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "121.145px 327.3px"
    },
    id: "elb7hreqhv2kt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.28,322.16c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,4,4,0,0,1-.63,1,3.52,3.52,0,0,1-1,.8,1.83,1.83,0,0,1-.95.3.84.84,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.78,1.78,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,128.28,322.16Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.16.22.41.23.77,0a1.75,1.75,0,0,0,.76-.91,4.66,4.66,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.31,2.31,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.77,1.77,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S125.17,325.7,125.18,326Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "126.185px 324.4px"
    },
    id: "eltc7pg2s094a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.94,321.36a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19V325a.66.66,0,0,1-.06.27.36.36,0,0,1-.15.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19V319.8l-1.09,1.94a.31.31,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "130.34px 321.497px"
    },
    id: "elid9stn99cym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.86,317.2c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.81,1.81,0,0,1,1-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,136.86,317.2Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.16.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.38,2.38,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S133.75,320.74,133.76,321Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "134.765px 319.435px"
    },
    id: "elda6tsjpwcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.52,316.41a.29.29,0,0,1,0-.22.52.52,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "138.92px 316.541px"
    },
    id: "elcf17qu9a2yc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.44,312.25c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.09,10.09,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.27,3.27,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.84,1.84,0,0,1,.35.81A6.83,6.83,0,0,1,145.44,312.25Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.16.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.35,2.35,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.77,1.77,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S142.33,315.79,142.34,316.09Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "143.345px 314.505px"
    },
    id: "el4871ora7j6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1,311.45a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94c-.05.08-.09.14-.15.15a.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "147.5px 311.6px"
    },
    id: "elgp3ma7xlj7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.63,309.41a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.31.31,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.55.55,0,0,1-.15.18l-.62.35a.11.11,0,0,1-.15,0,.24.24,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "151.037px 309.557px"
    },
    id: "elb76fyvf9l2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.55,305.25c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.3,3.3,0,0,1-.94.79,1.86,1.86,0,0,1-1,.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.87,4.87,0,0,1,.63-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.94-.31.91.91,0,0,1,.64.31,1.88,1.88,0,0,1,.35.82A6.77,6.77,0,0,1,157.55,305.25Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.72,1.72,0,0,0,.76-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S154.44,308.8,154.45,309.09Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "155.465px 307.485px"
    },
    id: "elntodsy6bhjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.21,304.46a.33.33,0,0,1,0-.21.72.72,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.23.23,0,0,1,.06.18v7.65a.58.58,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "159.617px 304.603px"
    },
    id: "el0l0uphuse30d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.75,302.42a.3.3,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3,.12-.21a.53.53,0,0,1,.15-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.1,1.95a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "163.15px 302.55px"
    },
    id: "el3anqzrxsbg1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.67,298.26c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,5.86,5.86,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.74,1.74,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.9,1.9,0,0,1,1-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,169.67,298.26Zm-3.1,3.83a2.32,2.32,0,0,0,.27,1.17c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.65,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,4.66,4.66,0,0,0-.27,1.48c0,.3,0,.64,0,1S166.56,301.8,166.57,302.09Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "167.575px 300.49px"
    },
    id: "elz3vqfnt123o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.71,295.35c0,.14,0,.31,0,.49V297c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.46,5.46,0,0,1-.35,1.23,4.34,4.34,0,0,1-.64,1,3.24,3.24,0,0,1-1,.8,1.78,1.78,0,0,1-.95.3.84.84,0,0,1-.63-.31,2,2,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.13,6.13,0,0,1,.35-1.24,4.8,4.8,0,0,1,.63-1.05,3.55,3.55,0,0,1,.95-.81,1.83,1.83,0,0,1,1-.3.84.84,0,0,1,.64.31,1.79,1.79,0,0,1,.35.81A6.89,6.89,0,0,1,174.71,295.35Zm-3.09,3.83a2.34,2.34,0,0,0,.26,1.17c.15.22.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S171.6,298.89,171.62,299.18Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "172.62px 297.64px"
    },
    id: "el7nc5u6m5y37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.37,294.55a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19V293L176,294.93a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "176.777px 294.697px"
    },
    id: "el8f56i67uydd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.29,290.39c0,.15,0,.31,0,.5V292c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.21,3.21,0,0,1-.95.79,1.83,1.83,0,0,1-.95.31.87.87,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.39,5.39,0,0,1,.35-1.24,4.87,4.87,0,0,1,.63-1.06,3.54,3.54,0,0,1,.95-.8,1.86,1.86,0,0,1,.95-.31.91.91,0,0,1,.64.31,2,2,0,0,1,.35.82A6.77,6.77,0,0,1,183.29,290.39Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.72,1.72,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S180.18,293.94,180.19,294.23Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "181.225px 292.625px"
    },
    id: "el2iobkcm2pqz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,289.6a.35.35,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.24.24,0,0,1,.07.19v7.65a.48.48,0,0,1-.07.26.34.34,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V288l-1.09,2a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "185.407px 289.732px"
    },
    id: "elctxvpybyv4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.87,285.44c0,.15,0,.31,0,.49V287c0,.19,0,.35,0,.51a10,10,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.37,3.37,0,0,1-.95.79,1.83,1.83,0,0,1-1,.31.88.88,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.54,5.54,0,0,1,.35-1.24,5,5,0,0,1,.63-1,3.21,3.21,0,0,1,1-.8,1.86,1.86,0,0,1,.95-.31.84.84,0,0,1,.64.31,2,2,0,0,1,.35.81A6.89,6.89,0,0,1,191.87,285.44Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.75,1.75,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S188.76,289,188.77,289.28Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "189.78px 287.655px"
    },
    id: "elgt09lrckvb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.53,284.64a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.47.47,0,0,1,.14-.14l.6-.35c.06,0,.1,0,.14,0a.22.22,0,0,1,.07.19v7.65a.54.54,0,0,1-.07.26.38.38,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85L193.19,285a.33.33,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "193.937px 284.803px"
    },
    id: "elqoucszv0a2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.07,282.6a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.33.33,0,0,1,.15-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.54.54,0,0,1-.14.18l-.63.35a.1.1,0,0,1-.14,0,.23.23,0,0,1-.06-.18V281l-1.1,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "197.47px 282.747px"
    },
    id: "eli5gimz3yhna",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,278.44c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,204,278.44Zm-3.1,3.84a2.38,2.38,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.16-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S200.88,282,200.89,282.28Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "201.905px 280.675px"
    },
    id: "elqkz5mhhyh3i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.65,277.65a.28.28,0,0,1,0-.21.57.57,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.6-.34a.1.1,0,0,1,.14,0,.24.24,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85L205.3,278a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "206.051px 277.793px"
    },
    id: "eloqk1zhf0r5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.57,273.49c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.31,5.31,0,0,1,.35-1.23,4.19,4.19,0,0,1,.63-1.06,3.09,3.09,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.83,6.83,0,0,1,212.57,273.49Zm-3.1,3.84a2.31,2.31,0,0,0,.27,1.16c.15.23.4.24.76,0a1.77,1.77,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.16-.22-.41-.23-.77,0a1.69,1.69,0,0,0-.76.9,4.66,4.66,0,0,0-.27,1.48c0,.3,0,.64,0,1S209.46,277,209.47,277.33Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "210.5px 275.725px"
    },
    id: "elcxl3tfujays",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.23,272.69a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.2a.43.43,0,0,1,.15-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0A.27.27,0,0,1,215,277v-5.85l-1.09,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "214.63px 272.84px"
    },
    id: "ellaft04gcl4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.77,270.65a.33.33,0,0,1-.05-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.13.13,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85L217.42,271c0,.08-.1.14-.15.15a.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "218.135px 270.799px"
    },
    id: "elm1i4jru3snd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.69,266.49v2.11a9.63,9.63,0,0,1-.14,1.35,5.23,5.23,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31A.83.83,0,0,1,221,273a2,2,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.22,4.22,0,0,1,.62-1,3.45,3.45,0,0,1,1-.81,1.7,1.7,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.82,6.82,0,0,1,224.69,266.49Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.88,4.88,0,0,0,.27-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S221.58,270,221.59,270.33Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "222.6px 268.775px"
    },
    id: "els8bic36p8ig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.35,265.7a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85L226,266.08a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "226.757px 265.843px"
    },
    id: "elnjqqk52jx5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.27,261.54v2.11a9.79,9.79,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.91,1.91,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10,10,0,0,1,.13-1.36,5.78,5.78,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.42,3.42,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,233.27,261.54Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1A2.5,2.5,0,0,0,232,261c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S230.16,265.08,230.17,265.38Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "231.155px 263.775px"
    },
    id: "elo8sojlyzn1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,260.74a.33.33,0,0,1-.05-.21.87.87,0,0,1,.08-.26l1.67-3a1.93,1.93,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "235.295px 260.88px"
    },
    id: "el31u1de35m7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.85,256.59v2.1a9.63,9.63,0,0,1-.14,1.35,5.31,5.31,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,2,2,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,241.85,256.59Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S238.74,260.13,238.75,260.42Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "239.76px 258.82px"
    },
    id: "els0bisevde9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79,125.28v2.11a11.41,11.41,0,0,1-.14,1.35,5.94,5.94,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.91.91,0,0,1,.63.31,2,2,0,0,1,.35.82A7.94,7.94,0,0,1,247.79,125.28Zm-3.11,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.72,1.72,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S244.67,128.83,244.68,129.12Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "245.7px 127.515px"
    },
    id: "elx3cdnzkehbl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.84,122.36c0,.15,0,.31,0,.5V124c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.3,3.3,0,0,1-.94.79,1.89,1.89,0,0,1-1,.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.87,4.87,0,0,1,.63-1.06,3.44,3.44,0,0,1,1-.8,1.81,1.81,0,0,1,.94-.31.91.91,0,0,1,.64.31,2,2,0,0,1,.35.82A6.77,6.77,0,0,1,252.84,122.36Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.75,1.75,0,0,0,.76-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S249.73,125.91,249.74,126.2Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "250.755px 124.625px"
    },
    id: "el40f7qtfpnqw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.9,119.44c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.8,9.8,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.37,3.37,0,0,1-.95.79,1.81,1.81,0,0,1-1,.31.89.89,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.71,3.71,0,0,1,1-.8,1.86,1.86,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.66,6.66,0,0,1,257.9,119.44Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.41-.23-.77,0a1.72,1.72,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S254.79,123,254.8,123.28Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "255.81px 121.675px"
    },
    id: "el44psd6nqtye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.58,118.64a.29.29,0,0,1,0-.22.52.52,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.6-.35a.12.12,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.26.26,0,0,1-.07-.19v-5.85l-1.09,2a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "259.979px 118.771px"
    },
    id: "elkn92qx2otb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.52,114.47v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.91,1.91,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12.23,12.23,0,0,1,.13-1.37,6.14,6.14,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.84,1.84,0,0,1,.35.81A6.83,6.83,0,0,1,266.52,114.47Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S263.41,118,263.42,118.31Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "264.43px 116.725px"
    },
    id: "elvolqc7y0mcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.19,113.66a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a1.37,1.37,0,0,1,.13-.2.41.41,0,0,1,.14-.15l.6-.35a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.51.51,0,0,1-.07.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19V112.1L267.85,114a.33.33,0,0,1-.15.16.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "268.597px 113.81px"
    },
    id: "elx90xg9871o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.13,109.5c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5A9.63,9.63,0,0,1,275,113a5.46,5.46,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.74,1.74,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81A6.83,6.83,0,0,1,271,114c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,275.13,109.5Zm-3.1,3.83a2.22,2.22,0,0,0,.27,1.17c.15.22.4.23.76,0a1.77,1.77,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.16-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.38,4.38,0,0,0-.27,1.47c0,.31,0,.64,0,1S272,113,272,113.33Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "273.065px 111.805px"
    },
    id: "el9qgmqiic6ej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.19,106.58v2.1a9.63,9.63,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,4,4,0,0,1-.63,1,3.52,3.52,0,0,1-.95.8,1.83,1.83,0,0,1-.95.3.84.84,0,0,1-.63-.31,2,2,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12,12,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.13,4.13,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,280.19,106.58Zm-3.1,3.83a2.37,2.37,0,0,0,.26,1.17c.16.22.41.23.77,0a1.65,1.65,0,0,0,.76-.9,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.77,1.77,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S277.08,110.12,277.09,110.41Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "278.12px 108.845px"
    },
    id: "el3ozucd0mc11",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.86,105.77a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34c.06,0,.1,0,.14,0a.22.22,0,0,1,.07.19v7.65a.54.54,0,0,1-.07.26.35.35,0,0,1-.14.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "282.267px 105.93px"
    },
    id: "elqy66awmb7kq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.42,103.72a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "285.82px 103.865px"
    },
    id: "elm4b2tvkcpe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,101.67a.28.28,0,0,1,0-.21.47.47,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.6-.34a.1.1,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19V100.1l-1.1,2a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "289.4px 101.813px"
    },
    id: "el4irg4777azb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.91,97.5v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.91,1.91,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10,10,0,0,1,.13-1.36,5.78,5.78,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.42,3.42,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,295.91,97.5Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1A2.5,2.5,0,0,0,294.6,97c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.61,4.61,0,0,0-.26,1.47c0,.3,0,.64,0,1S292.8,101,292.81,101.34Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "293.795px 99.735px"
    },
    id: "el0fvskcxfwra7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.58,96.7a.36.36,0,0,1,0-.22.87.87,0,0,1,.08-.26l1.67-3a1.48,1.48,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V95.13l-1.09,2a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "297.982px 96.8306px"
    },
    id: "el9fx9ya0e82",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.52,92.53c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.09,10.09,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,304.52,92.53Zm-3.1,3.84a2.44,2.44,0,0,0,.26,1.16c.16.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.32,2.32,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.77,1.77,0,0,0-.77.91,5,5,0,0,0-.26,1.48c0,.3,0,.64,0,1S301.41,96.07,301.42,96.37Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "302.45px 94.76px"
    },
    id: "elltwsk58au4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,91.72a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.46.46,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19V90.16l-1.09,1.94a.33.33,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "306.597px 91.87px"
    },
    id: "el67tyz175owc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.13,87.56c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5A9.66,9.66,0,0,1,313,91a5.77,5.77,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.37,3.37,0,0,1-.95.8,1.81,1.81,0,0,1-.95.3.84.84,0,0,1-.63-.31,1.89,1.89,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1.05,3.4,3.4,0,0,1,.95-.81,1.81,1.81,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.89,6.89,0,0,1,313.13,87.56ZM310,91.39a2.47,2.47,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91A4.94,4.94,0,0,0,310,89.4c0,.31,0,.64,0,1S310,91.1,310,91.39Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "311.06px 89.78px"
    },
    id: "elr1ww39c02tk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.81,86.75a.33.33,0,0,1-.05-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,0,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.36.36,0,0,1-.15.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19V85.19l-1.09,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "315.175px 86.8966px"
    },
    id: "elcw83iiphec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.36,84.7a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.6-.34a.1.1,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19V83.14L318,85.08a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "318.76px 84.845px"
    },
    id: "elsrbctgeeoeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.91,82.65a.33.33,0,0,1,0-.21.57.57,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.1.1,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.64a.48.48,0,0,1-.07.26.34.34,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V81.08l-1.09,2a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "322.317px 82.7939px"
    },
    id: "el4rhq0nbh5z4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.4,141.6a.28.28,0,0,1,0-.21.65.65,0,0,1,.08-.26l1.67-3a1.07,1.07,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19V140l-1.09,2a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "244.8px 141.74px"
    },
    id: "elvasqba2w01",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.34,137.44v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.74,1.74,0,0,1-1,.3.81.81,0,0,1-.63-.31,1.91,1.91,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12,12,0,0,1,.13-1.37,6.14,6.14,0,0,1,.36-1.24,4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,251.34,137.44Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S248.23,141,248.24,141.28Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "249.245px 139.665px"
    },
    id: "el6rwdh5km94v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.4,134.52v2.1a9.63,9.63,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.61,4.61,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,256.4,134.52Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.16.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.24-.76,0a1.77,1.77,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.65,0,1S253.29,138.06,253.3,138.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "254.31px 136.75px"
    },
    id: "eleez5wqraw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.46,131.6v2.1a9.63,9.63,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,4,4,0,0,1-.63,1,3.52,3.52,0,0,1-.95.8,1.84,1.84,0,0,1-1,.3.8.8,0,0,1-.62-.31,2,2,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.4,4.4,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,261.46,131.6Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S258.35,135.14,258.36,135.43Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "259.37px 133.84px"
    },
    id: "elyqmelh3m5tq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.52,128.67v2.11a9.63,9.63,0,0,1-.14,1.35,5.23,5.23,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,2,2,0,0,1-.36-.82,7.73,7.73,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a11.83,11.83,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.22,4.22,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.7,1.7,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.82,6.82,0,0,1,266.52,128.67Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.69,1.69,0,0,0,.76-.9,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S263.41,132.22,263.42,132.51Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "264.43px 130.91px"
    },
    id: "elq63abd3qyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.19,127.87a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.1.1,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.64a.48.48,0,0,1-.07.26.39.39,0,0,1-.14.18l-.63.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "268.597px 128.015px"
    },
    id: "eld7ftkrcd8du",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.13,123.7c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,275.13,123.7Zm-3.1,3.84a2.28,2.28,0,0,0,.27,1.17c.15.22.4.23.76,0a1.77,1.77,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.16-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.38,4.38,0,0,0-.27,1.47c0,.31,0,.64,0,1S272,127.24,272,127.54Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "273.06px 125.935px"
    },
    id: "elx0ts5i4l1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.8,122.9a.33.33,0,0,1,0-.21.72.72,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "277.207px 123.041px"
    },
    id: "elie1vze140ro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.74,118.73c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.83,1.83,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.31,5.31,0,0,1,.35-1.23,4.19,4.19,0,0,1,.63-1.06,3.21,3.21,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.81A6.89,6.89,0,0,1,283.74,118.73Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.69,1.69,0,0,0-.76.9,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S280.63,122.27,280.64,122.57Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "281.67px 120.965px"
    },
    id: "eluq17nro5rm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.42,117.92a.28.28,0,0,1,0-.21.52.52,0,0,1,.08-.26l1.66-3a1.93,1.93,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "285.82px 118.06px"
    },
    id: "ellmdhbmxf8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,115.87a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21a.49.49,0,0,1,.15-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85l-1.1,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "289.4px 116.02px"
    },
    id: "eli05mzchva1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.52,113.82a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.55.55,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "292.927px 113.97px"
    },
    id: "el8vy43ull226",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.46,109.65c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.23,5.23,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.77,1.77,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.89,1.89,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4,4,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.82,6.82,0,0,1,299.46,109.65Zm-3.1,3.84a2.35,2.35,0,0,0,.27,1.17c.15.22.4.23.76,0a1.7,1.7,0,0,0,.77-.9,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S296.35,113.2,296.36,113.49Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "297.39px 111.915px"
    },
    id: "el8mxiljpzu1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.14,108.85a.33.33,0,0,1-.05-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "301.505px 108.995px"
    },
    id: "eljxutmfcaiq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07,104.68c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.83,1.83,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.54,3.54,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A6.77,6.77,0,0,1,308.07,104.68Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S305,108.23,305,108.52Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "306.005px 106.915px"
    },
    id: "elb4crt5epw3m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75,103.88a.29.29,0,0,1,0-.22.46.46,0,0,1,.08-.25l1.66-3a2.39,2.39,0,0,0,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.23.23,0,0,1,.06.18v7.65a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "310.15px 104.023px"
    },
    id: "el0g4z52zn3zw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.3,101.83a.29.29,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.1,1.95a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "313.7px 101.961px"
    },
    id: "elcqayj8f2y9m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.24,97.66v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.91,1.91,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12.23,12.23,0,0,1,.13-1.37,6.14,6.14,0,0,1,.36-1.24,4.31,4.31,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.84,1.84,0,0,1,.35.81A6.83,6.83,0,0,1,320.24,97.66Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S317.13,101.2,317.14,101.5Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "318.17px 99.915px"
    },
    id: "elcd4fuzes3um",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3,94.74v2.11a11.46,11.46,0,0,1-.14,1.34,5.31,5.31,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.91,1.91,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12,12,0,0,1,.13-1.37,6.14,6.14,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A7.93,7.93,0,0,1,325.3,94.74Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.65,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S322.19,98.28,322.2,98.57Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "323.21px 96.9901px"
    },
    id: "eln1e9admbfl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79,153.69v2.11a11.41,11.41,0,0,1-.14,1.35,5.94,5.94,0,0,1-.35,1.22,4.5,4.5,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.91.91,0,0,1,.63.31,2,2,0,0,1,.35.82A7.94,7.94,0,0,1,247.79,153.69Zm-3.11,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.72,1.72,0,0,0,.76-.91,4.88,4.88,0,0,0,.27-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S244.67,157.24,244.68,157.53Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "245.7px 155.925px"
    },
    id: "elmlwqkwti1j9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,150.71c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.74,1.74,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.88,1.88,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,253,150.71Zm-3.1,3.83a2.45,2.45,0,0,0,.26,1.17c.16.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.66,4.66,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.32,2.32,0,0,0-.27-1.17c-.15-.23-.4-.24-.76,0a1.77,1.77,0,0,0-.77.91,5,5,0,0,0-.26,1.48c0,.3,0,.64,0,1S249.85,154.25,249.86,154.54Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "250.905px 152.94px"
    },
    id: "elo2f1srvic6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,149.84a.3.3,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.1,1.95a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "255.15px 149.97px"
    },
    id: "el3ygknneohqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.8,145.6c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A7.87,7.87,0,0,1,261.8,145.6Zm-3.1,3.84a2.38,2.38,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S258.69,149.14,258.7,149.44Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "259.705px 147.835px"
    },
    id: "elw6wtoh2idq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.59,144.73a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.53.53,0,0,1,.15-.15l.6-.34a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.41.41,0,0,1-.14.17l-.63.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.84l-1.1,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "263.992px 144.877px"
    },
    id: "elva9mq6sn84",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.64,140.5c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.86,5.86,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.72,1.72,0,0,1-.95.3A.81.81,0,0,1,267,147a1.79,1.79,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.4,3.4,0,0,1,.95-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.89,6.89,0,0,1,270.64,140.5Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S267.53,144,267.54,144.33Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "268.58px 142.75px"
    },
    id: "els13etjnkeyi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.43,139.63a.35.35,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.24.24,0,0,1,.07.19v7.65a.51.51,0,0,1-.07.26.34.34,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85L272.09,140a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "272.837px 139.762px"
    },
    id: "eldnh7au7274r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.48,135.39c0,.15,0,.31,0,.5V137c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.21,3.21,0,0,1-.95.79,1.81,1.81,0,0,1-1,.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.87,4.87,0,0,1,.63-1.06,3.71,3.71,0,0,1,1-.8,1.86,1.86,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.77,6.77,0,0,1,279.48,135.39Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.41-.23-.77,0a1.72,1.72,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S276.37,138.94,276.38,139.23Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "277.39px 137.625px"
    },
    id: "elesm2hwzfgae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.66,132.4v2.11a9.63,9.63,0,0,1-.14,1.35,5.23,5.23,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.48,3.48,0,0,1-1,.79,1.77,1.77,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.89,1.89,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.78,1.78,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.82,6.82,0,0,1,284.66,132.4Zm-3.1,3.84a2.37,2.37,0,0,0,.26,1.17c.16.22.41.23.77,0a1.69,1.69,0,0,0,.76-.9,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.77,1.77,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S281.55,136,281.56,136.24Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "282.565px 134.64px"
    },
    id: "elztdrpwnnji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.83,129.42c0,.15,0,.31,0,.49V131c0,.18,0,.35,0,.51a10,10,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.72,1.72,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.13-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.4,3.4,0,0,1,.95-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.89,6.89,0,0,1,289.83,129.42Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S286.72,133,286.73,133.26Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "287.765px 131.65px"
    },
    id: "elta3pguw5dei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.62,128.55a.35.35,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.24.24,0,0,1,.07.19v7.65a.51.51,0,0,1-.07.26.39.39,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V127l-1.09,2a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "292.027px 128.682px"
    },
    id: "el5t7o7vov5o7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.67,124.31c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.21,3.21,0,0,1-.95.79,1.83,1.83,0,0,1-1,.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.87,4.87,0,0,1,.63-1.06,3.54,3.54,0,0,1,1-.8,1.86,1.86,0,0,1,.95-.31.91.91,0,0,1,.64.31,2,2,0,0,1,.35.82A6.77,6.77,0,0,1,298.67,124.31Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.76,0a1.69,1.69,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S295.56,127.86,295.57,128.15Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "296.58px 126.545px"
    },
    id: "elyqihiszugn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.47,123.44a.33.33,0,0,1-.05-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.55.55,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "300.835px 123.59px"
    },
    id: "el3x509euxfsl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.51,119.21c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.84,1.84,0,0,1,.35.81A6.89,6.89,0,0,1,307.51,119.21Zm-3.09,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S304.41,122.75,304.42,123.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "305.425px 121.465px"
    },
    id: "elxyjbu8q0te",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.31,118.34a.33.33,0,0,1-.05-.21.72.72,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.23.23,0,0,1,.06.18V122a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "309.675px 118.483px"
    },
    id: "elelval6tjr3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.36,114.1v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,2,2,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.82,6.82,0,0,1,316.36,114.1Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.88,4.88,0,0,0,.27-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S313.25,117.65,313.26,117.94Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "314.27px 116.335px"
    },
    id: "elsw1gxg1nux",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.53,111.12c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.74,1.74,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.9,1.9,0,0,1,1-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.89,6.89,0,0,1,321.53,111.12Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.65,0,1S318.42,114.66,318.43,115Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "319.435px 113.375px"
    },
    id: "elyr7tzibhsa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.7,108.13c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.32,5.32,0,0,1,.36-1.23,4.47,4.47,0,0,1,.62-1.06,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.89,6.89,0,0,1,326.7,108.13ZM323.61,112a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.76,1.76,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S323.59,111.67,323.61,112Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "324.615px 110.36px"
    },
    id: "eltqhr9b7vjs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79,167.9V170a11.86,11.86,0,0,1-.14,1.35,5.94,5.94,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.32,5.32,0,0,1,.36-1.23,4.47,4.47,0,0,1,.62-1.06,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.35.81A7.93,7.93,0,0,1,247.79,167.9Zm-3.11,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.7,1.7,0,0,0-.77.9,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S244.67,171.44,244.68,171.74Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "245.7px 170.125px"
    },
    id: "eldsgp5enoeik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.53,167.06a.29.29,0,0,1,0-.22.52.52,0,0,1,.08-.26l1.66-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.31.31,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "249.93px 167.191px"
    },
    id: "ela1073175xg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.15,165a.29.29,0,0,1,0-.22.52.52,0,0,1,.08-.26l1.66-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V163.4l-1.09,1.95a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "253.55px 165.131px"
    },
    id: "el0k9ruvb5tex",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.76,162.88a.33.33,0,0,1,0-.21.72.72,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "257.167px 163.023px"
    },
    id: "eldun5wnr3ir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.77,158.67v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,2,2,0,0,1-.36-.82,7.73,7.73,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a11.83,11.83,0,0,1,.13-1.36,6,6,0,0,1,.36-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,263.77,158.67Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S260.66,162.22,260.67,162.51Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "261.7px 160.905px"
    },
    id: "elc0czu16ptdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.51,157.83a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21a.53.53,0,0,1,.15-.15l.6-.34a.1.1,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.1.1,0,0,1-.14,0,.22.22,0,0,1-.07-.19v-5.84l-1.09,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "265.91px 157.975px"
    },
    id: "elndp1fz8gafe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.51,153.62c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.83,1.83,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.54,3.54,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A6.77,6.77,0,0,1,272.51,153.62Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.69,1.69,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S269.4,157.17,269.41,157.46Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "270.445px 155.855px"
    },
    id: "elvrkpt7k8zq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.64,150.66v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.77,1.77,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,5.8,5.8,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a8.58,8.58,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4,4,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.7,1.7,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.82,6.82,0,0,1,277.64,150.66Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.59,4.59,0,0,0,.27-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.31,2.31,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S274.53,154.21,274.54,154.5Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "275.57px 152.925px"
    },
    id: "elykbbsf4riqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,147.71c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.24,5.24,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.18,3.18,0,0,1-.95.79,1.75,1.75,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.89,1.89,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1.05,3.4,3.4,0,0,1,.95-.81,1.81,1.81,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.89,6.89,0,0,1,282.76,147.71Zm-3.1,3.83a2.47,2.47,0,0,0,.27,1.17c.15.22.4.23.76,0a1.67,1.67,0,0,0,.77-.9,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S279.65,151.25,279.66,151.54Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "280.695px 149.94px"
    },
    id: "elhs4erns3y7s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.5,146.86a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.55.55,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18V145.3l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "284.907px 147.01px"
    },
    id: "elig9gs16qdv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.51,142.66v2.1a9.63,9.63,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.74,1.74,0,0,1-.95.3.81.81,0,0,1-.63-.31,2,2,0,0,1-.36-.81,8,8,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a12,12,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,291.51,142.66Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.65,0,1S288.4,146.2,288.41,146.49Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "289.44px 144.89px"
    },
    id: "els3l2b3rc4pk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.25,141.81a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.49.49,0,0,1,.15-.14l.59-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.39.39,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85l-1.1,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "293.65px 141.959px"
    },
    id: "elhw8hcdxbgwu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.25,137.61c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.09,10.09,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,2,2,0,0,1,.36.81A6.89,6.89,0,0,1,300.25,137.61Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S297.14,141.15,297.15,141.45Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "298.18px 139.865px"
    },
    id: "elc3igzksxaed",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,136.76a.33.33,0,0,1,0-.21.87.87,0,0,1,.08-.26l1.67-3a1.07,1.07,0,0,1,.13-.21A.41.41,0,0,1,303,133l.6-.35a.11.11,0,0,1,.14,0,.24.24,0,0,1,.07.19v7.65a.51.51,0,0,1-.07.26.39.39,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V135.2l-1.09,2a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "302.397px 136.971px"
    },
    id: "elhumbsywd7d9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,132.56v2.11a11.86,11.86,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A7.93,7.93,0,0,1,309,132.56Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.76,1.76,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S305.89,136.1,305.9,136.4Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "306.91px 134.79px"
    },
    id: "eluob5sh51ihk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.12,129.6c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.83,1.83,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.37,3.37,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.66,6.66,0,0,1,314.12,129.6Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.88,4.88,0,0,0-.27,1.47c0,.3,0,.64,0,1S311,133.14,311,133.44Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "312.05px 131.835px"
    },
    id: "elwuhhbzuny5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.25,126.64v2.11a9.79,9.79,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.87.87,0,0,1-.62-.31,1.88,1.88,0,0,1-.35-.82,6,6,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a8.58,8.58,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.47,4.47,0,0,1,.62-1.06,3.42,3.42,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,319.25,126.64Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S316.14,130.18,316.15,130.48Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "317.16px 128.875px"
    },
    id: "elgkou1xd6qop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,125.8a.28.28,0,0,1,0-.21.47.47,0,0,1,.08-.26l1.67-3,.12-.21A.51.51,0,0,1,322,122l.61-.34a.1.1,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.22.22,0,0,1-.07-.19v-5.85l-1.09,2a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "321.395px 125.973px"
    },
    id: "ele2b52wvn5fw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,121.59c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A7.87,7.87,0,0,1,328,121.59Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S324.88,125.14,324.89,125.43Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "325.93px 123.825px"
    },
    id: "eldjt2bwe2117",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79,182.11v2.1a11.41,11.41,0,0,1-.14,1.35,5.76,5.76,0,0,1-.35,1.22,4.5,4.5,0,0,1-.63,1,3.31,3.31,0,0,1-.95.79,1.77,1.77,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.9,1.9,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.4,4.4,0,0,1,.62-1,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,.95-.3.84.84,0,0,1,.63.31,1.9,1.9,0,0,1,.35.81A7.93,7.93,0,0,1,247.79,182.11Zm-3.11,3.83a2.47,2.47,0,0,0,.27,1.17c.15.22.41.23.77,0a1.73,1.73,0,0,0,.76-.9,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S244.67,185.65,244.68,185.94Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "245.7px 184.365px"
    },
    id: "elgksmuarfigr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.91,179.15c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.23,4,4,0,0,1-.63,1,3.37,3.37,0,0,1-.95.8,1.83,1.83,0,0,1-1,.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1.05,3.27,3.27,0,0,1,1-.81,1.81,1.81,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,252.91,179.15Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S249.8,182.69,249.81,183Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "250.815px 181.39px"
    },
    id: "el2cec661ar85",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,176.19v2.1a9.63,9.63,0,0,1-.14,1.35,5.46,5.46,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,2,2,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24A4.61,4.61,0,0,1,255,175a3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,258,176.19Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.65,0,1S254.93,179.73,254.94,180Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "255.893px 178.425px"
    },
    id: "elhh6pior7abq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.78,175.34a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.2a.51.51,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19V179a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "260.18px 175.485px"
    },
    id: "elxlt9ipahcn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.78,171.14c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a11.87,11.87,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.09,10.09,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.9,1.9,0,0,1,1-.3.81.81,0,0,1,.63.31,2,2,0,0,1,.36.81A8,8,0,0,1,266.78,171.14Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S263.67,174.68,263.68,175Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "264.685px 173.395px"
    },
    id: "elpx3nkojki6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.52,170.29a.33.33,0,0,1,0-.21.65.65,0,0,1,.08-.26l1.67-3a1.07,1.07,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.07.19V174a.63.63,0,0,1-.07.26.39.39,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "268.927px 170.456px"
    },
    id: "el9rhoee9pd1c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.52,166.09c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.32,5.32,0,0,1,.36-1.23,4.47,4.47,0,0,1,.62-1.06,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.87.87,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.89,6.89,0,0,1,275.52,166.09Zm-3.09,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.7,1.7,0,0,0-.77.9,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S272.42,169.63,272.43,169.93Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "273.41px 168.325px"
    },
    id: "elon7aih5ilw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.65,163.13c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36A5.26,5.26,0,0,1,277,163a4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,280.65,163.13Zm-3.1,3.84a2.31,2.31,0,0,0,.27,1.16c.15.23.4.24.76,0a1.77,1.77,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.16-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.59,4.59,0,0,0-.27,1.47c0,.3,0,.64,0,1S277.54,166.67,277.55,167Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "278.58px 165.37px"
    },
    id: "elldy4jl3q87d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.77,160.17c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.8,9.8,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.37,4.37,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.87.87,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.85.85,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.66,6.66,0,0,1,285.77,160.17ZM282.68,164a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S282.67,163.71,282.68,164Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "283.66px 162.405px"
    },
    id: "elhbffqqxz0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.52,159.33a.28.28,0,0,1,0-.21.47.47,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.51.51,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19V163a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36c-.06,0-.1,0-.14,0a.22.22,0,0,1-.07-.19v-5.85l-1.09,2a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "287.92px 159.465px"
    },
    id: "elmo8skuesexo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.52,155.12c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A7.87,7.87,0,0,1,294.52,155.12Zm-3.1,3.84a2.38,2.38,0,0,0,.27,1.17c.15.22.4.23.76,0a1.77,1.77,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.16-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S291.41,158.67,291.42,159Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "292.45px 157.355px"
    },
    id: "el04jcsxuwf3k1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.65,152.16v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,2,2,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36A6,6,0,0,1,296,152a4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,299.65,152.16Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.72,1.72,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S296.54,155.71,296.55,156Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "297.56px 154.385px"
    },
    id: "el7zovugg4ehy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.77,149.2c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,5.77,5.77,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.77,1.77,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4,4,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.72,1.72,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,304.77,149.2Zm-3.1,3.84a2.47,2.47,0,0,0,.27,1.17c.15.22.4.23.76,0a1.69,1.69,0,0,0,.77-.91,4.61,4.61,0,0,0,.26-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S301.66,152.75,301.67,153Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "302.7px 151.44px"
    },
    id: "el096toejc65go",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.51,148.36a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.31.31,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.55.55,0,0,1-.15.18l-.62.35a.11.11,0,0,1-.15,0,.23.23,0,0,1-.06-.18V146.8l-1.09,1.94a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "306.917px 148.507px"
    },
    id: "elz2y1u14jyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.51,144.16c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.46,5.46,0,0,1-.35,1.23,4,4,0,0,1-.63,1,3.52,3.52,0,0,1-.95.8,1.84,1.84,0,0,1-1,.3.8.8,0,0,1-.62-.31,2,2,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.14,6.14,0,0,1,.36-1.24,4.4,4.4,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.89,6.89,0,0,1,313.51,144.16ZM310.42,148a2.37,2.37,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S310.41,147.7,310.42,148Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "311.425px 146.4px"
    },
    id: "el2xia0avr07j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.64,141.2c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.74,1.74,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36A5.54,5.54,0,0,1,315,141a4.31,4.31,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.81,1.81,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.89,6.89,0,0,1,318.64,141.2Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.65,0,1S315.53,144.74,315.54,145Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "316.57px 143.43px"
    },
    id: "el5uj5hs4pafx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.38,140.35a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19V144a.54.54,0,0,1-.07.26.45.45,0,0,1-.14.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85L320,140.73a.33.33,0,0,1-.15.16.15.15,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "320.787px 140.491px"
    },
    id: "el7a06zppbl7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.38,136.15c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.47,3.47,0,0,1-.94.79,1.86,1.86,0,0,1-1,.31.88.88,0,0,1-.63-.32,1.9,1.9,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.13-1.37,6.13,6.13,0,0,1,.35-1.24,5,5,0,0,1,.63-1.05,3.45,3.45,0,0,1,1-.81,1.87,1.87,0,0,1,.94-.3.84.84,0,0,1,.64.31,1.79,1.79,0,0,1,.35.81A6.89,6.89,0,0,1,327.38,136.15ZM324.29,140a2.33,2.33,0,0,0,.26,1.16c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S324.28,139.69,324.29,140Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "325.295px 138.38px"
    },
    id: "ely7vn1yiepmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.4,198.43a.29.29,0,0,1,0-.22.65.65,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "244.8px 198.561px"
    },
    id: "ellbon0igcsqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.32,194.27c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.83,1.83,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.21,3.21,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.81A6.89,6.89,0,0,1,251.32,194.27Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S248.21,197.81,248.22,198.11Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "249.25px 196.5px"
    },
    id: "elxacdyk8q298",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,193.47a.28.28,0,0,1,0-.21A.61.61,0,0,1,252,193l1.67-3a2.39,2.39,0,0,1,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "253.36px 193.62px"
    },
    id: "elqgg9dq5n8vp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.9,189.32c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.77,5.77,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.18,3.18,0,0,1-.95.79,1.75,1.75,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.89,1.89,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1,3.4,3.4,0,0,1,.95-.81,1.81,1.81,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.89,6.89,0,0,1,259.9,189.32Zm-3.1,3.83a2.47,2.47,0,0,0,.27,1.17c.15.22.4.23.76,0a1.7,1.7,0,0,0,.77-.9,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S256.79,192.86,256.8,193.15Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "257.83px 191.575px"
    },
    id: "el485i9mzr9el",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.56,188.52a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19V187l-1.1,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "261.96px 188.667px"
    },
    id: "elxr7vdtemb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.48,184.36c0,.15,0,.31,0,.49V186c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35A6,6,0,0,1,268,189a4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A6.77,6.77,0,0,1,268.48,184.36Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S265.37,187.9,265.38,188.2Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "266.39px 186.555px"
    },
    id: "el4hm10s47mhu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,181.45c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.47,3.47,0,0,1-.94.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10,10,0,0,1,.13-1.36,5.26,5.26,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.42,3.42,0,0,1,1-.8,1.81,1.81,0,0,1,.94-.31.88.88,0,0,1,.64.31,2,2,0,0,1,.35.82A6.66,6.66,0,0,1,273.52,181.45Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.88,4.88,0,0,0-.27,1.47c0,.3,0,.64,0,1S270.41,185,270.42,185.29Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "271.435px 183.685px"
    },
    id: "el3d0qw5m3woa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.18,180.65a.33.33,0,0,1,0-.21.87.87,0,0,1,.08-.26l1.67-3A1.07,1.07,0,0,1,276,177a.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85L274.84,181a.35.35,0,0,1-.15.15.11.11,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "275.557px 180.82px"
    },
    id: "elkhy2sps2rq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.1,176.5c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5A9.66,9.66,0,0,1,282,180a6,6,0,0,1-.35,1.23,5,5,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.84,1.84,0,0,1-.36-.81A6.89,6.89,0,0,1,278,181c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.4,4.4,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,.95-.3.84.84,0,0,1,.63.31,1.9,1.9,0,0,1,.35.81A6.89,6.89,0,0,1,282.1,176.5Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.41.23.77,0a1.75,1.75,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.65,0,1S279,180,279,180.33Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "280.051px 178.78px"
    },
    id: "el413vtugoo0z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,175.7a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.36.36,0,0,1-.15.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "284.167px 175.847px"
    },
    id: "el494syd6bfw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.68,171.54c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.91.91,0,0,1,.63.31,2,2,0,0,1,.35.82A6.77,6.77,0,0,1,290.68,171.54Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.72,1.72,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S287.57,175.09,287.58,175.38Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "288.595px 173.775px"
    },
    id: "elu8u3qziwvm9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.34,170.75a.35.35,0,0,1,0-.22.73.73,0,0,1,.08-.25l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.23.23,0,0,1,.06.18v7.65a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85L292,171.13a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "292.747px 170.893px"
    },
    id: "el9tzwk33t75n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.26,166.59c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.81,1.81,0,0,1-.95.31.86.86,0,0,1-.63-.32,1.9,1.9,0,0,1-.35-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.85,5.85,0,0,1,.35-1.23,4.5,4.5,0,0,1,.63-1.06,3.52,3.52,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.9,1.9,0,0,1,.36.81A6.89,6.89,0,0,1,299.26,166.59Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.41-.23-.77,0a1.72,1.72,0,0,0-.76.91,4.82,4.82,0,0,0-.27,1.47c0,.3,0,.64,0,1S296.15,170.13,296.16,170.43Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "297.195px 168.825px"
    },
    id: "el3sjbvwi06c6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.92,165.79a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a1.37,1.37,0,0,1,.13-.2.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.15.15,0,0,1-.15-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "301.327px 165.94px"
    },
    id: "elzpl4b0alc5t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.46,163.75a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21a.48.48,0,0,1,.15-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.54.54,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.23.23,0,0,1-.07-.18v-5.85l-1.09,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "304.86px 163.9px"
    },
    id: "eldvc7lp4ek65",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.38,159.59c0,.15,0,.32,0,.5v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.77,1.77,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4,4,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.72,1.72,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,311.38,159.59Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.69,1.69,0,0,0,.77-.91,4.61,4.61,0,0,0,.26-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S308.27,163.14,308.28,163.43Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "309.31px 161.83px"
    },
    id: "el4b7y6x505tp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,158.8a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21A.53.53,0,0,1,314,155l.6-.34a.1.1,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.26.26,0,0,1-.07-.19v-5.85l-1.09,2a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "313.39px 158.973px"
    },
    id: "el8iefiwrj02g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,154.64c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a11.87,11.87,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,2,2,0,0,1,.36.82A7.73,7.73,0,0,1,320,154.64Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.88,4.88,0,0,0-.27,1.47c0,.31,0,.64,0,1S316.85,158.18,316.86,158.48Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "317.93px 156.875px"
    },
    id: "elucib558xfye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.62,153.84a.28.28,0,0,1,0-.21.65.65,0,0,1,.08-.26l1.67-3,.12-.21a.53.53,0,0,1,.15-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.26.26,0,0,1-.07-.19v-5.85l-1.09,1.95a.27.27,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "322.02px 153.98px"
    },
    id: "elwy8rrlvrzz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.16,151.8a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.21a.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "325.56px 151.95px"
    },
    id: "elh8q7lad5p0i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79,210.52v2.1a11.41,11.41,0,0,1-.14,1.35,6,6,0,0,1-.35,1.23,4.66,4.66,0,0,1-.63,1,3.52,3.52,0,0,1-.95.8,1.84,1.84,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.9,1.9,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.55,5.55,0,0,1,.36-1.24,4.4,4.4,0,0,1,.62-1.05,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,.95-.3.84.84,0,0,1,.63.31,1.9,1.9,0,0,1,.35.81A7.93,7.93,0,0,1,247.79,210.52Zm-3.11,3.83a2.47,2.47,0,0,0,.27,1.17c.15.22.41.23.77,0a1.75,1.75,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S244.67,214.06,244.68,214.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "245.7px 212.76px"
    },
    id: "elg1rp4aheklo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.91,207.56c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.23,4,4,0,0,1-.63,1,3.37,3.37,0,0,1-.95.8,1.83,1.83,0,0,1-1,.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1.05,3.27,3.27,0,0,1,1-.81,1.81,1.81,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A8,8,0,0,1,252.91,207.56Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.65,0,1S249.8,211.1,249.81,211.39Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "250.815px 209.8px"
    },
    id: "elobemj8uez98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.65,206.71a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.71.71,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.15.15,0,0,1-.15-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "255.057px 206.86px"
    },
    id: "elmuny0d2peza",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.65,202.51c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.47,3.47,0,0,1-.94.79,1.75,1.75,0,0,1-1,.3A.8.8,0,0,1,258,209a1.79,1.79,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.13-1.37,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1,3.45,3.45,0,0,1,1-.81,1.87,1.87,0,0,1,.94-.3.84.84,0,0,1,.64.31,1.79,1.79,0,0,1,.35.81A6.89,6.89,0,0,1,261.65,202.51Zm-3.09,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.23.77,0a1.75,1.75,0,0,0,.76-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S258.54,206.05,258.56,206.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "259.58px 204.775px"
    },
    id: "eleslie67ua1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.4,201.66a.28.28,0,0,1,0-.21.52.52,0,0,1,.08-.26l1.66-3a1.93,1.93,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V200.1l-1.09,2a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "263.8px 201.8px"
    },
    id: "el7z46obw7wae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.4,197.46c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.09,3.09,0,0,1,.95-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.83,6.83,0,0,1,270.4,197.46Zm-3.1,3.84a2.44,2.44,0,0,0,.26,1.16c.16.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.38,4.38,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.25,2.25,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.81,1.81,0,0,0-.77.91,5,5,0,0,0-.26,1.48c0,.3,0,.64,0,1S267.29,201,267.3,201.3Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "268.33px 199.69px"
    },
    id: "ely14min9evdt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.52,194.5c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.32,5.32,0,0,1,.36-1.23,4.47,4.47,0,0,1,.62-1.06,3.42,3.42,0,0,1,1-.8,1.81,1.81,0,0,1,1-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.66,6.66,0,0,1,275.52,194.5Zm-3.09,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.61,4.61,0,0,0-.26,1.47c0,.3,0,.64,0,1S272.42,198,272.43,198.34Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "273.41px 196.735px"
    },
    id: "el1q3megxb03s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.65,191.54c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a9.79,9.79,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31A.85.85,0,0,1,277,198a1.79,1.79,0,0,1-.35-.81,6.82,6.82,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.73,0-1a9.94,9.94,0,0,1,.14-1.36,5.26,5.26,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,280.65,191.54Zm-3.1,3.84a2.31,2.31,0,0,0,.27,1.16c.15.23.4.24.76,0a1.77,1.77,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.4,2.4,0,0,0-.26-1.17c-.16-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S277.54,195.08,277.55,195.38Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "278.58px 193.775px"
    },
    id: "ellz6uzd3h7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.39,190.7a.33.33,0,0,1,0-.21.57.57,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.1.1,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.64a.48.48,0,0,1-.07.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "282.797px 190.843px"
    },
    id: "el2clajt7yion",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,188.61a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.1.1,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19V187l-1.09,2a.35.35,0,0,1-.15.15.12.12,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "286.4px 188.753px"
    },
    id: "elx1s77yuq7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,184.4c0,.15,0,.31,0,.5V186c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.3,3.3,0,0,1-.94.79,1.89,1.89,0,0,1-1,.31.87.87,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.39,5.39,0,0,1,.35-1.24,4.87,4.87,0,0,1,.63-1.06,3.44,3.44,0,0,1,1-.8,1.81,1.81,0,0,1,.94-.31.91.91,0,0,1,.64.31,2,2,0,0,1,.35.82A6.77,6.77,0,0,1,293,184.4Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.72,1.72,0,0,0,.76-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S289.9,188,289.91,188.24Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "290.915px 186.625px"
    },
    id: "elks7er6wmuz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.14,181.44c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A8,8,0,0,1,298.14,181.44Zm-3.1,3.84a2.38,2.38,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.16-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S295,185,295,185.28Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "296.07px 183.675px"
    },
    id: "el8q2exp4wx3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.88,180.6a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.6-.34a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.41.41,0,0,1-.14.17l-.63.36a.1.1,0,0,1-.14,0,.25.25,0,0,1-.06-.19V179L299.54,181a.32.32,0,0,1-.16.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "300.28px 180.747px"
    },
    id: "elyxrlzaw1h7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.88,176.4c0,.14,0,.31,0,.49V178c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.24,5.24,0,0,1-.36,1.22,3.9,3.9,0,0,1-.63,1,3.06,3.06,0,0,1-.95.79,1.75,1.75,0,0,1-.95.31.85.85,0,0,1-.63-.31,2,2,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.13,6.13,0,0,1,.35-1.24,4.44,4.44,0,0,1,.63-1.05,3.4,3.4,0,0,1,.95-.81,1.83,1.83,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.89,6.89,0,0,1,306.88,176.4Zm-3.1,3.83a2.47,2.47,0,0,0,.27,1.17c.15.22.41.23.76,0a1.7,1.7,0,0,0,.77-.9,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S303.77,179.94,303.78,180.23Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "304.815px 178.63px"
    },
    id: "elp9w7wt3i9pb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,175.55a.33.33,0,0,1-.05-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.37.37,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18V174l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "308.995px 175.7px"
    },
    id: "elttfsstzbgb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.25,173.46a.33.33,0,0,1-.05-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.13.13,0,0,1-.15,0,.27.27,0,0,1-.06-.19V171.9l-1.09,1.94c0,.08-.1.14-.15.15a.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "312.615px 173.609px"
    },
    id: "el3h4nlr77lan",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.25,169.26v2.1a9.63,9.63,0,0,1-.14,1.35,5.31,5.31,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.75,1.75,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.84,1.84,0,0,1-.35-.81,6,6,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a8.71,8.71,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.61,4.61,0,0,1,.62-1,3.45,3.45,0,0,1,1-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,319.25,169.26Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.15.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.43,2.43,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S316.14,172.8,316.15,173.09Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "317.16px 171.515px"
    },
    id: "el9su69ds0zbo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.37,166.3c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.83,1.83,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6,6,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a8.72,8.72,0,0,1,.13-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.4,3.4,0,0,1,.95-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.84,1.84,0,0,1,.36.81A6.89,6.89,0,0,1,324.37,166.3Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S321.26,169.84,321.27,170.14Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "322.305px 168.555px"
    },
    id: "eln3sxnz1kf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.11,165.45a.33.33,0,0,1,0-.21.87.87,0,0,1,.08-.26l1.67-3a1.93,1.93,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "326.517px 165.59px"
    },
    id: "el4h9rbzonpkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79,224.72v2.11a11.63,11.63,0,0,1-.14,1.35,5.94,5.94,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.87.87,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.35.82A7.64,7.64,0,0,1,247.79,224.72Zm-3.11,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S244.67,228.26,244.68,228.56Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "245.7px 226.955px"
    },
    id: "elqpfhcro258",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.91,221.76c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,1-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A7.87,7.87,0,0,1,252.91,221.76Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.67,1.67,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S249.8,225.3,249.81,225.6Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "250.815px 223.995px"
    },
    id: "el30h3axvfeg9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.65,220.92a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.47.47,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "255.057px 221.065px"
    },
    id: "eltya4g95y6hk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.65,216.71c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.41,4.41,0,0,1-.64,1,3.3,3.3,0,0,1-.94.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.94-.31.91.91,0,0,1,.64.31,1.88,1.88,0,0,1,.35.82A6.88,6.88,0,0,1,261.65,216.71Zm-3.09,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.72,1.72,0,0,0,.76-.91,4.61,4.61,0,0,0,.26-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S258.54,220.26,258.56,220.55Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "259.565px 218.945px"
    },
    id: "elq9v83ic7ckh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.4,215.87a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.36.36,0,0,1-.15.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "263.8px 216.017px"
    },
    id: "el6mo24aahso9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,213.78a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21A.41.41,0,0,1,268,210l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.36.36,0,0,1-.15.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "267.397px 213.977px"
    },
    id: "el9gvemp7kro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,209.58c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.23,5.23,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.31,3.31,0,0,1-.95.79,1.77,1.77,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.89,1.89,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,274,209.58Zm-3.1,3.83a2.49,2.49,0,0,0,.26,1.17c.16.22.41.23.77,0a1.65,1.65,0,0,0,.76-.9,4.66,4.66,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.31,2.31,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.77,1.77,0,0,0-.77.91,5,5,0,0,0-.26,1.47c0,.31,0,.64,0,1S270.91,213.12,270.92,213.41Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "271.93px 211.835px"
    },
    id: "elgesr08d8gjo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.76,208.73a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.37.37,0,0,1,.14-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.54.54,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.23.23,0,0,1-.06-.18v-5.85l-1.1,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "276.161px 208.88px"
    },
    id: "elh6v9h7yoj1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,204.53c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.32,5.32,0,0,1-.36,1.23,4.25,4.25,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.72,1.72,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1.05,3.4,3.4,0,0,1,.95-.81,1.9,1.9,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.89,6.89,0,0,1,282.76,204.53Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S279.65,208.07,279.66,208.36Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "280.695px 206.76px"
    },
    id: "eldhkwnfe4cr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.89,201.57v2.11a9.65,9.65,0,0,1-.14,1.34,5.31,5.31,0,0,1-.35,1.23,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.74,1.74,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.09,10.09,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.88,1.88,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,287.89,201.57Zm-3.1,3.83a2.34,2.34,0,0,0,.26,1.17c.16.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.65,0-1s0-.69,0-1a2.32,2.32,0,0,0-.27-1.17c-.15-.23-.4-.23-.76,0a1.77,1.77,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S284.78,205.11,284.79,205.4Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "285.82px 203.82px"
    },
    id: "elrajlle1da7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.63,200.72a.28.28,0,0,1,0-.21.65.65,0,0,1,.08-.26l1.67-3,.12-.21a.43.43,0,0,1,.15-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.1,2a.27.27,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "290.03px 200.86px"
    },
    id: "elhxzon281oe9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.63,196.52c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.37,3.37,0,0,1-.95.79,1.83,1.83,0,0,1-.95.31A.86.86,0,0,1,293,203a1.79,1.79,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.54,5.54,0,0,1,.35-1.24,4.65,4.65,0,0,1,.63-1.05,3.21,3.21,0,0,1,.95-.8,1.86,1.86,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.9,1.9,0,0,1,.36.81A6.89,6.89,0,0,1,296.63,196.52Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.75,1.75,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S293.52,200.06,293.53,200.36Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "294.575px 198.76px"
    },
    id: "elqckorhxwlw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.76,193.56v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.91,1.91,0,0,1-.36-.81,8,8,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a11.83,11.83,0,0,1,.13-1.36,5.78,5.78,0,0,1,.36-1.24,4.19,4.19,0,0,1,.63-1.06,3.24,3.24,0,0,1,.95-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,301.76,193.56Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.61,4.61,0,0,0-.26,1.47c0,.3,0,.64,0,1S298.65,197.1,298.66,197.4Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "299.69px 195.795px"
    },
    id: "el3uihue2rqeu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.88,190.6c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.8,9.8,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.37,3.37,0,0,1-.95.79,1.83,1.83,0,0,1-.95.31.86.86,0,0,1-.63-.32,1.9,1.9,0,0,1-.35-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10,10,0,0,1,.13-1.36,5.78,5.78,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.37,3.37,0,0,1,.95-.8,1.86,1.86,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.66,6.66,0,0,1,306.88,190.6Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.72,1.72,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S303.77,194.14,303.78,194.44Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "304.815px 192.835px"
    },
    id: "el6eyuitye5aq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,189.76a.33.33,0,0,1-.05-.21.72.72,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "308.995px 189.903px"
    },
    id: "elcsk73l7atfm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.63,185.55c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.71,6.71,0,0,1,315.63,185.55Zm-3.1,3.84a2.52,2.52,0,0,0,.26,1.17c.16.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.38,2.38,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,5,5,0,0,0-.26,1.47c0,.31,0,.64,0,1S312.52,189.09,312.53,189.39Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "313.56px 187.785px"
    },
    id: "elwr82mor1g2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.37,184.71a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.53.53,0,0,1,.15-.15l.6-.34a.1.1,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.1.1,0,0,1-.14,0,.26.26,0,0,1-.07-.19v-5.84L317,185.09a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "317.77px 184.855px"
    },
    id: "elgew8303g61r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.37,180.5c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.83,1.83,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,5.85,5.85,0,0,1-.13-1.19c0-.29,0-.63,0-1s0-.72,0-1a8.59,8.59,0,0,1,.13-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.54,3.54,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.88,6.88,0,0,1,324.37,180.5Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.69,1.69,0,0,0,.77-.91,4.61,4.61,0,0,0,.26-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S321.26,184.05,321.27,184.34Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "322.305px 182.735px"
    },
    id: "ele2spzt83w5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.11,179.66a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3L327,176a.41.41,0,0,1,.14-.15l.6-.34a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.43.43,0,0,1-.15.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19V178.1L325.77,180a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "326.522px 179.827px"
    },
    id: "elimcl6oa5ge9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.4,241a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.54.54,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.14.14,0,0,1-.15-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "244.8px 241.15px"
    },
    id: "elh61ibvqn9gf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,239a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.49.49,0,0,1,.15-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85l-1.1,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "248.4px 239.15px"
    },
    id: "els8vkfuvsu8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,234.75c0,.15,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.32,5.32,0,0,1-.36,1.23,4.07,4.07,0,0,1-.63,1,3.37,3.37,0,0,1-1,.79,1.83,1.83,0,0,1-.95.31.86.86,0,0,1-.63-.32,1.9,1.9,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.13-1.37,6.13,6.13,0,0,1,.35-1.24,4.65,4.65,0,0,1,.63-1.05,3.4,3.4,0,0,1,.95-.81,1.93,1.93,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.89,6.89,0,0,1,255,234.75Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.65,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.77,0a1.75,1.75,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S251.91,238.29,251.92,238.59Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "252.91px 236.98px"
    },
    id: "elcbjy4upvhb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.76,233.9a.33.33,0,0,1,0-.21.87.87,0,0,1,.08-.26l1.67-3a1.07,1.07,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.12.12,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "257.167px 234.04px"
    },
    id: "el1eeyet7ek2y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.77,229.7v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.85.85,0,0,1-.63-.32,1.91,1.91,0,0,1-.36-.81,8,8,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a12.23,12.23,0,0,1,.13-1.37,5.86,5.86,0,0,1,.36-1.23,4.19,4.19,0,0,1,.63-1.06,3.09,3.09,0,0,1,.95-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.83,6.83,0,0,1,263.77,229.7Zm-3.1,3.84a2.33,2.33,0,0,0,.26,1.16c.15.23.41.24.77,0a1.71,1.71,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.7,1.7,0,0,0-.77.9,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S260.66,233.24,260.67,233.54Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "261.7px 231.935px"
    },
    id: "elijpddjfd9ml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.89,226.74c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.51,3.51,0,0,1-.95.79,1.83,1.83,0,0,1-.95.31.86.86,0,0,1-.63-.32,1.9,1.9,0,0,1-.35-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10,10,0,0,1,.13-1.36,5.78,5.78,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.37,3.37,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.89,1.89,0,0,1,.36.82A6.66,6.66,0,0,1,268.89,226.74Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.72,1.72,0,0,0-.76.91,4.88,4.88,0,0,0-.27,1.47c0,.3,0,.64,0,1S265.78,230.28,265.79,230.58Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "266.825px 228.975px"
    },
    id: "elvr5xvpuosh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.64,225.9a.34.34,0,0,1-.05-.22.87.87,0,0,1,.08-.26l1.67-3,.13-.21a.41.41,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "271.004px 226.031px"
    },
    id: "elnceslt57yb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.64,221.69v2.11a9.79,9.79,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.87.87,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,5.89,5.89,0,0,1-.14-1.19c0-.3,0-.64,0-1s0-.72,0-1a8.58,8.58,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,277.64,221.69Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.38,2.38,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.69,1.69,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S274.53,225.23,274.54,225.53Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "275.57px 223.925px"
    },
    id: "eldw4do5jwhru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.38,220.85a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21a.51.51,0,0,1,.14-.15l.61-.34a.1.1,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.22.22,0,0,1-.07-.19v-5.85L279,221.23a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "279.78px 220.993px"
    },
    id: "elthts4b9y4gk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,218.76a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.67-3,.12-.21a.51.51,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.1.1,0,0,1-.14,0,.22.22,0,0,1-.07-.19V217.2l-1.09,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "283.4px 218.905px"
    },
    id: "el73fsol2rrlu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,214.55c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.83,1.83,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A6.88,6.88,0,0,1,290,214.55Zm-3.1,3.84a2.5,2.5,0,0,0,.27,1.17c.15.22.4.23.76,0a1.69,1.69,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S286.89,218.1,286.9,218.39Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "287.93px 216.785px"
    },
    id: "el29vmh33df56",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.74,213.71a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.54.54,0,0,1-.07.26.41.41,0,0,1-.14.17l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.84l-1.09,1.94a.35.35,0,0,1-.15.15.13.13,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "292.147px 213.857px"
    },
    id: "el6to6pxglo54",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.74,209.51c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.23,5.23,0,0,1-.35,1.22,3.93,3.93,0,0,1-.64,1,3.14,3.14,0,0,1-.94.79,1.77,1.77,0,0,1-1,.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.11,10.11,0,0,1,.13-1.36,6.13,6.13,0,0,1,.35-1.24,4.8,4.8,0,0,1,.63-1,3.45,3.45,0,0,1,1-.81,1.78,1.78,0,0,1,.94-.3.83.83,0,0,1,.64.31,1.79,1.79,0,0,1,.35.81A6.89,6.89,0,0,1,298.74,209.51Zm-3.09,3.83a2.37,2.37,0,0,0,.26,1.17c.15.22.41.23.77,0a1.73,1.73,0,0,0,.76-.9,5,5,0,0,0,.27-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S295.64,213.05,295.65,213.34Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "296.655px 211.765px"
    },
    id: "el7dpt0sojiye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.87,206.55c0,.14,0,.31,0,.49v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,6,6,0,0,1-.36,1.23,4,4,0,0,1-.63,1,3.52,3.52,0,0,1-.95.8,1.83,1.83,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.84,1.84,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4.13,4.13,0,0,1,.63-1,3.27,3.27,0,0,1,.95-.81,1.78,1.78,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.91,1.91,0,0,1,.36.81A6.89,6.89,0,0,1,303.87,206.55Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.22.4.23.76,0a1.73,1.73,0,0,0,.77-.91,4.68,4.68,0,0,0,.26-1.48c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S300.76,210.09,300.77,210.38Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "301.8px 208.815px"
    },
    id: "elfksp7s9229n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.61,205.7a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.63.63,0,0,1-.21.44l-.63.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.14.14,0,0,1-.15-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "306.017px 205.85px"
    },
    id: "el140ydpjmt33",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.23,203.61a.33.33,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.11.11,0,0,1,.14,0,.22.22,0,0,1,.07.19v7.65a.54.54,0,0,1-.07.26.45.45,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.27.27,0,0,1-.06-.19v-5.85L308.89,204a.33.33,0,0,1-.15.16.14.14,0,0,1-.15-.05Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "309.637px 203.76px"
    },
    id: "el5o2dc8jh2zf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.23,199.41c0,.14,0,.31,0,.49V201c0,.18,0,.35,0,.51a9.66,9.66,0,0,1-.13,1.34,5.85,5.85,0,0,1-.35,1.23,4.62,4.62,0,0,1-.64,1,3.47,3.47,0,0,1-.94.79,1.77,1.77,0,0,1-1,.3.8.8,0,0,1-.62-.31,1.79,1.79,0,0,1-.36-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.1,10.1,0,0,1,.13-1.37,5.55,5.55,0,0,1,.36-1.24,4.61,4.61,0,0,1,.62-1.05,3.31,3.31,0,0,1,1-.81,1.87,1.87,0,0,1,.94-.3.84.84,0,0,1,.64.31,1.9,1.9,0,0,1,.35.81A6.89,6.89,0,0,1,316.23,199.41Zm-3.1,3.83a2.43,2.43,0,0,0,.27,1.17c.15.23.41.23.77,0a1.75,1.75,0,0,0,.76-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.65,0-1s0-.69,0-1a2.34,2.34,0,0,0-.26-1.17c-.15-.23-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S313.12,203,313.13,203.24Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "314.145px 201.625px"
    },
    id: "elpr2zgnimhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.36,196.45c0,.15,0,.31,0,.49v1.11c0,.19,0,.35,0,.51a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.85.85,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37,5.54,5.54,0,0,1,.35-1.24,4.31,4.31,0,0,1,.63-1,3.09,3.09,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.81.81,0,0,1,.63.31,1.89,1.89,0,0,1,.35.81A6.83,6.83,0,0,1,321.36,196.45Zm-3.1,3.84a2.31,2.31,0,0,0,.27,1.16c.15.23.4.24.76,0a1.77,1.77,0,0,0,.77-.91,5,5,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.49,2.49,0,0,0-.26-1.17c-.16-.22-.41-.23-.77,0a1.71,1.71,0,0,0-.76.91,4.66,4.66,0,0,0-.27,1.48c0,.3,0,.64,0,1S318.25,200,318.26,200.29Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "319.265px 198.705px"
    },
    id: "elte79gqdoeyk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.48,193.49c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,5.94,5.94,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.84.84,0,0,1-.62-.32,1.79,1.79,0,0,1-.36-.81,6.88,6.88,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.32,5.32,0,0,1,.36-1.23,4.47,4.47,0,0,1,.62-1.06,3.26,3.26,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.35.81A6.89,6.89,0,0,1,326.48,193.49Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.47,2.47,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.7,1.7,0,0,0-.77.9,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S323.37,197,323.38,197.33Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "324.395px 195.725px"
    },
    id: "ely3bcx1gt69k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79,253.13v2.11a11.41,11.41,0,0,1-.14,1.35,5.94,5.94,0,0,1-.35,1.22,4.73,4.73,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.86,1.86,0,0,1-1,.31.83.83,0,0,1-.62-.31,1.89,1.89,0,0,1-.36-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,5.4,5.4,0,0,1,.36-1.24,4.47,4.47,0,0,1,.62-1.06,3.59,3.59,0,0,1,1-.8,1.81,1.81,0,0,1,.95-.31.91.91,0,0,1,.63.31,2,2,0,0,1,.35.82A7.79,7.79,0,0,1,247.79,253.13ZM244.68,257a2.5,2.5,0,0,0,.27,1.17c.15.22.41.23.77,0a1.75,1.75,0,0,0,.76-.91,4.94,4.94,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.5,2.5,0,0,0-.27-1.17c-.15-.22-.41-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.94,4.94,0,0,0-.27,1.47c0,.31,0,.64,0,1S244.67,256.68,244.68,257Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "245.7px 255.365px"
    },
    id: "eldwwouc8koso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.44,252.34a.35.35,0,0,1,0-.22.87.87,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19V256a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "249.846px 252.476px"
    },
    id: "elmco5tl93tmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,250.29a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3a1.07,1.07,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.11.11,0,0,1,.14,0,.27.27,0,0,1,.06.19V254a.62.62,0,0,1-.06.26.39.39,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,2a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "253.4px 250.455px"
    },
    id: "elpq6vwcmxuvf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.52,248.25a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.62.62,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36c-.06,0-.1,0-.14,0a.24.24,0,0,1-.07-.19v-5.85l-1.09,1.94a.26.26,0,0,1-.15.16.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "256.92px 248.387px"
    },
    id: "eltwv2vndgf9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.05,246.21a.33.33,0,0,1,0-.21.79.79,0,0,1,.08-.26l1.67-3,.13-.21a.31.31,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.55.55,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.23.23,0,0,1-.06-.18v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "260.457px 246.36px"
    },
    id: "elzgruf43z1x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,242.05c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35,5.37,5.37,0,0,1-.35,1.22,4.21,4.21,0,0,1-.64,1,3.21,3.21,0,0,1-1,.79,1.81,1.81,0,0,1-.95.31.87.87,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.66,6.66,0,0,1-.13-1.19c0-.3,0-.63,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.87,4.87,0,0,1,.63-1.06,3.71,3.71,0,0,1,.95-.8,1.86,1.86,0,0,1,1-.31.91.91,0,0,1,.64.31,1.88,1.88,0,0,1,.35.82A6.88,6.88,0,0,1,267,242.05Zm-3.09,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.76,0a1.69,1.69,0,0,0,.77-.91,4.88,4.88,0,0,0,.27-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.42,2.42,0,0,0-.27-1.16c-.15-.23-.41-.24-.77,0a1.75,1.75,0,0,0-.76.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S263.87,245.6,263.88,245.89Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "264.91px 244.285px"
    },
    id: "elfgjtkvqul97",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,239.14v2.11a9.63,9.63,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.07,4.07,0,0,1-.63,1,3.67,3.67,0,0,1-.95.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.71,6.71,0,0,1-.14-1.19c0-.3,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.81,1.81,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.88,1.88,0,0,1,.35.82A6.59,6.59,0,0,1,272,239.14Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.16.22.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.38,2.38,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.73,1.73,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S268.91,242.69,268.92,243Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "269.93px 241.375px"
    },
    id: "elf2bwc3fnirp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.68,238.35a.3.3,0,0,1,0-.22.52.52,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.13.13,0,0,1,.15,0,.27.27,0,0,1,.06.19V242a.62.62,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95a.35.35,0,0,1-.15.15.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "274.08px 238.481px"
    },
    id: "el7teze4t9fkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.6,234.19v2.11a10,10,0,0,1-.14,1.35,5.37,5.37,0,0,1-.35,1.22,4.25,4.25,0,0,1-.63,1,3.67,3.67,0,0,1-1,.79,1.74,1.74,0,0,1-.95.3.81.81,0,0,1-.63-.31,1.79,1.79,0,0,1-.35-.81,6.83,6.83,0,0,1-.14-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.25,10.25,0,0,1,.14-1.37A5.54,5.54,0,0,1,277,234a4.31,4.31,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.88,1.88,0,0,1,1-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.83,6.83,0,0,1,280.6,234.19ZM277.5,238a2.33,2.33,0,0,0,.26,1.16c.16.23.41.23.77,0a1.71,1.71,0,0,0,.76-.91,4.65,4.65,0,0,0,.27-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.32,2.32,0,0,0-.27-1.17c-.15-.22-.4-.23-.76,0a1.77,1.77,0,0,0-.77.91,4.68,4.68,0,0,0-.26,1.48c0,.3,0,.64,0,1S277.49,237.73,277.5,238Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "278.511px 236.4px"
    },
    id: "elw44gom3hcp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.26,233.39a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.45.45,0,0,1-.15.18l-.62.36a.14.14,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.35.35,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "282.66px 233.538px"
    },
    id: "el5b0z807vl8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.18,229.23v2.11a9.63,9.63,0,0,1-.14,1.35,5.23,5.23,0,0,1-.35,1.22,3.9,3.9,0,0,1-.63,1,3.48,3.48,0,0,1-.95.79,1.77,1.77,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a10.1,10.1,0,0,1,.14-1.36,5.54,5.54,0,0,1,.35-1.24,4,4,0,0,1,.63-1.05,3.27,3.27,0,0,1,.95-.81,1.7,1.7,0,0,1,.95-.3.81.81,0,0,1,.63.31,1.79,1.79,0,0,1,.35.81A6.82,6.82,0,0,1,289.18,229.23Zm-3.1,3.84a2.4,2.4,0,0,0,.26,1.17c.16.22.41.23.77,0a1.67,1.67,0,0,0,.76-.91,4.59,4.59,0,0,0,.27-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.31,2.31,0,0,0-.27-1.16c-.15-.23-.4-.24-.76,0a1.77,1.77,0,0,0-.77.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S286.07,232.78,286.08,233.07Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "287.11px 231.47px"
    },
    id: "ellkt8ra4tron",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.84,228.44a.28.28,0,0,1,0-.21.5.5,0,0,1,.08-.26l1.66-3a2.39,2.39,0,0,0,.13-.21.41.41,0,0,1,.14-.15l.6-.34a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.64a.58.58,0,0,1-.06.26.35.35,0,0,1-.15.18l-.62.36a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85l-1.09,1.95c-.05.08-.09.13-.15.15a.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "291.24px 228.585px"
    },
    id: "elbwkv8y7ja9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.37,226.4a.33.33,0,0,1,0-.21.72.72,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.14.14,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.58.58,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-5.85L294,226.78a.35.35,0,0,1-.15.15.12.12,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "294.777px 226.542px"
    },
    id: "el8trcfd8cvuf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.29,222.24c0,.15,0,.31,0,.49v1.12c0,.18,0,.34,0,.5a10,10,0,0,1-.13,1.35,4.92,4.92,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.37,3.37,0,0,1-.95.79,1.81,1.81,0,0,1-1,.31.86.86,0,0,1-.63-.32,1.9,1.9,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,6.13,6.13,0,0,1,.35-1.24,4.65,4.65,0,0,1,.63-1.05,3.35,3.35,0,0,1,1-.8,1.86,1.86,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.79,1.79,0,0,1,.36.81A6.89,6.89,0,0,1,301.29,222.24Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.79,1.79,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S298.18,225.78,298.19,226.08Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "299.2px 224.47px"
    },
    id: "eldfe3e11ne5u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,221.44a.33.33,0,0,1,0-.21A.79.79,0,0,1,302,221l1.67-3a2.39,2.39,0,0,1,.13-.21.47.47,0,0,1,.14-.14l.6-.35a.12.12,0,0,1,.15,0,.25.25,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.27.27,0,0,1-.06-.19v-5.85l-1.09,1.94a.33.33,0,0,1-.15.16.13.13,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "303.367px 221.62px"
    },
    id: "elus9h4jhyek7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.49,219.4a.28.28,0,0,1,0-.21.61.61,0,0,1,.08-.26l1.67-3,.12-.21a.48.48,0,0,1,.15-.14l.6-.35a.11.11,0,0,1,.14,0,.25.25,0,0,1,.06.19v7.65a.65.65,0,0,1-.06.26.54.54,0,0,1-.14.18l-.63.36a.11.11,0,0,1-.14,0,.23.23,0,0,1-.06-.18v-5.85l-1.1,1.94a.27.27,0,0,1-.15.15.11.11,0,0,1-.14,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "306.89px 219.55px"
    },
    id: "elhdj9czkvb4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.41,215.24c0,.15,0,.31,0,.5v1.11c0,.18,0,.35,0,.5a11.44,11.44,0,0,1-.13,1.35,6,6,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.34,3.34,0,0,1-1,.79,1.86,1.86,0,0,1-.95.31.84.84,0,0,1-.63-.31,1.88,1.88,0,0,1-.35-.82,6.59,6.59,0,0,1-.14-1.19c0-.29,0-.63,0-1s0-.72,0-1a9.94,9.94,0,0,1,.14-1.36,5.39,5.39,0,0,1,.35-1.24,4.19,4.19,0,0,1,.63-1.06,3.4,3.4,0,0,1,.95-.8,1.83,1.83,0,0,1,1-.31.87.87,0,0,1,.63.31,2,2,0,0,1,.36.82A8,8,0,0,1,313.41,215.24Zm-3.1,3.84a2.38,2.38,0,0,0,.27,1.17c.15.22.4.23.76,0a1.69,1.69,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.3,0-.64,0-1s0-.69,0-1a2.33,2.33,0,0,0-.26-1.16c-.15-.23-.41-.24-.77,0a1.71,1.71,0,0,0-.76.91,4.65,4.65,0,0,0-.27,1.47c0,.31,0,.64,0,1S310.3,218.79,310.31,219.08Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "311.315px 217.475px"
    },
    id: "elwyzpinw179i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.45,212.33c0,.15,0,.31,0,.49v1.12c0,.18,0,.35,0,.5a9.66,9.66,0,0,1-.13,1.35A4.92,4.92,0,0,1,318,217a4.07,4.07,0,0,1-.63,1,3.21,3.21,0,0,1-.95.79,1.81,1.81,0,0,1-.95.31.85.85,0,0,1-.63-.31,2,2,0,0,1-.35-.82,6.77,6.77,0,0,1-.13-1.19c0-.3,0-.64,0-1s0-.72,0-1a10,10,0,0,1,.13-1.36,6,6,0,0,1,.35-1.24,4.5,4.5,0,0,1,.63-1.06,3.71,3.71,0,0,1,.95-.8,1.86,1.86,0,0,1,.95-.31.84.84,0,0,1,.63.31,1.78,1.78,0,0,1,.36.82A6.66,6.66,0,0,1,318.45,212.33Zm-3.09,3.84a2.4,2.4,0,0,0,.26,1.17c.15.22.41.23.76,0a1.73,1.73,0,0,0,.77-.91,4.66,4.66,0,0,0,.26-1.47c0-.31,0-.64,0-1s0-.7,0-1a2.4,2.4,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.72,1.72,0,0,0-.76.91,4.66,4.66,0,0,0-.26,1.47c0,.31,0,.64,0,1S315.34,215.87,315.36,216.17Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "316.405px 214.555px"
    },
    id: "elqw9d645xuzq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.11,211.54a.35.35,0,0,1,0-.22.87.87,0,0,1,.08-.26l1.67-3a2.39,2.39,0,0,1,.13-.21.41.41,0,0,1,.14-.15l.6-.35a.14.14,0,0,1,.15,0,.27.27,0,0,1,.06.19v7.65a.62.62,0,0,1-.06.26.4.4,0,0,1-.15.18l-.62.36a.12.12,0,0,1-.15,0,.25.25,0,0,1-.06-.19V210l-1.09,1.95a.35.35,0,0,1-.15.15.14.14,0,0,1-.15,0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "320.516px 211.672px"
    },
    id: "el5r8ctcqhox7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,207.38c0,.15,0,.31,0,.49V209c0,.19,0,.35,0,.51a10,10,0,0,1-.13,1.35,5.39,5.39,0,0,1-.36,1.22,4.07,4.07,0,0,1-.63,1,3.37,3.37,0,0,1-1,.79,1.83,1.83,0,0,1-.95.31.86.86,0,0,1-.63-.32,1.79,1.79,0,0,1-.35-.81,6.89,6.89,0,0,1-.13-1.2c0-.29,0-.63,0-1s0-.73,0-1a10.26,10.26,0,0,1,.13-1.37,5.54,5.54,0,0,1,.35-1.24,4.65,4.65,0,0,1,.63-1.05,3.4,3.4,0,0,1,.95-.81,1.93,1.93,0,0,1,1-.3.81.81,0,0,1,.63.31,1.84,1.84,0,0,1,.36.81A6.89,6.89,0,0,1,327,207.38Zm-3.1,3.84a2.42,2.42,0,0,0,.27,1.16c.15.23.41.24.76,0a1.73,1.73,0,0,0,.77-.91A4.66,4.66,0,0,0,326,210c0-.31,0-.64,0-1s0-.69,0-1a2.37,2.37,0,0,0-.26-1.17c-.15-.22-.41-.23-.77,0a1.75,1.75,0,0,0-.76.91,5,5,0,0,0-.27,1.48c0,.3,0,.64,0,1S323.92,210.92,323.93,211.22Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "324.91px 209.63px"
    },
    id: "elhrh64h8qj0e",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2",
    className: "animable",
    style: {
      transformOrigin: "244.515px 220.319px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2",
    className: "animable",
    style: {
      transformOrigin: "244.515px 220.319px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.18,70.35a1.76,1.76,0,0,0-.07-.41s0-.06,0-.09a1.56,1.56,0,0,0-.11-.4,2,2,0,0,0-.26-.57.87.87,0,0,0-.15-.24.51.51,0,0,0-.13-.16,1.42,1.42,0,0,0-.3-.3l0,0a2.88,2.88,0,0,0-.38-.22,3.25,3.25,0,0,0-3,.39L133.07,200a10,10,0,0,0-4.5,7.79V373a3.08,3.08,0,0,0,1.63,2.72l.18.11.24.13a1.71,1.71,0,0,0,.38.13,2.32,2.32,0,0,0,.58.08,2.89,2.89,0,0,0,1.49-.43l.12-.07h0l4.28-2.48L361.72,244a9.94,9.94,0,0,0,4.49-7.78V70.91A5.12,5.12,0,0,0,366.18,70.35Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "247.39px 221.964px"
    },
    id: "elgg1o1cvywpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.74,67.93a3.27,3.27,0,0,0-3,.39L133.07,200a10,10,0,0,0-4.5,7.79v14.69l-5.74-3.37V204.5a9.92,9.92,0,0,1,4.49-7.78L356,65.07a3.11,3.11,0,0,1,3.26-.26C360.05,65.29,363.78,67.43,364.74,67.93Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "243.785px 143.474px"
    },
    id: "ely48d4wbruj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.2,70.88c0-2.84-2-4-4.49-2.56L133.07,200a9.93,9.93,0,0,0-4.5,7.79v14.69L366.2,85.63Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "247.385px 145.09px"
    },
    id: "elp8xt9iodx4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt3r41jl2e3"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "244.475px 133.905px"
    },
    className: "animable",
    id: "elxyujf1wiwjo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.71,68.32,133.07,200a9.18,9.18,0,0,0-3.16,3.34L124.2,200a8.9,8.9,0,0,1,3.12-3.28L356,65.07a3.18,3.18,0,0,1,3.27-.27c.8.5,4.53,2.62,5.48,3.13A3.23,3.23,0,0,0,361.71,68.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "244.475px 133.905px"
    },
    id: "el0vca3wopjxfe",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elb7py1ah2lr7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.82,219.1V204.49A9.22,9.22,0,0,1,124.2,200l5.72,3.29a9.14,9.14,0,0,0-1.34,4.47v14.69Z",
    style: {
      opacity: 0.15,
      transformOrigin: "126.37px 211.225px"
    },
    className: "animable",
    id: "elg4ffblq7l2w"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.63,87.54c-1.4.81-2.54,3.22-2.54,5.37s1.14,3.26,2.54,2.45,2.54-3.22,2.54-5.38S341,86.73,339.63,87.54Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "339.63px 91.4488px"
    },
    id: "eldr0d79okpqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.77,82.25c-1.4.81-2.54,3.22-2.54,5.38s1.14,3.25,2.54,2.44,2.54-3.22,2.54-5.37S350.17,81.44,348.77,82.25Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "348.77px 86.1612px"
    },
    id: "elnjaxmv1wm0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.91,77c-1.4.81-2.54,3.22-2.54,5.38s1.14,3.25,2.54,2.44,2.54-3.21,2.54-5.37S359.31,76.16,357.91,77Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "357.91px 80.9046px"
    },
    id: "elu6y41915ixm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.2,375.74l-.24-.14-4.74-2.73a4.85,4.85,0,0,1-2.4-4.14V219.09l5.75,3.36V373a3.06,3.06,0,0,0,1.43,2.6A1.53,1.53,0,0,1,130.2,375.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "126.51px 297.415px"
    },
    id: "elwgu08gqskt",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-2",
    className: "animable",
    style: {
      transformOrigin: "244.45px 233.898px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.63,229.66l84.13-48.83c.88-.51,1.6-.15,1.6.81a3.44,3.44,0,0,1-1.6,2.65l-84.13,48.83c-.88.51-1.59.14-1.59-.81A3.41,3.41,0,0,1,137.63,229.66Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "179.7px 206.974px"
    },
    id: "el4zc35l55nid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.28,264l199-115.5c.88-.51,1.59-.14,1.59.81a3.41,3.41,0,0,1-1.59,2.65l-199,115.49c-.88.51-1.6.15-1.6-.8A3.41,3.41,0,0,1,151.28,264Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "250.775px 207.976px"
    },
    id: "el8d8sxpatzum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.28,275.91l199-115.49c.88-.51,1.59-.14,1.59.81a3.41,3.41,0,0,1-1.59,2.65l-199,115.49c-.88.51-1.6.15-1.6-.8A3.44,3.44,0,0,1,151.28,275.91Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "250.775px 219.896px"
    },
    id: "elumkrf2hna5f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,177.26l123.26-71.08c.88-.5,1.6-.14,1.6.81a3.42,3.42,0,0,1-1.6,2.65L228,180.72c-.88.51-1.6.14-1.6-.81A3.42,3.42,0,0,1,228,177.26Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "289.63px 143.452px"
    },
    id: "el80wzhl2v7i9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.63,239.59l53-30.87c.88-.51,1.6-.15,1.6.81a3.44,3.44,0,0,1-1.6,2.65l-53,30.87c-.88.51-1.59.15-1.59-.8A3.43,3.43,0,0,1,137.63,239.59Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "164.135px 225.885px"
    },
    id: "elfaarwbk9iq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm97ipixltck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.63,239.59l53-30.87c.88-.51,1.6-.15,1.6.81a3.44,3.44,0,0,1-1.6,2.65l-53,30.87c-.88.51-1.59.15-1.59-.8A3.43,3.43,0,0,1,137.63,239.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "164.135px 225.885px"
    },
    className: "animable",
    id: "elhqi1poh1mnc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.63,249.47l18.54-10.78c.88-.51,1.59-.15,1.59.81a3.43,3.43,0,0,1-1.59,2.65l-18.54,10.78c-.88.51-1.59.15-1.59-.81A3.43,3.43,0,0,1,137.63,249.47Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "146.9px 245.81px"
    },
    id: "elezxx61nvg6m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3nylh7ahtv5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.63,249.47l18.54-10.78c.88-.51,1.59-.15,1.59.81a3.43,3.43,0,0,1-1.59,2.65l-18.54,10.78c-.88.51-1.59.15-1.59-.81A3.43,3.43,0,0,1,137.63,249.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "146.9px 245.81px"
    },
    className: "animable",
    id: "eln7jl9rjael"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.82,205.15l19-10.91c.88-.51,1.59-.14,1.59.81a3.41,3.41,0,0,1-1.59,2.65l-19,10.91c-.88.51-1.6.14-1.6-.81A3.42,3.42,0,0,1,196.82,205.15Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "206.315px 201.425px"
    },
    id: "el0ijzm214lcv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elaf9ezukguxk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.82,205.15l19-10.91c.88-.51,1.59-.14,1.59.81a3.41,3.41,0,0,1-1.59,2.65l-19,10.91c-.88.51-1.6.14-1.6-.81A3.42,3.42,0,0,1,196.82,205.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "206.315px 201.425px"
    },
    className: "animable",
    id: "elkraa6o5gjfd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.41,263l137.8-79.49c.88-.51,1.6-.14,1.6.81a3.42,3.42,0,0,1-1.6,2.65l-137.8,79.49c-.89.51-1.6.15-1.6-.81A3.41,3.41,0,0,1,213.41,263Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "282.31px 224.986px"
    },
    id: "elc4nyb71zl1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1,241.14l117.11-67.6c.88-.51,1.6-.15,1.6.81a3.44,3.44,0,0,1-1.6,2.65L234.1,244.6c-.88.5-1.59.14-1.59-.81A3.41,3.41,0,0,1,234.1,241.14Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "292.66px 209.067px"
    },
    id: "el0oydp2tyn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.11,297.2l89.8-52.49c.89-.51,1.6-.15,1.6.81a3.41,3.41,0,0,1-1.6,2.65l-89.8,52.49c-.88.51-1.6.14-1.6-.81A3.42,3.42,0,0,1,138.11,297.2Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "183.01px 272.684px"
    },
    id: "el2fj172bjbfp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.82,234.28,312,148.49c.88-.51,1.6-.15,1.6.81A3.44,3.44,0,0,1,312,152L163.82,237.74c-.88.51-1.59.15-1.59-.81A3.43,3.43,0,0,1,163.82,234.28Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "237.915px 193.115px"
    },
    id: "elwqdu9xp8fgs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,144.49l31.32-17.63c.88-.51,1.6-.15,1.6.81a3.44,3.44,0,0,1-1.6,2.65L319,148c-.88.51-1.6.15-1.6-.8A3.44,3.44,0,0,1,319,144.49Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "334.66px 137.43px"
    },
    id: "elr3y9md82d5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.93,256.21l69.67-40.84c.88-.51,1.59-.15,1.59.81a3.43,3.43,0,0,1-1.59,2.65l-69.67,40.84c-.88.51-1.6.15-1.6-.81A3.44,3.44,0,0,1,144.93,256.21Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "179.76px 237.52px"
    },
    id: "elkey31cal00o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgozgwor1qu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.93,256.21l69.67-40.84c.88-.51,1.59-.15,1.59.81a3.43,3.43,0,0,1-1.59,2.65l-69.67,40.84c-.88.51-1.6.15-1.6-.81A3.44,3.44,0,0,1,144.93,256.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "179.76px 237.52px"
    },
    className: "animable",
    id: "eln2v1eqipdt"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.79,211.79l129.48-74.33c.88-.51,1.6-.14,1.6.81a3.42,3.42,0,0,1-1.6,2.65L220.79,215.25c-.89.51-1.6.15-1.6-.8A3.41,3.41,0,0,1,220.79,211.79Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "285.53px 176.356px"
    },
    id: "elp759o1d5x2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elx18ozgq9n8m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.79,211.79l129.48-74.33c.88-.51,1.6-.14,1.6.81a3.42,3.42,0,0,1-1.6,2.65L220.79,215.25c-.89.51-1.6.15-1.6-.8A3.41,3.41,0,0,1,220.79,211.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "285.53px 176.356px"
    },
    className: "animable",
    id: "elrx3ukxtbfnh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.37,311.19,351.21,193.71c.88-.51,1.6-.15,1.6.8a3.44,3.44,0,0,1-1.6,2.66L148.37,314.65c-.89.51-1.6.15-1.6-.81A3.4,3.4,0,0,1,148.37,311.19Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "249.79px 254.18px"
    },
    id: "elbfaseydgza8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.37,321.09,351.21,203.61c.88-.51,1.6-.15,1.6.8a3.44,3.44,0,0,1-1.6,2.66L148.37,324.55c-.89.51-1.6.14-1.6-.81A3.4,3.4,0,0,1,148.37,321.09Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "249.79px 264.079px"
    },
    id: "el9a2l48lvkb9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.37,331,351.21,213.51c.88-.51,1.6-.15,1.6.8a3.44,3.44,0,0,1-1.6,2.66L148.37,334.45c-.89.51-1.6.14-1.6-.81A3.4,3.4,0,0,1,148.37,331Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "249.79px 273.979px"
    },
    id: "elm8htf1fbxyg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.22,336,227.42,298c.88-.51,1.6-.15,1.6.81a3.44,3.44,0,0,1-1.6,2.65l-65.2,37.92c-.88.51-1.6.15-1.6-.81A3.44,3.44,0,0,1,162.22,336Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "194.82px 318.69px"
    },
    id: "eld71c9z7pczf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.61,294.34l117.6-67.67c.88-.51,1.6-.15,1.6.81a3.44,3.44,0,0,1-1.6,2.65L233.61,297.8c-.88.51-1.6.15-1.6-.81A3.44,3.44,0,0,1,233.61,294.34Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "292.41px 262.235px"
    },
    id: "el4x2nt5njbbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.06,349.2l14.78-8.54c.88-.51,1.6-.15,1.6.8a3.44,3.44,0,0,1-1.6,2.66l-14.78,8.54c-.88.51-1.6.15-1.6-.81A3.44,3.44,0,0,1,139.06,349.2Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "146.45px 346.66px"
    },
    id: "elxcywlsq46s9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw0q6epqxbe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.06,349.2l14.78-8.54c.88-.51,1.6-.15,1.6.8a3.44,3.44,0,0,1-1.6,2.66l-14.78,8.54c-.88.51-1.6.15-1.6-.81A3.44,3.44,0,0,1,139.06,349.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "146.45px 346.66px"
    },
    className: "animable",
    id: "ele1sc4hg712s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.06,358.15l14.78-8.54c.88-.51,1.6-.15,1.6.8a3.44,3.44,0,0,1-1.6,2.66l-14.78,8.54c-.88.51-1.6.15-1.6-.81A3.44,3.44,0,0,1,139.06,358.15Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "146.45px 355.61px"
    },
    id: "ele5com8ggv7c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljl656e93c1r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.06,358.15l14.78-8.54c.88-.51,1.6-.15,1.6.8a3.44,3.44,0,0,1-1.6,2.66l-14.78,8.54c-.88.51-1.6.15-1.6-.81A3.44,3.44,0,0,1,139.06,358.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "146.45px 355.61px"
    },
    className: "animable",
    id: "elod7l90gm6wj"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.27,344.42l188.94-109c.88-.51,1.6-.15,1.6.81a3.44,3.44,0,0,1-1.6,2.65l-188.94,109c-.89.51-1.6.15-1.6-.8A3.41,3.41,0,0,1,162.27,344.42Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "256.74px 291.65px"
    },
    id: "el7fr9yki54g",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2",
    className: "animable",
    style: {
      transformOrigin: "200.93px 294.748px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2",
    className: "animable",
    style: {
      transformOrigin: "200.93px 294.748px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246,200a1.81,1.81,0,0,0-.07-.35.11.11,0,0,0,0-.08,1.13,1.13,0,0,0-.09-.34,1.75,1.75,0,0,0-.23-.5.69.69,0,0,0-.13-.2.31.31,0,0,0-.11-.14,1.07,1.07,0,0,0-.26-.26l0,0a2.23,2.23,0,0,0-.33-.2,2.8,2.8,0,0,0-2.61.34l-77.42,44.36a8.58,8.58,0,0,0-3.88,6.72V391.88a2.65,2.65,0,0,0,1.4,2.34l.17.1a1,1,0,0,0,.2.11,1.85,1.85,0,0,0,.33.12,2.14,2.14,0,0,0,.5.06,2.45,2.45,0,0,0,1.28-.37l.1-.06h0l3.7-2.13,73.61-42.23A8.58,8.58,0,0,0,246,343.1V200.45C246,200.28,246,200.11,246,200Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "203.435px 296.18px"
    },
    id: "elp2pyjkzr6vg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.77,197.87a2.8,2.8,0,0,0-2.61.34l-77.42,44.36a8.58,8.58,0,0,0-3.88,6.72V262l-5-2.9V246.47a8.55,8.55,0,0,1,3.87-6.7l77.43-44.36a2.68,2.68,0,0,1,2.81-.23C240.72,195.6,243.94,197.44,244.77,197.87Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "200.315px 228.443px"
    },
    id: "elyhspv0n688d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,200.42c0-2.45-1.74-3.44-3.87-2.21l-77.42,44.36a8.58,8.58,0,0,0-3.88,6.72V262L246,213.14Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "203.415px 229.841px"
    },
    id: "elybxd4nl9e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3q8ift081qc"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "200.92px 220.169px"
    },
    className: "animable",
    id: "elpan7m2pqwn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.16,198.21l-77.42,44.36a8,8,0,0,0-2.73,2.88l-4.92-2.86a7.81,7.81,0,0,1,2.69-2.83L237.2,195.4a2.76,2.76,0,0,1,2.82-.23c.7.43,3.92,2.26,4.73,2.7A2.8,2.8,0,0,0,242.16,198.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "200.92px 220.169px"
    },
    id: "el01s5e39xu334",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el6yxc0p5gmxj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.9,259.08V246.47a8,8,0,0,1,1.18-3.88l4.94,2.85a7.78,7.78,0,0,0-1.16,3.85V262Z",
    style: {
      opacity: 0.15,
      transformOrigin: "158.96px 252.295px"
    },
    className: "animable",
    id: "el9r3la8iphgo"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.1,214.79c-1.21.7-2.19,2.78-2.19,4.64s1,2.8,2.19,2.11,2.19-2.78,2.19-4.64S224.31,214.09,223.1,214.79Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "223.1px 218.163px"
    },
    id: "eljr5bnim8hgn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,210.23c-1.21.7-2.19,2.77-2.19,4.64s1,2.8,2.19,2.1,2.19-2.77,2.19-4.63S232.2,209.53,231,210.23Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "231px 213.601px"
    },
    id: "elg9iftjyloug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.88,205.67c-1.21.7-2.19,2.77-2.19,4.63s1,2.81,2.19,2.11,2.19-2.77,2.19-4.64S240.09,205,238.88,205.67Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "238.88px 209.045px"
    },
    id: "elrjbgonznvnr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.27,394.22l-.21-.12L158,391.75a4.12,4.12,0,0,1-2-3,5.46,5.46,0,0,1,0-.57V259.06l5,2.91v129.9a2.65,2.65,0,0,0,1.24,2.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "159.131px 326.64px"
    },
    id: "eli9c230re0np",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.78,340.11l54.1-31.21c1.07-.62,1.94-.12,1.94,1.12v1a4.29,4.29,0,0,1-1.94,3.35l-54.3,31.35c-1.07.61-1.91.11-1.88-1.12l.09-1.15A4.43,4.43,0,0,1,177.78,340.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "204.76px 327.307px"
    },
    id: "eli9iqgw93azk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.78,351.51l54.1-31.22c1.07-.61,1.94-.11,1.94,1.12v1a4.26,4.26,0,0,1-1.94,3.35l-54.3,31.35c-1.07.62-1.91.12-1.88-1.12l.09-1.15A4.42,4.42,0,0,1,177.78,351.51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "204.76px 338.703px"
    },
    id: "elnggtpn8ohn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.78,362.91l54.1-31.22c1.07-.62,1.94-.12,1.94,1.12v1a4.29,4.29,0,0,1-1.94,3.35l-54.3,31.35c-1.07.62-1.91.11-1.88-1.12l.09-1.15A4.39,4.39,0,0,1,177.78,362.91Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "204.76px 350.099px"
    },
    id: "el34pw04dkysv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.26,311.83a.88.88,0,0,1-.45-.11,1,1,0,0,1-.47-1.36l11.82-23.95a2.19,2.19,0,0,1,3.33-.55l10.06,6.6,1.32.27-.94-.38,12-29.12a2.21,2.21,0,0,1,1.67-1.15,2.17,2.17,0,0,1,1.78.6l14.91,15.37a1,1,0,0,1-1.46,1.41L215.9,264.12l-12.09,29a2.27,2.27,0,0,1-1.45,1.32,2.24,2.24,0,0,1-1.93-.28l-10.4-6.8-11.86,23.9A1,1,0,0,1,177.26,311.83Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "204.403px 286.947px"
    },
    id: "elr3wh6wbpplo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.19,240.76h0M231.07,242v53.65l-53.65,31V273h0l53.64-31m1.52-3.11a.82.82,0,0,0-.42.13l-2,1.17-53.82,31.1a2.09,2.09,0,0,0-.92,1.61v56.2c0,.42.21.66.51.66a.81.81,0,0,0,.41-.13l55.86-32.27a2,2,0,0,0,.93-1.61v-56.2c0-.42-.2-.66-.51-.66Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "204.305px 284.325px"
    },
    id: "elfhr3ml2rxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.23,280.08a2.92,2.92,0,0,1-1.48-.39,3.59,3.59,0,0,1-1.61-3.31A9.29,9.29,0,0,1,195.4,269a3.29,3.29,0,0,1,5.28,3.05,9.31,9.31,0,0,1-4.26,7.38A4.49,4.49,0,0,1,194.23,280.08Zm3.35-9.69a2.42,2.42,0,0,0-1.16.38,7.26,7.26,0,0,0-3.24,5.61,1.31,1.31,0,0,0,2.22,1.28,7.29,7.29,0,0,0,3.24-5.61,1.72,1.72,0,0,0-.59-1.55A1,1,0,0,0,197.58,270.39Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "195.919px 274.193px"
    },
    id: "elqwio4hxobq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2",
    className: "animable",
    style: {
      transformOrigin: "325.605px 222.618px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2",
    className: "animable",
    style: {
      transformOrigin: "325.605px 222.618px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.45,115.1a2.09,2.09,0,0,0-.07-.36s0,0,0-.07a1.28,1.28,0,0,0-.09-.35,1.83,1.83,0,0,0-.23-.49.44.44,0,0,0-.13-.2.42.42,0,0,0-.11-.15,1.48,1.48,0,0,0-.25-.25l0,0a3.54,3.54,0,0,0-.33-.19,2.8,2.8,0,0,0-2.61.34l-121,69.82a8.58,8.58,0,0,0-3.88,6.72V332.48a2.66,2.66,0,0,0,1.4,2.35l.16.09.21.12a1.17,1.17,0,0,0,.33.11,2.05,2.05,0,0,0,.49.06,2.46,2.46,0,0,0,1.29-.36l.1-.06h0l3.7-2.13L388.59,265a8.58,8.58,0,0,0,3.88-6.72V115.59C392.47,115.42,392.46,115.25,392.45,115.1Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "328.11px 224.035px"
    },
    id: "elv405cnju8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.2,113a2.8,2.8,0,0,0-2.61.34l-121,69.82a8.58,8.58,0,0,0-3.88,6.72v12.68l-5-2.91V187.08a8.57,8.57,0,0,1,3.86-6.71l121.07-69.82a2.68,2.68,0,0,1,2.81-.23C387.15,110.74,390.37,112.58,391.2,113Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "324.955px 156.293px"
    },
    id: "eld9m7azw9egr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.46,115.56c0-2.45-1.74-3.44-3.87-2.21l-121,69.82a8.57,8.57,0,0,0-3.88,6.72v12.68l128.8-74.29Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "328.11px 157.696px"
    },
    id: "elq8lt383tq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgopg6nfzsdv"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "325.58px 148.038px"
    },
    className: "animable",
    id: "el3c18mt41qqr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.59,113.35l-121,69.82a7.9,7.9,0,0,0-2.73,2.88l-4.93-2.85a7.68,7.68,0,0,1,2.7-2.83l121.06-69.83a2.74,2.74,0,0,1,2.81-.23c.7.43,3.92,2.26,4.73,2.7A2.8,2.8,0,0,0,388.59,113.35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "325.58px 148.038px"
    },
    id: "elbs1658e4mj",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eln8j8opo02ms"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.7,199.68V187.07a8,8,0,0,1,1.18-3.87l4.94,2.84a7.81,7.81,0,0,0-1.16,3.85v12.68Z",
    style: {
      opacity: 0.15,
      transformOrigin: "261.76px 192.885px"
    },
    className: "animable",
    id: "elede4xfu7rra"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.53,129.93c-1.21.7-2.19,2.78-2.19,4.64s1,2.8,2.19,2.11,2.19-2.78,2.19-4.64S370.74,129.23,369.53,129.93Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "369.53px 133.303px"
    },
    id: "elpec7rmu9vs9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.42,125.37c-1.21.7-2.19,2.77-2.19,4.64s1,2.8,2.19,2.1,2.19-2.77,2.19-4.63S378.63,124.67,377.42,125.37Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "377.42px 128.741px"
    },
    id: "el7ze3x5yelux",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.31,120.81c-1.21.7-2.19,2.77-2.19,4.63s1,2.81,2.19,2.11,2.19-2.77,2.19-4.64S386.52,120.11,385.31,120.81Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "385.31px 124.179px"
    },
    id: "elzksk25lvhpl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.07,334.83l-.22-.12-4.09-2.36a4.11,4.11,0,0,1-2-3,3.52,3.52,0,0,1,0-.56V199.66l5,2.91V332.48a2.66,2.66,0,0,0,1.23,2.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "261.909px 267.245px"
    },
    id: "elbaa7zqn5fh4",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.35,270.43a.89.89,0,0,1-.48-.13,1,1,0,0,1-.49-.83V210.8a1,1,0,0,1,.49-.83l70.34-40.61a1,1,0,0,1,1,0,1,1,0,0,1,.48.83v58.67a1,1,0,0,1-.48.83L271.83,270.3A.94.94,0,0,1,271.35,270.43Zm1-59.07V267.8l68.42-39.5V171.86Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "306.535px 219.828px"
    },
    id: "el5kxw8au9lks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.17,256.93l-1.65-1L291.81,220a1,1,0,0,1,1.3-.35l13.73,7.78,14.48-29A.92.92,0,0,1,322,198a1,1,0,0,1,.82.22l19.51,17.23-1.27,1.44-18.58-16.4L308.1,229.24a.92.92,0,0,1-.58.49.94.94,0,0,1-.75-.08L293,221.83Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "306.425px 227.457px"
    },
    id: "elwrynb43zirb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.13,213.05a2.93,2.93,0,0,1-1.49-.39,3.59,3.59,0,0,1-1.61-3.31,9.29,9.29,0,0,1,4.26-7.38,3.29,3.29,0,0,1,5.28,3.05,9.29,9.29,0,0,1-4.26,7.38A4.43,4.43,0,0,1,303.13,213.05Zm3.34-9.69a2.42,2.42,0,0,0-1.16.38,7.26,7.26,0,0,0-3.24,5.61,1.72,1.72,0,0,0,.59,1.55,1.75,1.75,0,0,0,1.63-.27,7.26,7.26,0,0,0,3.24-5.61,1.72,1.72,0,0,0-.59-1.55A1,1,0,0,0,306.47,203.36Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "304.809px 207.163px"
    },
    id: "elo2ylxwea04",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.8,166.63,374.08,152c.57-.33,1-.06,1,.6v2.11a2.3,2.3,0,0,1-1,1.8l-25.28,14.6c-.57.33-1,.06-1-.6v-2.11A2.33,2.33,0,0,1,348.8,166.63Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "361.44px 161.555px"
    },
    id: "elyl141gjzj7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.18,173.76,366.89,163c.23-.13.41,0,.41.24v1.3a.92.92,0,0,1-.41.72L348.18,176c-.23.13-.42,0-.42-.24v-1.29A.94.94,0,0,1,348.18,173.76Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "357.53px 169.5px"
    },
    id: "elg601d1ag7sp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,181a.25.25,0,0,1-.21-.12.26.26,0,0,1,.09-.33l37.07-21.4a.25.25,0,0,1,.33.09.24.24,0,0,1-.09.33L347.88,181Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.298px 170.06px"
    },
    id: "elm4w8nyjt1es",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,183.27a.25.25,0,0,1-.21-.12.26.26,0,0,1,.09-.33l37.07-21.4a.23.23,0,0,1,.33.09.24.24,0,0,1-.09.33l-37.07,21.4A.27.27,0,0,1,347.76,183.27Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.298px 172.327px"
    },
    id: "elu4wyp3kn8fc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,185.53a.27.27,0,0,1-.21-.12.25.25,0,0,1,.09-.33l37.07-21.4a.24.24,0,0,1,.33.08.23.23,0,0,1-.09.33l-37.07,21.4A.19.19,0,0,1,347.76,185.53Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.299px 174.587px"
    },
    id: "elm3wnrmlt3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,187.78a.25.25,0,0,1-.21-.12.26.26,0,0,1,.09-.33l37.07-21.4a.25.25,0,0,1,.33.09.24.24,0,0,1-.09.33l-37.07,21.4A.27.27,0,0,1,347.76,187.78Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.298px 176.84px"
    },
    id: "elqqnlj67wq9h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,190a.25.25,0,0,1-.21-.12.25.25,0,0,1,.09-.33l37.07-21.4a.23.23,0,0,1,.33.09.22.22,0,0,1-.09.32L347.88,190A.27.27,0,0,1,347.76,190Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.299px 179.06px"
    },
    id: "elhnpxivgayln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,192.3a.27.27,0,0,1-.21-.12.25.25,0,0,1,.09-.33l17.59-10.16a.26.26,0,0,1,.33.09.25.25,0,0,1-.09.33l-17.59,10.15A.19.19,0,0,1,347.76,192.3Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "356.555px 186.982px"
    },
    id: "el0ce229ivm62",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,196.81a.25.25,0,0,1-.21-.12.25.25,0,0,1,.09-.33L384.71,175a.23.23,0,0,1,.33.09.22.22,0,0,1-.09.32l-37.07,21.41Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.299px 185.892px"
    },
    id: "el4ebr3t4mc08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,199.06a.25.25,0,0,1-.21-.12.24.24,0,0,1,.09-.32l37.07-21.41a.25.25,0,0,1,.33.09.24.24,0,0,1-.09.33L347.88,199Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.297px 188.12px"
    },
    id: "elcert442y8k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,201.32a.25.25,0,0,1-.21-.12.26.26,0,0,1,.09-.33l37.07-21.4a.24.24,0,0,1,.33.09.24.24,0,0,1-.09.33l-37.07,21.4Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.298px 190.379px"
    },
    id: "eldembvmvrao8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,203.58a.27.27,0,0,1-.21-.12.25.25,0,0,1,.09-.33l37.07-21.4a.24.24,0,0,1,.33.08.23.23,0,0,1-.09.33l-37.07,21.41A.27.27,0,0,1,347.76,203.58Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.299px 192.637px"
    },
    id: "elod0wpehnaon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,205.83a.25.25,0,0,1-.21-.12.26.26,0,0,1,.09-.33L384.71,184a.25.25,0,0,1,.33.09.24.24,0,0,1-.09.33l-37.07,21.4A.27.27,0,0,1,347.76,205.83Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.298px 194.902px"
    },
    id: "el91kmfs0wr0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,208.09a.25.25,0,0,1-.21-.12.25.25,0,0,1,.09-.33l17.59-10.15a.24.24,0,0,1,.33.09.24.24,0,0,1-.09.32l-17.59,10.16A.27.27,0,0,1,347.76,208.09Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "356.555px 202.774px"
    },
    id: "elnz9xxj95c0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,212.6a.25.25,0,0,1-.21-.12.26.26,0,0,1,.09-.33l37.07-21.4a.25.25,0,0,1,.33.09.24.24,0,0,1-.09.33l-37.07,21.4A.27.27,0,0,1,347.76,212.6Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.298px 201.66px"
    },
    id: "eljgexhp1sgbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,214.86a.25.25,0,0,1-.21-.12.25.25,0,0,1,.09-.33L384.71,193a.23.23,0,0,1,.33.09.22.22,0,0,1-.09.32l-37.07,21.41Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.299px 203.912px"
    },
    id: "elccjtwlo8a5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,217.12a.27.27,0,0,1-.21-.12.25.25,0,0,1,.09-.33l37.07-21.41a.25.25,0,0,1,.33.09.24.24,0,0,1-.09.33l-37.07,21.4A.28.28,0,0,1,347.76,217.12Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.297px 206.175px"
    },
    id: "el4ees3skvy1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,219.37a.25.25,0,0,1-.21-.12.26.26,0,0,1,.09-.33l37.07-21.4a.24.24,0,0,1,.33.09.24.24,0,0,1-.09.33l-37.07,21.4Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.298px 208.429px"
    },
    id: "elwkt62eoyew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,221.63a.27.27,0,0,1-.21-.12.25.25,0,0,1,.09-.33l37.07-21.4a.23.23,0,0,1,.33.09.22.22,0,0,1-.09.32L347.88,221.6Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "366.299px 210.687px"
    },
    id: "elomwt3bcp49",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,223.88a.25.25,0,0,1-.21-.12.24.24,0,0,1,.09-.32l17.59-10.16a.25.25,0,0,1,.33.09.26.26,0,0,1-.09.33l-17.59,10.15Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "356.554px 218.565px"
    },
    id: "elosv8q34hhvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-2",
    className: "animable",
    style: {
      transformOrigin: "327.795px 268.558px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.92,313.16l49.75-28.77a4.57,4.57,0,0,0,2.08-3.6V254c0-1.33-.93-1.87-2.08-1.2l-49.75,28.76a4.61,4.61,0,0,0-2.09,3.61V312C275.83,313.29,276.77,313.82,277.92,313.16Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "302.79px 282.978px"
    },
    id: "elv0ymnbpjmzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,313.93a1.52,1.52,0,0,1-.78-.21,1.9,1.9,0,0,1-.85-1.76V285.18a5.07,5.07,0,0,1,2.33-4l49.75-28.76a1.91,1.91,0,0,1,1.95-.15,1.93,1.93,0,0,1,.86,1.77v26.78a5.05,5.05,0,0,1-2.33,4l-49.75,28.77A2.44,2.44,0,0,1,277,313.93ZM328.6,253a1.49,1.49,0,0,0-.69.22L278.16,282a4.14,4.14,0,0,0-1.85,3.19V312a1.06,1.06,0,0,0,.37.93,1,1,0,0,0,1-.15L327.43,284a4.14,4.14,0,0,0,1.84-3.19V254a1,1,0,0,0-.37-.93A.56.56,0,0,0,328.6,253Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "302.814px 283px"
    },
    id: "elqkksti03a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.78,283.4l9.64-5.56c.58-.34,1.05-.07,1.05.6v11.13a2.29,2.29,0,0,1-1.05,1.8l-9.64,5.57c-.57.33-1,.06-1-.6V285.21A2.31,2.31,0,0,1,280.78,283.4Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "285.625px 287.387px"
    },
    id: "elgcmp8ewgcqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.79,274.74l29.64-17.15c.23-.14.42,0,.42.24v1.46a.93.93,0,0,1-.42.72l-29.64,17.15c-.23.13-.42,0-.42-.24v-1.46A.91.91,0,0,1,295.79,274.74Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "310.61px 267.373px"
    },
    id: "elct5a6pwbqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.79,280.3l29.64-17.16c.23-.13.42,0,.42.24v1.46a.94.94,0,0,1-.42.73l-29.64,17.15c-.23.13-.42,0-.42-.24V281A.91.91,0,0,1,295.79,280.3Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "310.61px 272.93px"
    },
    id: "elk89z9ohwvsb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.79,285.85l29.64-17.15c.23-.13.42,0,.42.24v1.46a.91.91,0,0,1-.42.72l-29.64,17.16c-.23.13-.42,0-.42-.25v-1.46A.94.94,0,0,1,295.79,285.85Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "310.61px 278.49px"
    },
    id: "el1mvu1pfi7xa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.16,300.4l45.27-26.14c.23-.13.42,0,.42.24V276a.91.91,0,0,1-.42.72l-45.27,26.14c-.23.13-.42,0-.42-.24v-1.46A.93.93,0,0,1,280.16,300.4Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "302.795px 288.56px"
    },
    id: "eln54ambcdokd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.16,306l45.27-26.14c.23-.14.42,0,.42.24v1.46a.93.93,0,0,1-.42.72l-45.27,26.14c-.23.13-.42,0-.42-.24v-1.46A.91.91,0,0,1,280.16,306Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "302.795px 294.138px"
    },
    id: "elae16wy1fh7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.93,279.65a.36.36,0,0,1-.18-.67l1.05-.6a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-1.05.6A.34.34,0,0,1,273.93,279.65Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "274.456px 278.991px"
    },
    id: "el330p2odhpxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.17,277.79a.35.35,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.36.36,0,0,1,.36.62l-2.19,1.27A.41.41,0,0,1,277.17,277.79Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "278.251px 276.803px"
    },
    id: "el5rs8eym3lr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.55,275.26a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.37.37,0,0,1,.5.13.35.35,0,0,1-.14.49l-2.19,1.27A.37.37,0,0,1,281.55,275.26Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "282.65px 274.266px"
    },
    id: "elmabp3w75m2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.94,272.73a.38.38,0,0,1-.32-.18.36.36,0,0,1,.14-.5l2.19-1.26a.36.36,0,0,1,.36.62l-2.19,1.27A.41.41,0,0,1,285.94,272.73Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "287.016px 271.743px"
    },
    id: "elzxs2t88pdnl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.32,270.19a.36.36,0,0,1-.18-.67l2.19-1.26a.35.35,0,0,1,.49.13.36.36,0,0,1-.13.49l-2.19,1.27A.39.39,0,0,1,290.32,270.19Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "291.415px 269.199px"
    },
    id: "el97f2o3r660g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.7,267.66a.36.36,0,0,1-.18-.67l2.19-1.26a.37.37,0,0,1,.5.13.36.36,0,0,1-.13.49l-2.2,1.27A.37.37,0,0,1,294.7,267.66Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "295.8px 266.671px"
    },
    id: "ele743ohg18at",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.25,265a.35.35,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.36.36,0,0,1,.36.62L299.43,265A.41.41,0,0,1,299.25,265Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "300.331px 264.018px"
    },
    id: "elx7ig2l96oep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.79,262.41a.36.36,0,0,1-.18-.67l2.2-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.2,1.26A.27.27,0,0,1,303.79,262.41Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "304.891px 261.416px"
    },
    id: "elj8cuu67h4fh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.34,259.79a.37.37,0,0,1-.18-.68l2.19-1.26a.36.36,0,0,1,.49.13.35.35,0,0,1-.13.49l-2.19,1.27A.41.41,0,0,1,308.34,259.79Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "309.441px 258.796px"
    },
    id: "elbdmum5jx1un",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.89,257.16a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.41.41,0,0,1,312.89,257.16Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "313.98px 256.166px"
    },
    id: "elyog5xh3q8yg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.43,254.53a.36.36,0,0,1-.18-.67l2.19-1.26a.36.36,0,0,1,.5.13.35.35,0,0,1-.14.49l-2.19,1.27A.37.37,0,0,1,317.43,254.53Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "318.531px 253.539px"
    },
    id: "elui29kh08ezh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,251.91a.38.38,0,0,1-.32-.18.37.37,0,0,1,.14-.5L324,250a.36.36,0,0,1,.36.62l-2.19,1.27A.41.41,0,0,1,322,251.91Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "323.073px 250.939px"
    },
    id: "elupxwz70twf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.52,249.28a.36.36,0,0,1-.18-.67l2.19-1.27a.37.37,0,0,1,.5.13.36.36,0,0,1-.14.5l-2.19,1.26A.29.29,0,0,1,326.52,249.28Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "327.621px 248.286px"
    },
    id: "el0e03o2ibe7oj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.07,246.66a.35.35,0,0,1-.31-.18.36.36,0,0,1,.13-.5l2.19-1.26a.36.36,0,0,1,.36.62l-2.19,1.27A.41.41,0,0,1,331.07,246.66Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "332.149px 245.673px"
    },
    id: "eli92sxtcbfia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.61,244a.36.36,0,0,1-.18-.67l2.2-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.2,1.26A.37.37,0,0,1,335.61,244Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "336.711px 243.006px"
    },
    id: "elrym5gas45u8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16,241.4a.34.34,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.36.36,0,0,1,.36.63l-2.19,1.27A.39.39,0,0,1,340.16,241.4Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "341.256px 240.407px"
    },
    id: "els960xnn3m8r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.7,238.78a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.2-1.26a.36.36,0,1,1,.36.62l-2.19,1.27A.41.41,0,0,1,344.7,238.78Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "345.815px 237.777px"
    },
    id: "elwxv66wt4dyn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.25,236.15a.34.34,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.37.37,0,0,1,.5.13.36.36,0,0,1-.14.5l-2.19,1.26A.31.31,0,0,1,349.25,236.15Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "350.351px 235.156px"
    },
    id: "elfm9cj51ubba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.8,233.53a.38.38,0,0,1-.32-.18.36.36,0,0,1,.14-.5l2.19-1.26a.36.36,0,0,1,.36.62L354,233.48A.41.41,0,0,1,353.8,233.53Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "354.876px 232.543px"
    },
    id: "el3900qji4px",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.34,230.9a.36.36,0,0,1-.18-.67l2.19-1.27a.37.37,0,0,1,.5.13.37.37,0,0,1-.14.5l-2.19,1.26A.37.37,0,0,1,358.34,230.9Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "359.44px 229.906px"
    },
    id: "el9axc0kytnlh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.89,228.27a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.37.37,0,0,1,.49.14.36.36,0,0,1-.13.49l-2.19,1.27A.39.39,0,0,1,362.89,228.27Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "363.979px 227.279px"
    },
    id: "elhx6viz0kgca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.43,225.65a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.37.37,0,0,1,.5.13.36.36,0,0,1-.13.49l-2.2,1.27A.37.37,0,0,1,367.43,225.65Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "368.53px 224.656px"
    },
    id: "elekkau9sywwm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.82,223.12a.38.38,0,0,1-.32-.18.36.36,0,0,1,.14-.5l2.19-1.26a.36.36,0,1,1,.36.62L372,223.07A.41.41,0,0,1,371.82,223.12Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "372.924px 222.117px"
    },
    id: "elvu31gk2zu3m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.2,220.59a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.37.37,0,0,1,.5.13.35.35,0,0,1-.14.49l-2.19,1.27A.41.41,0,0,1,376.2,220.59Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "377.3px 219.596px"
    },
    id: "eldwui2zv3wmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.58,218.06a.37.37,0,0,1-.31-.19.36.36,0,0,1,.13-.49l1.05-.6a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-1,.6A.41.41,0,0,1,380.58,218.06Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "381.105px 217.397px"
    },
    id: "elfxt4nrqsfxv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.33,319.43a.36.36,0,0,1-.36-.36v-1.21a.36.36,0,0,1,.72,0v1.21A.36.36,0,0,1,272.33,319.43Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "272.33px 318.465px"
    },
    id: "eltihy58nab1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.33,315.92a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,0,1,.72,0v2.31A.36.36,0,0,1,272.33,315.92Zm0-4.61a.37.37,0,0,1-.36-.37v-2.3a.36.36,0,0,1,.72,0v2.3A.37.37,0,0,1,272.33,311.31Zm0-4.62a.36.36,0,0,1-.36-.36V304a.36.36,0,0,1,.72,0v2.3A.36.36,0,0,1,272.33,306.69Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,0,1,.72,0v2.31A.36.36,0,0,1,272.33,302.08Zm0-4.61a.36.36,0,0,1-.36-.36V294.8a.36.36,0,0,1,.72,0v2.31A.36.36,0,0,1,272.33,297.47Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,0,1,.72,0v2.31A.36.36,0,0,1,272.33,292.86Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,0,1,.72,0v2.31A.36.36,0,0,1,272.33,288.25Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "272.331px 300.57px"
    },
    id: "el9u4bt1i9ltp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.33,283.63a.36.36,0,0,1-.36-.36v-1.2a.36.36,0,1,1,.72,0v1.2A.36.36,0,0,1,272.33,283.63Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "272.33px 282.67px"
    },
    id: "elreaecr1lvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.62,258.73a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l1-.6a.36.36,0,0,1,.36.62l-1,.6A.31.31,0,0,1,380.62,258.73Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "381.101px 258.078px"
    },
    id: "el042t2eyvtsmc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.17,318.48a.34.34,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.38.38,0,0,1,.5.13.36.36,0,0,1-.14.5l-2.19,1.26A.31.31,0,0,1,277.17,318.48Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "278.271px 317.488px"
    },
    id: "elfxxrvqsckyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.56,316a.36.36,0,0,1-.18-.67l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.41.41,0,0,1,281.56,316Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "282.656px 315.006px"
    },
    id: "el2wk2wwsbaar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.94,313.42a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.2-1.26a.36.36,0,0,1,.36.62l-2.19,1.27A.41.41,0,0,1,285.94,313.42Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "287.026px 312.433px"
    },
    id: "elzylzou7rcz9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.33,310.88a.36.36,0,0,1-.18-.67l2.2-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.2,1.26A.29.29,0,0,1,290.33,310.88Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "291.431px 309.886px"
    },
    id: "el3t0yolrdjni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.72,308.35a.37.37,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.37.37,0,0,1,.5.13.35.35,0,0,1-.14.49l-2.19,1.27A.41.41,0,0,1,294.72,308.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "295.821px 307.356px"
    },
    id: "elzi3tv3i5mzq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.27,305.72a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.35.35,0,0,1,.49.14.36.36,0,0,1-.13.49l-2.19,1.27A.39.39,0,0,1,299.27,305.72Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "300.359px 304.725px"
    },
    id: "elgmlx47u3bkt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.81,303.1a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.2-1.26a.36.36,0,0,1,.36.62l-2.2,1.27A.37.37,0,0,1,303.81,303.1Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "304.896px 302.113px"
    },
    id: "elev5xudtto8g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.36,300.47a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.31.31,0,0,1,308.36,300.47Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "309.45px 299.476px"
    },
    id: "el3axxvabfc9s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,297.85a.37.37,0,0,1-.31-.19.36.36,0,0,1,.13-.49l2.2-1.26a.35.35,0,0,1,.49.13.36.36,0,0,1-.13.49l-2.2,1.27A.37.37,0,0,1,312.9,297.85Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "314px 296.854px"
    },
    id: "elpd0ebyun7n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.45,295.22a.37.37,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.37.37,0,0,1,.5.13.35.35,0,0,1-.14.49l-2.19,1.27A.41.41,0,0,1,317.45,295.22Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "318.551px 294.226px"
    },
    id: "el5fcpuvttfv4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,292.59a.36.36,0,0,1-.19-.67l2.2-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.31.31,0,0,1,322,292.59Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "323.091px 291.596px"
    },
    id: "elto1pug7xa8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.54,290a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.36.36,0,0,1,.5.13.35.35,0,0,1-.14.49l-2.19,1.27A.37.37,0,0,1,326.54,290Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "327.64px 289.004px"
    },
    id: "elxh1vogv0lys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.09,287.34a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.41.41,0,0,1,331.09,287.34Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "332.18px 286.346px"
    },
    id: "elnesaufcfne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.63,284.71a.36.36,0,0,1-.18-.67l2.2-1.27a.37.37,0,0,1,.49.14.36.36,0,0,1-.13.49l-2.2,1.27A.37.37,0,0,1,335.63,284.71Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "336.73px 283.719px"
    },
    id: "el7tbkijwqlme",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.18,282.09a.35.35,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.36.36,0,0,1,.49.13.35.35,0,0,1-.13.49L340.36,282A.41.41,0,0,1,340.18,282.09Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "341.277px 281.096px"
    },
    id: "el6vai76fl3d5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.72,279.46a.36.36,0,0,1-.18-.67l2.2-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.2,1.26A.27.27,0,0,1,344.72,279.46Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "345.821px 278.466px"
    },
    id: "el19pitpka166",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.27,276.84a.37.37,0,0,1-.18-.68l2.19-1.26a.36.36,0,0,1,.5.13.35.35,0,0,1-.14.49l-2.19,1.27A.41.41,0,0,1,349.27,276.84Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "350.375px 275.844px"
    },
    id: "el6dqtuaemnpq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.82,274.21a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.36.62L354,274.16A.41.41,0,0,1,353.82,274.21Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "354.896px 273.223px"
    },
    id: "elkmaf62971om",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.36,271.58a.36.36,0,0,1-.18-.67l2.19-1.27a.37.37,0,0,1,.5.14.36.36,0,0,1-.13.49l-2.2,1.27A.37.37,0,0,1,358.36,271.58Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "359.46px 270.587px"
    },
    id: "elr60t3oo3t8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.91,269a.38.38,0,0,1-.32-.18.36.36,0,0,1,.14-.5l2.19-1.26a.36.36,0,0,1,.36.62l-2.19,1.27A.41.41,0,0,1,362.91,269Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "363.986px 268.013px"
    },
    id: "ela99r712ri3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.45,266.33a.36.36,0,0,1-.18-.67l2.2-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.2,1.26A.27.27,0,0,1,367.45,266.33Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "368.551px 265.336px"
    },
    id: "elm20ig6pv9k9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.84,263.8a.37.37,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.37.37,0,0,1,.5.13.35.35,0,0,1-.14.49L372,263.75A.41.41,0,0,1,371.84,263.8Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "372.941px 262.806px"
    },
    id: "elub291fqjna9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.23,261.26a.33.33,0,0,1-.31-.18.35.35,0,0,1,.13-.49l2.19-1.26a.36.36,0,0,1,.49.13.35.35,0,0,1-.13.49l-2.19,1.27A.39.39,0,0,1,376.23,261.26Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "377.325px 260.271px"
    },
    id: "elb40hiirrmcb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.93,320.35a.36.36,0,0,1-.18-.67l1.05-.6a.36.36,0,0,1,.36.62l-1.05.6A.35.35,0,0,1,273.93,320.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "274.442px 319.698px"
    },
    id: "el1jb3k5wex8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.26,219.56a.36.36,0,0,1-.36-.36V218a.36.36,0,0,1,.72,0v1.2A.36.36,0,0,1,383.26,219.56Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "383.26px 218.6px"
    },
    id: "eltfukxf0xekq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.26,251.85a.37.37,0,0,1-.36-.37v-2.3a.36.36,0,0,1,.72,0v2.3A.37.37,0,0,1,383.26,251.85Zm0-4.62a.36.36,0,0,1-.36-.36v-2.3a.36.36,0,1,1,.72,0v2.3A.36.36,0,0,1,383.26,247.23Zm0-4.61a.36.36,0,0,1-.36-.36V240a.36.36,0,1,1,.72,0v2.3A.36.36,0,0,1,383.26,242.62Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,0,1,.72,0v2.31A.36.36,0,0,1,383.26,238Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,1,1,.72,0V233A.36.36,0,0,1,383.26,233.4Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,0,1,.72,0v2.31A.36.36,0,0,1,383.26,228.79Zm0-4.62a.36.36,0,0,1-.36-.36v-2.3a.36.36,0,1,1,.72,0v2.3A.36.36,0,0,1,383.26,224.17Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "383.261px 236.5px"
    },
    id: "elfjkragn8ooa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.26,255.35a.36.36,0,0,1-.36-.36v-1.2a.36.36,0,1,1,.72,0V255A.36.36,0,0,1,383.26,255.35Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "383.26px 254.39px"
    },
    id: "elp49t7lroaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.66,219.29a.37.37,0,0,1-.18,0,.38.38,0,0,1-.18-.32v-3.7a.38.38,0,0,1,.18-.31l3.2-1.85a.38.38,0,0,1,.36,0,.37.37,0,0,1,.18.31v3.7a.38.38,0,0,1-.18.32l-3.2,1.85A.41.41,0,0,1,381.66,219.29Zm.36-3.86v2.87l2.48-1.43V214Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "383.26px 216.183px"
    },
    id: "elp26v1kmd17",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.66,260a.37.37,0,0,1-.18-.05.35.35,0,0,1-.18-.31v-3.7a.35.35,0,0,1,.18-.31l3.2-1.85a.33.33,0,0,1,.36,0,.35.35,0,0,1,.18.31v3.7a.35.35,0,0,1-.18.31l-3.2,1.85A.41.41,0,0,1,381.66,260Zm.36-3.85V259l2.48-1.43v-2.87Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "383.26px 256.863px"
    },
    id: "elimllje9rckh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.73,283.36a.37.37,0,0,1-.18-.05.38.38,0,0,1-.18-.31v-3.71a.38.38,0,0,1,.18-.31l3.2-1.85a.38.38,0,0,1,.36,0,.37.37,0,0,1,.19.31v3.7a.37.37,0,0,1-.19.32l-3.2,1.85A.41.41,0,0,1,270.73,283.36Zm.36-3.86v2.87l2.48-1.43v-2.87Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "272.335px 280.222px"
    },
    id: "elqgfhi30yp9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.73,324.05a.29.29,0,0,1-.18-.05.35.35,0,0,1-.18-.31V320a.35.35,0,0,1,.18-.31l3.2-1.85a.33.33,0,0,1,.36,0,.34.34,0,0,1,.19.31v3.7a.34.34,0,0,1-.19.31l-3.2,1.85A.31.31,0,0,1,270.73,324.05Zm.36-3.85v2.87l2.48-1.44v-2.87Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "272.335px 320.919px"
    },
    id: "elcnydyjgdkb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.87,237.84a3.88,3.88,0,0,1-1.61,3.09c-.89.51-1.61,0-1.61-1.22a3.88,3.88,0,0,1,1.61-3.09C384.15,236.11,384.87,236.66,384.87,237.84Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "383.26px 238.778px"
    },
    id: "elugrp0zyjw79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.58,245.85a3.85,3.85,0,0,1-1.61,3.08c-.89.52-1.61,0-1.61-1.22a3.88,3.88,0,0,1,1.61-3.08C330.86,244.12,331.58,244.66,331.58,245.85Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "329.97px 246.784px"
    },
    id: "elusvxk80n26",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.58,286.55a3.88,3.88,0,0,1-1.61,3.08c-.89.51-1.61,0-1.61-1.22a3.85,3.85,0,0,1,1.61-3.08C330.86,284.81,331.58,285.36,331.58,286.55Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "329.97px 287.48px"
    },
    id: "elzci3ujaip3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.94,302a3.85,3.85,0,0,1-1.61,3.08c-.89.52-1.61,0-1.61-1.22a3.86,3.86,0,0,1,1.61-3.08C273.22,300.24,273.94,300.78,273.94,302Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "272.33px 302.926px"
    },
    id: "el46pqr3escil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,252a.27.27,0,0,1-.25-.15.28.28,0,0,1,.1-.4l45.62-26.34a.31.31,0,0,1,.41.11.29.29,0,0,1-.11.4L334.1,251.93A.28.28,0,0,1,334,252Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "356.812px 238.537px"
    },
    id: "elmlbcp8ienip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,254.75a.3.3,0,0,1-.15-.56l45.62-26.33a.3.3,0,1,1,.3.51L334.1,254.71A.42.42,0,0,1,334,254.75Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "356.831px 241.27px"
    },
    id: "ell5e0kt4fkyn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,257.52a.29.29,0,0,1-.25-.14.29.29,0,0,1,.1-.41l45.62-26.34a.3.3,0,0,1,.3.52L334.1,257.48A.28.28,0,0,1,334,257.52Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "356.812px 244.055px"
    },
    id: "elv41kl0uf8tp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,260.3a.27.27,0,0,1-.25-.15.28.28,0,0,1,.1-.4l45.62-26.34a.31.31,0,0,1,.41.11.29.29,0,0,1-.11.4L334.1,260.26A.28.28,0,0,1,334,260.3Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "356.812px 246.837px"
    },
    id: "el27gy0nupjmt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,263.08a.29.29,0,0,1-.25-.15.28.28,0,0,1,.1-.4l45.62-26.34a.3.3,0,1,1,.3.51L334.1,263A.42.42,0,0,1,334,263.08Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "356.833px 249.6px"
    },
    id: "elf1788dikwmq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,265.85a.29.29,0,0,1-.25-.14.29.29,0,0,1,.1-.41l21.65-12.49a.29.29,0,0,1,.4.1.3.3,0,0,1-.11.41L334.1,265.81A.28.28,0,0,1,334,265.85Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "344.822px 259.309px"
    },
    id: "el4t8vhtqgibu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,272.25a.27.27,0,0,1-.25-.15.28.28,0,0,1,.1-.4l45.62-26.34a.3.3,0,1,1,.3.51L334.1,272.21A.28.28,0,0,1,334,272.25Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "356.833px 258.77px"
    },
    id: "ell1f5bdxix0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,275a.3.3,0,0,1-.15-.56l45.62-26.33a.29.29,0,0,1,.41.1.3.3,0,0,1-.11.41L334.1,275A.42.42,0,0,1,334,275Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "356.81px 261.533px"
    },
    id: "elioeiiea3dn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,277.8a.27.27,0,0,1-.25-.15.28.28,0,0,1,.1-.4l45.62-26.34a.31.31,0,0,1,.41.11.29.29,0,0,1-.11.4L334.1,277.76A.28.28,0,0,1,334,277.8Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "356.812px 264.337px"
    },
    id: "elvmgo41wk7sd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,280.58a.27.27,0,0,1-.25-.15.28.28,0,0,1,.1-.4l21.65-12.5a.29.29,0,1,1,.29.51l-21.64,12.5A.28.28,0,0,1,334,280.58Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "344.821px 274.036px"
    },
    id: "elt2emalxodd",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "412.922px 289.432px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "412.922px 289.432px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.92,231.91c5.5-.3,9.45,2.67,10.24,7.89.65,4.26-.15,22.12-.15,22.12,7.5,6.8,13.54,10.3,16.15,11.41,3.26,1.38,10.75,11.54,10.52,13.45s-3.41-2-5.46-4-6.76-1.72-11.18-3.84-18.32-10.12-20.23-12.77S394.92,231.91,394.92,231.91Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "412.837px 259.59px"
    },
    id: "eln3wuxs35rke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,231.73s4.5-.71,6.84.37,5.09,3.72,5.48,6.12.68,4.1.57,12c-.06,4.66-.24,7.23-.24,7.23-7.08,2.22-10.92.72-14.39-.34Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "398.587px 245.049px"
    },
    id: "elzc6xwwslcx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "417.406px 289.432px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.05,342.17s2.52,7.77,4.53,11.4a56.16,56.16,0,0,0,7.13,10.35c.64.7,2.08,2,2.6,2.59a1.12,1.12,0,0,1-.09,1.73c-1.25,1.24-6.63,1.62-9.68-.59s-6.1-6.45-7.93-8.24L444.2,357a2.47,2.47,0,0,1-.65-2.31c.06-.24.13-.52.2-.84.38-1.75-2-8.84-2-8.84Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "453.213px 355.705px"
    },
    id: "elm0c54umetr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.73,266.64c-1.05,5.87-1.37,9.19.69,15.11s6.88,15.35,15.16,20c6.86,3.84,16.47,8.49,18.49,9.39,1.57.7,1.84,3.47,3,7.74,1.33,4.71,2.48,6.84,6.8,14.76,4.8,8.78,7,13.12,7,13.12,2.25-1.73,7.71-3.46,9.82-3.59,0,0-9.84-36.71-11.65-41.74S424.17,289,418.54,285.75s-8.76-5.26-15.18-9.61Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "419.797px 306.7px"
    },
    id: "el3aiuc4t1xjh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.54,285.75c-5.62-3.24-8.76-5.26-15.18-9.61l-9.16-6.39L389,271.39a22.39,22.39,0,0,0,1.39,10.36c2.07,5.93,6.88,15.35,15.16,20,6.86,3.84,16.47,8.49,18.49,9.39,1.57.7,1.84,3.47,3,7.74a39,39,0,0,0,1.22,3.73c-1.22-3.74-1.16-10.35-1.86-12.46s-7.28-5.81-7.28-5.81l-4.41-4.76,13.75-7.8C424.82,289.33,421,287.15,418.54,285.75Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "408.672px 296.18px"
    },
    id: "elek30upp6tct",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.29,358.71a5.6,5.6,0,0,0,.28,1.87c.3.67,2.56,1.5,3.54,2a5.27,5.27,0,0,1,2.72,3,12.66,12.66,0,0,0,5.72,5.36,16.06,16.06,0,0,0,9.54.8c4-.79,4.24-3.15,4.24-3.15s.17-2.21-.83-2.54S443.29,358.71,443.29,358.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "456.315px 365.417px"
    },
    id: "el9og46cxocre",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.11,350.67a.58.58,0,0,0-.27.32c-.06.17.07.45.11.63a11.37,11.37,0,0,1,.26,3.13,9,9,0,0,0,.08,4c1.91,2.33,4.41,2.12,6.06,4.31s4.08,6.16,9.31,7.09,9.16-.8,10.1-2.3,0-2.89-3.35-4.63c-3.59-1.84-8.37-7.46-8.37-7.46a23.49,23.49,0,0,1-1.81-2.51,4.43,4.43,0,0,1-.72-1.63,6,6,0,0,1-.11-1.84c0-.37.09-.8-.18-1.05a1.07,1.07,0,0,0-.93-.14,16.37,16.37,0,0,0-3.56,1,3.51,3.51,0,0,0-2.4,2.14c-.14.51-.11,1.05-.21,1.58a.93.93,0,0,1-.49.75c-.41.14-.81-.26-1-.67a3.45,3.45,0,0,0-.49-1.2c-.49-.51-1.36-.28-1.69-.91l-.14-.61A.43.43,0,0,0,443.11,350.67Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "455.965px 359.476px"
    },
    id: "elg33fccwl6z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmbwg7teoyi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.11,350.67a.58.58,0,0,0-.27.32c-.06.17.07.45.11.63a11.37,11.37,0,0,1,.26,3.13,9,9,0,0,0,.08,4c1.91,2.33,4.41,2.12,6.06,4.31s4.08,6.16,9.31,7.09,9.16-.8,10.1-2.3,0-2.89-3.35-4.63c-3.59-1.84-8.37-7.46-8.37-7.46a23.49,23.49,0,0,1-1.81-2.51,4.43,4.43,0,0,1-.72-1.63,6,6,0,0,1-.11-1.84c0-.37.09-.8-.18-1.05a1.07,1.07,0,0,0-.93-.14,16.37,16.37,0,0,0-3.56,1,3.51,3.51,0,0,0-2.4,2.14c-.14.51-.11,1.05-.21,1.58a.93.93,0,0,1-.49.75c-.41.14-.81-.26-1-.67a3.45,3.45,0,0,0-.49-1.2c-.49-.51-1.36-.28-1.69-.91l-.14-.61A.43.43,0,0,0,443.11,350.67Z",
    style: {
      opacity: 0.5,
      transformOrigin: "455.965px 359.476px"
    },
    className: "animable",
    id: "elu60mlciwcvk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M455.26,368.93A6.62,6.62,0,0,1,459,363.2c3.89-2.09,6.31-.84,7.53,0,1.45,1,3.54,3.12,2.33,4.71s-3.45,2.56-7.46,2.68A9.53,9.53,0,0,1,455.26,368.93Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "462.241px 366.336px"
    },
    id: "elihcffw07boo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.63,356.85a.47.47,0,0,0,.36-.2c.43-.63,3.25-3,6-2.29.13-.33-.11-.65-.68-1a8.14,8.14,0,0,0-6.11,2.8.43.43,0,0,0,.13.6A.54.54,0,0,0,449.63,356.85Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "452.577px 355.105px"
    },
    id: "el71q7pvrxxhh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.64,356.4a1.35,1.35,0,0,0-.8-.94,8.22,8.22,0,0,0-5.74,2.81.42.42,0,0,0,.12.6.41.41,0,0,0,.28.07.42.42,0,0,0,.35-.19C452.27,358.14,455,355.88,457.64,356.4Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "454.331px 357.201px"
    },
    id: "el4xxmlsxwour",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.07,360.8a2.49,2.49,0,0,0-1.26-1.14,8.16,8.16,0,0,0-6,2.81.41.41,0,0,0,.13.59.38.38,0,0,0,.27.07.45.45,0,0,0,.36-.19C456,362.28,459.15,359.66,462.07,360.8Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "458.403px 361.396px"
    },
    id: "el8c84a4mob5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.36,361a.46.46,0,0,0,.35-.2c.43-.62,3.19-2.95,5.94-2.31a1.55,1.55,0,0,0-.95-1,8.26,8.26,0,0,0-5.74,2.82.42.42,0,0,0,.13.6A.52.52,0,0,0,453.36,361Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "456.268px 359.245px"
    },
    id: "elvdmlyqs2b3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.72,352.42s1.36,9.31,4.08,12.77c2.46,3.12,4.22,7.1,7.14,10.35.63.71,2.07,2,2.59,2.59a1.12,1.12,0,0,1-.09,1.73c-1.25,1.24-6.62,1.62-9.68-.58s-6.09-6.46-7.92-8.25c-.92-.89-1.78-1.75-2.41-2.38a2.41,2.41,0,0,1-.65-2.31c.06-.24.12-.51.19-.84.39-1.74-2-8.84-2-8.84Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "433.433px 366.641px"
    },
    id: "elavjm9iwjm08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.55,370.48a5.6,5.6,0,0,0,.28,1.87c.3.67,2.56,1.5,3.54,2s1.76,1,2.73,3a12.65,12.65,0,0,0,5.71,5.37,16.07,16.07,0,0,0,9.54.79c4-.79,4.24-3.14,4.24-3.14s.17-2.22-.83-2.55S423.55,370.48,423.55,370.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "436.575px 377.188px"
    },
    id: "elc4zt0dslibi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.37,362.45a.52.52,0,0,0-.27.32c-.06.17.07.44.11.62a11.4,11.4,0,0,1,.26,3.13,9,9,0,0,0,.08,4c1.91,2.33,4.41,2.12,6.06,4.31s4.08,6.16,9.31,7.09,9.16-.8,10.1-2.3,0-2.88-3.35-4.62c-3.59-1.85-8.37-7.47-8.37-7.47a23.49,23.49,0,0,1-1.81-2.51,4.43,4.43,0,0,1-.72-1.63,6,6,0,0,1-.11-1.84c0-.37.09-.8-.18-1.05a1.1,1.1,0,0,0-.93-.14,16.37,16.37,0,0,0-3.56,1,3.54,3.54,0,0,0-2.4,2.14c-.14.51-.11,1.06-.21,1.58a.93.93,0,0,1-.48.75c-.42.15-.82-.26-1-.67a3.45,3.45,0,0,0-.49-1.2c-.49-.51-1.36-.28-1.69-.91l-.14-.61A.38.38,0,0,0,423.37,362.45Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "436.225px 371.248px"
    },
    id: "el95993lgk17p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elno0rdf2xfab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.37,362.45a.52.52,0,0,0-.27.32c-.06.17.07.44.11.62a11.4,11.4,0,0,1,.26,3.13,9,9,0,0,0,.08,4c1.91,2.33,4.41,2.12,6.06,4.31s4.08,6.16,9.31,7.09,9.16-.8,10.1-2.3,0-2.88-3.35-4.62c-3.59-1.85-8.37-7.47-8.37-7.47a23.49,23.49,0,0,1-1.81-2.51,4.43,4.43,0,0,1-.72-1.63,6,6,0,0,1-.11-1.84c0-.37.09-.8-.18-1.05a1.1,1.1,0,0,0-.93-.14,16.37,16.37,0,0,0-3.56,1,3.54,3.54,0,0,0-2.4,2.14c-.14.51-.11,1.06-.21,1.58a.93.93,0,0,1-.48.75c-.42.15-.82-.26-1-.67a3.45,3.45,0,0,0-.49-1.2c-.49-.51-1.36-.28-1.69-.91l-.14-.61A.38.38,0,0,0,423.37,362.45Z",
    style: {
      opacity: 0.5,
      transformOrigin: "436.225px 371.248px"
    },
    className: "animable",
    id: "elvlo8fjin2gd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.52,380.71a6.64,6.64,0,0,1,3.75-5.74c3.9-2.09,6.31-.84,7.53,0,1.45,1,3.54,3.12,2.33,4.71s-3.45,2.56-7.46,2.68A9.56,9.56,0,0,1,435.52,380.71Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "442.506px 378.107px"
    },
    id: "eljajxxaa6vj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.9,368.62a.49.49,0,0,0,.35-.19c.43-.64,3.25-3,6-2.3.13-.32-.11-.65-.68-1a8.14,8.14,0,0,0-6.11,2.8.43.43,0,0,0,.13.6A.55.55,0,0,0,429.9,368.62Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "432.837px 366.875px"
    },
    id: "el6d0mkjsyeem",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.9,368.18a1.35,1.35,0,0,0-.8-.95,8.26,8.26,0,0,0-5.74,2.82.41.41,0,0,0,.12.59.41.41,0,0,0,.28.07.42.42,0,0,0,.35-.19C432.53,369.91,435.21,367.65,437.9,368.18Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "434.591px 368.971px"
    },
    id: "elpta0yul35dr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.33,372.57a2.49,2.49,0,0,0-1.26-1.14,8.19,8.19,0,0,0-6,2.81.42.42,0,0,0,.13.6.52.52,0,0,0,.27.07.49.49,0,0,0,.36-.2C436.3,374.05,439.41,371.43,442.33,372.57Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "438.663px 373.17px"
    },
    id: "el0pxmfle6g86",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.62,372.81a.45.45,0,0,0,.35-.19c.43-.63,3.19-3,5.94-2.32a1.51,1.51,0,0,0-1-1,8.22,8.22,0,0,0-5.74,2.81.42.42,0,0,0,.13.6A.44.44,0,0,0,433.62,372.81Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "436.503px 371.056px"
    },
    id: "el4k6zx7h1im",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.1,278.05c-.68,5.81-2,10,0,15.9s8.88,10.47,17.16,15.11c6.86,3.83,16.56,8.92,18.49,10,2.55,1.44,2.64,3.72,3.3,7.54.86,5,2,9.6,6.2,17.78,4.36,8.48,7,13.93,7,13.93a37.19,37.19,0,0,1,10.34-3.79s-8.59-38.42-10.4-43.45-21.12-21-21.12-21,2.45-3.74,3.18-10.83Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "399.815px 318.18px"
    },
    id: "elsvu6jj83m1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.79,298c3.19.26,4.7-4.8,4.7-4.8l-7.84-6-14.71-7.18L369,279A58.41,58.41,0,0,0,368,288c4.11,1.2,11.85,3.56,13.41,4.67C383.59,294.23,387.6,297.77,390.79,298Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "381.745px 288.505px"
    },
    id: "elj6cql7byujl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.79,244.32c.52-5.46-2.33-12.26-10.76-12.6l-12.22.16a29.67,29.67,0,0,0-12.22,3.26l-3,20.62a93.59,93.59,0,0,0,2.85,28.1c7.79,4.94,27,2.2,37.68-5.88C401.78,268.64,403.23,250.33,403.79,244.32Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "385.796px 259.024px"
    },
    id: "el6kno0go8yuh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elazuk7ec6o6a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.79,244.32c.52-5.46-2.33-12.26-10.76-12.6l-12.22.16a29.67,29.67,0,0,0-12.22,3.26l-3,20.62a93.59,93.59,0,0,0,2.85,28.1c7.79,4.94,27,2.2,37.68-5.88C401.78,268.64,403.23,250.33,403.79,244.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "385.796px 259.024px"
    },
    className: "animable",
    id: "elc52qd0lj0mv"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,210.17s0-.08,0-.12a2.74,2.74,0,0,0-.64-2.2c-.48-.38-1.07-.6-1.56-1l-2.54-2.2a3.88,3.88,0,0,0-3.3.86c-1.5,1.3-1.09,5.77.27,10.23,0,0,1,8,1.6,9.34a3.55,3.55,0,0,0,1.92,1.83c.15-2.42,0-5,.79-7.28C383.69,216.45,385.86,213.58,386.05,210.17Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "381.569px 215.741px"
    },
    id: "ell4a3bdla8bi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.36,216.41c-.66.32-1.47-1-2.18-1.85s-3.16-2.2-4.65.37.67,6.27,2.55,7.21a2.48,2.48,0,0,0,3.24-1c-.25,3.94-.66,9.39-.85,11,4,6.75,16,6.79,12.29.61l.19-2.66a24.13,24.13,0,0,0,4.64.53,5.73,5.73,0,0,0,5.32-4.18c1.6-4.31,2.36-7.84,2-16.6-.37-9.61-11.43-10.62-17.71-7.35S382.36,216.41,382.36,216.41Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "390.016px 219.051px"
    },
    id: "elax99jvxk1a5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,201.27a4,4,0,0,0-2.64-.57,3.26,3.26,0,0,0-1.62-3.44,3.77,3.77,0,0,0-4.15.15,1.93,1.93,0,0,0-1.38-2.31,5.19,5.19,0,0,0-3,.2c-1.44.39-2.87.85-4.32,1.19-2.57.59-5.26.8-7.64,1.93a4.67,4.67,0,0,0-1.53,1.06,3.92,3.92,0,0,0-.87,2.41,5,5,0,0,0,0,.86,2.1,2.1,0,0,0-3.52.2l3.56,2.3c-.17.75-.33,1.49-.48,2.24-.4,2-1,4.27-.75,6.31a1.54,1.54,0,0,0,.18.69,3,3,0,0,1,.44.71l.54,1.29c.26.65.85,1.72,1.71,1.42a2.18,2.18,0,0,0,1.07-1.09,11.84,11.84,0,0,0,1.35-7.12,5.59,5.59,0,0,0,5.16-2.35,15,15,0,0,0,10.21,2.22,12.75,12.75,0,0,0,5.53-1.89C408,206.42,411,203.18,408.2,201.27Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "393.435px 206.464px"
    },
    id: "el7309qftbceq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,230.14s-5.56-1.39-7.46-2.61a7.45,7.45,0,0,1-2.53-3.36,8,8,0,0,0,1.16,3.61c1.29,2,8.73,3.95,8.73,3.95Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "388.005px 227.95px"
    },
    id: "eliisqob1pmv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.1,217.45a1.15,1.15,0,1,1-1-1.29A1.17,1.17,0,0,1,394.1,217.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "392.959px 217.301px"
    },
    id: "elat3bcet7tu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.05,212.31l-2.61,1a1.47,1.47,0,0,1,.85-1.84A1.36,1.36,0,0,1,392.05,212.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "390.706px 212.348px"
    },
    id: "el34sefplq1k6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.62,224l3.15,1.49a1.71,1.71,0,0,1-2.29.89A1.83,1.83,0,0,1,392.62,224Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "394.117px 225.268px"
    },
    id: "eltb9lf6dovn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.42,213.27l-2.33-1.42a1.31,1.31,0,0,1,1.83-.45A1.39,1.39,0,0,1,403.42,213.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "402.343px 212.234px"
    },
    id: "elyzjpyrxrpo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.92,217.72a1.17,1.17,0,0,1-1.24,1.09,1.19,1.19,0,0,1-1.05-1.29,1.15,1.15,0,1,1,2.29.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "401.777px 217.622px"
    },
    id: "elh8ig31wte1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.69,214.48l-.5-.08a14.4,14.4,0,0,0-5,0c-1.63.44-2.22,1-3.11,1s-1.5-.6-3.17-1.14a16.29,16.29,0,0,0-5.32-.32l-.54,0a.9.9,0,0,0-.65.88,1.93,1.93,0,0,0,.44,1.06,1.41,1.41,0,0,1,.15.43,18.09,18.09,0,0,0,.46,2.91,3.41,3.41,0,0,0,.62,1.06,2.34,2.34,0,0,0,.32.31l.2.15a2.87,2.87,0,0,0,.58.3l.1,0,.15,0,.17.05a3.69,3.69,0,0,0,.52.1l.22,0,.29,0a3.78,3.78,0,0,0,3.79-2c.61-1.08.57-2.64,1.58-2.6h.19c.73.2.55,1.62.95,2.65a4.28,4.28,0,0,0,.64,1.14l.16.18.09.08.09.08.08.07.09.07.07.05a.1.1,0,0,1,0,0,3.9,3.9,0,0,0,.85.38l.08,0a4.69,4.69,0,0,0,1.06.14,3.23,3.23,0,0,0,3.23-1.92,19.78,19.78,0,0,0,.81-2.87,1,1,0,0,1,.21-.38,2.1,2.1,0,0,0,.54-1.05A.87.87,0,0,0,406.69,214.48Zm-10.78,3.79a3.34,3.34,0,0,1-.86,1.5h0a3.17,3.17,0,0,1-2.45.81,2.56,2.56,0,0,1-2.22-1.18l-.07-.11-.06-.11-.05-.11,0-.09,0-.08a.14.14,0,0,1,0-.06.76.76,0,0,1,0-.11h0c0-.12-.07-.22-.1-.33h0a1.29,1.29,0,0,1,0-.19c0-.11,0-.22-.06-.31v-.12c-.12-.77-.22-2.28.18-2.61a4.33,4.33,0,0,1,3-.44l.17,0c.25,0,.5.09.74.15l.28.08c.25.08.49.17.71.26l.22.11a1.67,1.67,0,0,1,.23.12l.05,0,.08,0a1.35,1.35,0,0,1,.46.41A3.48,3.48,0,0,1,395.91,218.27Zm9.53-.05a3.43,3.43,0,0,1-1.7,2.4,2.84,2.84,0,0,1-1.23.24,2.53,2.53,0,0,1-2.36-1.22h0l0-.07a.59.59,0,0,1,0-.08l0,0,0-.12-.06-.14a.64.64,0,0,0,0-.07v0a.14.14,0,0,1,0-.06l0-.05a5.34,5.34,0,0,1-.12-.57,3.75,3.75,0,0,1,.21-2.31,4.5,4.5,0,0,1,2.74-1.06,6.75,6.75,0,0,1,.75,0H404l.12,0a.64.64,0,0,1,.2,0,2.12,2.12,0,0,1,.38.08l.08,0h0l.05,0,.09,0,.11,0,.17.08,0,0a1.39,1.39,0,0,1,.39.27C406,216,405.65,217.45,405.44,218.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "397.765px 217.647px"
    },
    id: "elhqvtgzjxfwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.73 216.75 397.3 223.32 401.44 222.77 397.73 216.75",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "399.37px 220.035px"
    },
    id: "el46tpooj1u1z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.05,214l-9.3.17s.55.29,1.14,1.83h8.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.4px 215px"
    },
    id: "el2nc6naz10xo",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M381.54,299.93v.76a2.12,2.12,0,0,0,1.06,1.84l20.26,11.67a2.13,2.13,0,0,0,1.06.28,2.08,2.08,0,0,0,1.06-.28l37.19-21.46a2.1,2.1,0,0,0,1.06-1.84v-.51l-39.31,22.68Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "412.385px 302.435px"
    },
    id: "el6d6bmapb02r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5gxevigox0h"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "412.385px 302.435px"
    },
    className: "animable",
    id: "elquinzrzr0ze"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.54,299.93v.76a2.12,2.12,0,0,0,1.06,1.84l20.26,11.67a2.13,2.13,0,0,0,1.06.28,2.08,2.08,0,0,0,1.06-.28l37.19-21.46a2.1,2.1,0,0,0,1.06-1.84v-.51l-39.31,22.68Z",
    id: "elsjjdj6koogs",
    className: "animable",
    style: {
      transformOrigin: "412.385px 302.435px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el29pl1ahyhtd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "423.575px 302.435px"
    },
    className: "animable",
    id: "el2nya92cqac4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.92,313.07v1.41a2.08,2.08,0,0,0,1.06-.28l37.19-21.46a2.1,2.1,0,0,0,1.06-1.84v-.51Z",
    id: "elwljgg0wjzg",
    className: "animable",
    style: {
      transformOrigin: "423.575px 302.435px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M443.23,290.39l-22-12.74a1.29,1.29,0,0,0-1.26,0l-38.25,22.07a.28.28,0,0,0,0,.49l22.24,12.86Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "412.403px 295.278px"
    },
    id: "el9awavco4ov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1iujidf0i2j"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "412.403px 295.278px"
    },
    className: "animable",
    id: "el5z51kxhfddc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.23,290.39l-22-12.74a1.29,1.29,0,0,0-1.26,0l-38.25,22.07a.28.28,0,0,0,0,.49l22.24,12.86Z",
    id: "elhghwxmmcen6",
    className: "animable",
    style: {
      transformOrigin: "412.403px 295.278px"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "403.72 311.19 391.83 304.33 426.61 284.27 438.56 291.1 403.72 311.19",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "415.195px 297.73px"
    },
    id: "elw0x5knuhdhl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.88 292.12 398.1 292.24 403.93 295.61 414.29 289.63 414.51 289.51 408.46 286.01 397.88 292.12",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "406.195px 290.81px"
    },
    id: "el7urrnzlq1zk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.1 292.24 403.93 295.61 414.29 289.63 408.46 286.26 398.1 292.24",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "406.195px 290.935px"
    },
    id: "ela80bngmqw7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.52,313.38a2.51,2.51,0,0,0,2.17-.17l37-21.36a2.53,2.53,0,0,0,1.23-1.76L449,265.93a2.93,2.93,0,0,0,0-.41,2.53,2.53,0,0,0-.74-1.79l-38.48,22.2a1.85,1.85,0,0,0-.9,1.3Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "426.764px 288.64px"
    },
    id: "el04l47ccx9gv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsv5vh7v09xr"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "426.764px 288.64px"
    },
    className: "animable",
    id: "eln1juwf2o01r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.52,313.38a2.51,2.51,0,0,0,2.17-.17l37-21.36a2.53,2.53,0,0,0,1.23-1.76L449,265.93a2.93,2.93,0,0,0,0-.41,2.53,2.53,0,0,0-.74-1.79l-38.48,22.2a1.85,1.85,0,0,0-.9,1.3Z",
    id: "eljovs8u8r94",
    className: "animable",
    style: {
      transformOrigin: "426.764px 288.64px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M403.92,313.07l.26.14a2.16,2.16,0,0,0,.34.17l4.39-26.15a1.85,1.85,0,0,1,.9-1.3l38.48-22.2a2.53,2.53,0,0,0-.52-.39l-38.55,22.24a1.85,1.85,0,0,0-.9,1.3Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "426.105px 288.36px"
    },
    id: "ell2yxrw8too",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzcophydaeoj"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "426.105px 288.36px"
    },
    className: "animable",
    id: "elrrtpxlrx08o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.92,313.07l.26.14a2.16,2.16,0,0,0,.34.17l4.39-26.15a1.85,1.85,0,0,1,.9-1.3l38.48-22.2a2.53,2.53,0,0,0-.52-.39l-38.55,22.24a1.85,1.85,0,0,0-.9,1.3Z",
    id: "el6lbucznxyel",
    className: "animable",
    style: {
      transformOrigin: "426.105px 288.36px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M425.38,291.08a8.15,8.15,0,0,1,3.73-4.8c1.79-1,3-.56,2.75,1.06a8.21,8.21,0,0,1-3.74,4.8C426.33,293.17,425.1,292.7,425.38,291.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "428.616px 289.217px"
    },
    id: "elw9wbtem0uar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39,291.08c-4.38-2.22-20.49-8-24.6-11.52-3.09-2.61-2.31-5.8-1.84-8.84.45-2.84,5-23.37,7.6-28.77,2.27-4.74,3.85-5.84,9.05-7,3.59,4.18,3.77,16.62.24,21.16l-4,16.16a122.86,122.86,0,0,0,11.3,7.83c3.52,2.16,6.28,4.66,9.32,5.78,2.05.75,5.85,2.64,6.52,3.55a66,66,0,0,1,4,7.48c.52,1.4,1.85,4.28-.87,4.6-2.48.3-4.19-1.06-5.85-2.72a25.06,25.06,0,0,1-2.14-2.58,9.49,9.49,0,0,1-5.29-2.12C385.55,293,383.39,291.08,383.39,291.08Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "379.135px 268.251px"
    },
    id: "elofl8lo6t3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,233.64a8.64,8.64,0,0,0-6.94,4.15c-1.93,2.71-6.7,20.65-6.7,20.65s1.14,3,7.34,4.44,6.91.28,6.91.28l5.27-16S377.62,236.36,372,233.64Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "368.12px 248.621px"
    },
    id: "elfk9rsm3jaf",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    className: "animable",
    style: {
      transformOrigin: "393.995px 155.323px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    className: "animable",
    style: {
      transformOrigin: "393.995px 155.323px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.4,181.44l-2.79-5.24,2.25-6.49v-4l-6.87,4v4l2.95,5.12a.43.43,0,0,0,.2.18h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "391.695px 173.575px"
    },
    id: "elur48xbwaw7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.82,134.2a4.55,4.55,0,0,0-2.06-3.57l-1.68-1a4.53,4.53,0,0,0-4.12,0l-25.73,14.88a4.56,4.56,0,0,0-2.06,3.57v28.31a4.53,4.53,0,0,0,2.06,3.57l1.67,1a4.55,4.55,0,0,0,4.13,0l8.27-4.78,2.95,5.11a.44.44,0,0,0,.8-.08l3.11-9,10.6-6.14a4.56,4.56,0,0,0,2.06-3.57Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "393.995px 155.323px"
    },
    id: "elw5cc6m0ejqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.17,176.42a4.53,4.53,0,0,0,2.06,3.57l1.67,1a4.58,4.58,0,0,0,3.77.17c-1,.37-1.71-.18-1.71-1.36V151.46a4.25,4.25,0,0,1,.61-2l-5.8-3.35a4.27,4.27,0,0,0-.6,2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "379.92px 163.798px"
    },
    id: "elwncpewirw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.75,133.61c-.24-.87-1-1.15-2-.6L384,147.89a4.23,4.23,0,0,0-1.45,1.54l-5.79-3.34a4,4,0,0,1,1.45-1.54L404,129.66a4.62,4.62,0,0,1,4.13,0l1.68,1A4.55,4.55,0,0,1,411.75,133.61Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "394.255px 139.301px"
    },
    id: "elb7w78itwbf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-2",
    className: "animable",
    style: {
      transformOrigin: "396.814px 157.88px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.88,162.89a1.44,1.44,0,0,1,.1-.58,3.41,3.41,0,0,1,.3-.55l5.6-9a.53.53,0,0,1,.09-.11l.06,0a.15.15,0,0,1,.21,0,.34.34,0,0,1,.08.27v3.49a1.49,1.49,0,0,1-.16.73,4.42,4.42,0,0,1-.28.48l-2.89,4.4,2.89,1.32a.91.91,0,0,1,.28.14c.11.06.16.24.16.53v2.48a.8.8,0,0,1-.08.37.6.6,0,0,1-.21.25l-.06,0h-.09l-5.6-2.58a.75.75,0,0,1-.3-.2.78.78,0,0,1-.1-.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "388.1px 159.859px"
    },
    id: "elmln5bwr2me",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.94,148.61a3.28,3.28,0,0,1,.21-.57,1.09,1.09,0,0,1,.41-.44l1.87-1.08a.17.17,0,0,1,.22,0,.38.38,0,0,1,.09.28.88.88,0,0,1,0,.21L396,167.18a3.34,3.34,0,0,1-.2.54,1,1,0,0,1-.42.46l-1.83,1.06a.17.17,0,0,1-.22,0,.38.38,0,0,1-.09-.28.88.88,0,0,1,0-.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "396.99px 157.88px"
    },
    id: "elhghylycdhj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.75,151.87a1.43,1.43,0,0,1-.11.58,3.41,3.41,0,0,1-.3.55l-5.6,9.05a.3.3,0,0,1-.09.1l-.06,0a.15.15,0,0,1-.21,0,.38.38,0,0,1-.08-.27v-3.49a1.42,1.42,0,0,1,.16-.72c.11-.19.2-.34.28-.46l2.69-3.93-2.69-1a1,1,0,0,1-.28-.14c-.11-.08-.16-.26-.16-.55v-3.25a1,1,0,0,1,.08-.37.6.6,0,0,1,.21-.25l.06,0a.14.14,0,0,1,.09,0l5.6,2.58a.75.75,0,0,1,.3.2.77.77,0,0,1,.11.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "405.526px 154.953px"
    },
    id: "eltv85w9wivx",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.2f449c488518687d2cff68756cf29d45.svg";
export { ForwardRef as ReactComponent };